/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Recupera la contraseña para un usuario.
     * @param rUC (optional) RUC de la empresa a la que pertenece el usuario.
     * @param usernameOrEmail (optional) Nombre de usuario o email utilizado.
     * @return Success
     */
    recoverPassword(rUC: string | null | undefined, usernameOrEmail: string | null | undefined): Observable<RecoverPasswordStatusCode> {
        let url_ = this.baseUrl + "/api/services/app/Account/RecoverPassword?";
        if (rUC !== undefined)
            url_ += "RUC=" + encodeURIComponent("" + rUC) + "&";
        if (usernameOrEmail !== undefined)
            url_ += "usernameOrEmail=" + encodeURIComponent("" + usernameOrEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverPassword(<any>response_);
                } catch (e) {
                    return <Observable<RecoverPasswordStatusCode>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecoverPasswordStatusCode>><any>_observableThrow(response_);
        }));
    }

    protected processRecoverPassword(response: HttpResponseBase): Observable<RecoverPasswordStatusCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecoverPasswordStatusCode>(<any>null);
    }
}

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las actividades económicas disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una actividad económica, dado su
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(<any>null);
    }

    /**
     * Crea una nueva actividad económica.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: ActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(<any>null);
    }

    /**
     * Actualiza los datos de una actividad económica
    dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: ActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(<any>null);
    }

    /**
     * Elimina una actividad económica dado un
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene todas las entradas de Auditoría de acuerdo a los parámetros recibidos.
     * @param hostSide (optional) Bandera indicando si se quiere filtrar por
    los resultados de las empresas o del host.
     * @param keyword (optional) Palabra de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(hostSide: boolean | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AuditLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAll?";
        if (hostSide !== undefined)
            url_ += "HostSide=" + encodeURIComponent("" + hostSide) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AuditLogDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuditLogDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AuditLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuditLogDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una entrada de auditoría, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AuditLogDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AuditLogDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuditLogDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AuditLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuditLogDto>(<any>null);
    }
}

@Injectable()
export class BranchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las sucursales disponibles.
     * @param tenantRUC (optional) Filtro de RUC de la empresa.
     * @return Success
     */
    getAllBranches(tenantRUC: string | null | undefined): Observable<BranchDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Branch/GetAllBranches?";
        if (tenantRUC !== undefined)
            url_ += "tenantRUC=" + encodeURIComponent("" + tenantRUC) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranches(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranches(response: HttpResponseBase): Observable<BranchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BranchDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto[]>(<any>null);
    }

    /**
     * Obtiene las sucursales disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param parentRUC (optional) Filtro de RUC de la empresa.
     * @param viewAllBranches (optional) Ver todas las sucursales, incluyendo las no vinculadas.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(parentRUC: string | null | undefined, viewAllBranches: boolean | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BranchDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/GetAll?";
        if (parentRUC !== undefined)
            url_ += "ParentRUC=" + encodeURIComponent("" + parentRUC) + "&";
        if (viewAllBranches === null)
            throw new Error("The parameter 'viewAllBranches' cannot be null.");
        else if (viewAllBranches !== undefined)
            url_ += "ViewAllBranches=" + encodeURIComponent("" + viewAllBranches) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<BranchDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BranchDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una sucursal dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * Crea una nueva sucursal.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: BranchDto | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * Actualiza los datos de una sucursal dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: BranchDto | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * Elimina una sucursal dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CardTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las tarjetas de crédito disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CardTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CardType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CardTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CardTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una tarjeta de crédito dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CardTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CardType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CardTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CardTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTypeDto>(<any>null);
    }

    /**
     * Crea una nueva tarjeta de crédito.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: CardTypeDto | undefined): Observable<CardTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CardType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CardTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CardTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de una tarjeta de crédito dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: CardTypeDto | undefined): Observable<CardTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CardType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CardTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CardTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTypeDto>(<any>null);
    }

    /**
     * Elimina una tarjeta de crédito dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las ciudades disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CityDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una ciudad dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/app/City/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * Obtiene las ciudades disponibles para el distrito (identificador
    en SIFEN) dado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListByParentCode(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetListByParentCode?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListByParentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByParentCode(<any>response_);
                } catch (e) {
                    return <Observable<CityDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetListByParentCode(response: HttpResponseBase): Observable<CityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una ciudad dado su identificador en SIFEN.
     * @param code (optional) Código SIFEN que identifica la ciudad.
     * @return Success
     */
    getByCode(code: number | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * Crea una nueva ciudad.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: CityDto | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/app/City/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * Actualiza los datos de una ciudad dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: CityDto | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/app/City/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * Elimina una ciudad dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/City/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los paises disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CountryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CountryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CountryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un país dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }

    /**
     * Obtiene un país dado su identificador en SIFEN.
     * @param code (optional) Código SIFEN que identifica al país.
     * @return Success
     */
    getByCode(code: string | null | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }

    /**
     * Crea un nuevo país.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: CountryDto | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }

    /**
     * Actualiza los datos de un país dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: CountryDto | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }

    /**
     * Elimina un país dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Country/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CreditNoteReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los motivos de emisión de notas de crédito disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CreditNoteReasonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditNoteReason/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CreditNoteReasonDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreditNoteReasonDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CreditNoteReasonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditNoteReasonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteReasonDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un motivo de emisión de nota de crédito, dado su
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CreditNoteReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditNoteReason/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CreditNoteReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreditNoteReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CreditNoteReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditNoteReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteReasonDto>(<any>null);
    }

    /**
     * Crea un nuevo motivo de emisión de nota de crédito.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: CreditNoteReasonDto | undefined): Observable<CreditNoteReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditNoteReason/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CreditNoteReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreditNoteReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreditNoteReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditNoteReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteReasonDto>(<any>null);
    }

    /**
     * Actualiza los datos de un motivo de emisión de nota de crédito
    dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: CreditNoteReasonDto | undefined): Observable<CreditNoteReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditNoteReason/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CreditNoteReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreditNoteReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CreditNoteReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditNoteReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteReasonDto>(<any>null);
    }

    /**
     * Elimina un motivo de emisión de nota de crédito dado un
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CreditNoteReason/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CurrencyTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las monedas disponibles de acuerdo a
    los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
    Búsqueda en el nombre y código.
     * @param onlyActives (optional) Parametro para filtrar únicamente monedas
    activas.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, onlyActives: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CurrencyTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (onlyActives !== undefined)
            url_ += "OnlyActives=" + encodeURIComponent("" + onlyActives) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CurrencyTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrencyTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurrencyTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una moneda, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CurrencyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CurrencyTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrencyTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurrencyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDto>(<any>null);
    }

    /**
     * Obtiene una moneda dado su identificador en SIFEN.
     * @param code (optional) Código SIFEN que identifica la moneda.
     * @return Success
     */
    getByCode(code: string | null | undefined): Observable<CurrencyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/GetByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<CurrencyTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrencyTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<CurrencyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDto>(<any>null);
    }

    /**
     * Obtiene una moneda en SIFEN según el identificador del producto.
     * @param productId (optional) Identificador del producto.
     * @return Success
     */
    getByProductId(productId: number | undefined): Observable<CurrencyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/GetByProductId?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductId(<any>response_);
                } catch (e) {
                    return <Observable<CurrencyTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrencyTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByProductId(response: HttpResponseBase): Observable<CurrencyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDto>(<any>null);
    }

    /**
     * Crea una nueva moneda.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: CurrencyTypeDto | undefined): Observable<CurrencyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CurrencyTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrencyTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurrencyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de una moneda dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: CurrencyTypeDto | undefined): Observable<CurrencyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CurrencyTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrencyTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurrencyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDto>(<any>null);
    }

    /**
     * Elimina una moneda dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DefaultElectronicDocumentDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los valores por defecto para la creación de un documento electrónico.
     * @return Success
     */
    get(): Observable<DefaultElectronicDocumentDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DefaultElectronicDocumentData/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DefaultElectronicDocumentDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DefaultElectronicDocumentDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DefaultElectronicDocumentDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultElectronicDocumentDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefaultElectronicDocumentDataDto>(<any>null);
    }

    /**
     * Actualiza los valores por defecto para la creación de un documento electrónico.
     * @param body (optional) 
     * @return Success
     */
    update(body: DefaultElectronicDocumentDataDto | undefined): Observable<DefaultElectronicDocumentDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DefaultElectronicDocumentData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DefaultElectronicDocumentDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DefaultElectronicDocumentDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DefaultElectronicDocumentDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultElectronicDocumentDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefaultElectronicDocumentDataDto>(<any>null);
    }

    /**
     * Elimina los valores por defecto para la creación del documento electrónico, reiniciando sus datos.
     * @return Success
     */
    delete(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DefaultElectronicDocumentData/Delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DefaultProductDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los valores por defecto para la creación de un producto.
     * @return Success
     */
    get(): Observable<DefaultProductDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DefaultProductData/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DefaultProductDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DefaultProductDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DefaultProductDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultProductDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefaultProductDataDto>(<any>null);
    }

    /**
     * Actualiza los valores por defecto para la creación de un producto.
     * @param body (optional) 
     * @return Success
     */
    update(body: DefaultProductDataDto | undefined): Observable<DefaultProductDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DefaultProductData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DefaultProductDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DefaultProductDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DefaultProductDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultProductDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefaultProductDataDto>(<any>null);
    }

    /**
     * Elimina los valores por defecto para la creación del producto, reiniciando sus datos.
     * @return Success
     */
    delete(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DefaultProductData/Delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DefaultReceiversDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los valores por defecto para la creación de un cliente.
     * @return Success
     */
    get(): Observable<DefaultReceiversDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DefaultReceiversData/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DefaultReceiversDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DefaultReceiversDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DefaultReceiversDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultReceiversDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefaultReceiversDataDto>(<any>null);
    }

    /**
     * Actualiza los valores por defecto para la creación de un cliente.
     * @param body (optional) 
     * @return Success
     */
    update(body: DefaultReceiversDataDto | undefined): Observable<DefaultReceiversDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DefaultReceiversData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DefaultReceiversDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DefaultReceiversDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DefaultReceiversDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultReceiversDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefaultReceiversDataDto>(<any>null);
    }

    /**
     * Elimina los valores por defecto para la creación del cliente, reiniciando sus datos.
     * @return Success
     */
    delete(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DefaultReceiversData/Delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DepartmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los departamentos disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DepartmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DepartmentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepartmentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DepartmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un departamento dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DepartmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepartmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(<any>null);
    }

    /**
     * Obtiene los departamentos disponibles para el país (identificador
    en SIFEN) dado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListByParentCode(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DepartmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetListByParentCode?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListByParentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByParentCode(<any>response_);
                } catch (e) {
                    return <Observable<DepartmentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepartmentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetListByParentCode(response: HttpResponseBase): Observable<DepartmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un departamento dado su identificador en SIFEN.
     * @param code (optional) Código SIFEN que identifica al departamento.
     * @return Success
     */
    getByCode(code: number | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<DepartmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepartmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(<any>null);
    }

    /**
     * Crea un nuevo departamento.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: DepartmentDto | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DepartmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepartmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(<any>null);
    }

    /**
     * Actualiza los datos de un departamento dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: DepartmentDto | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DepartmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepartmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(<any>null);
    }

    /**
     * Elimina un departamento dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Department/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DistrictServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los distritos disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DistrictDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/District/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DistrictDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un distrito dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDto>(<any>null);
    }

    /**
     * Obtiene los distritos disponibles para el departamento (identificador
    en SIFEN) dado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListByParentCode(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DistrictDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/District/GetListByParentCode?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListByParentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByParentCode(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetListByParentCode(response: HttpResponseBase): Observable<DistrictDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un distrito dado su identificador en SIFEN.
     * @param code (optional) Código SIFEN que identifica al distrito.
     * @return Success
     */
    getByCode(code: number | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDto>(<any>null);
    }

    /**
     * Crea un nuevo distrito.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: DistrictDto | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDto>(<any>null);
    }

    /**
     * Actualiza los datos de un distrito dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: DistrictDto | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDto>(<any>null);
    }

    /**
     * Elimina un distrito dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DocumentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los tipos de documentos disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DocumentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un tipo de documento, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypeDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de documento.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: DocumentTypeDto | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de un tipo de documento dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: DocumentTypeDto | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypeDto>(<any>null);
    }

    /**
     * Elimina un tipo de documento dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ElectronicDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    testWebhook(body: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/TestWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestWebhook(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene los documentos electrónicos emitidos, de acuerdo a los
    parámetros de entrada.
    <param name="input">Filtros y paginado.</param><returns>Listado de documentos electrónicos encontrados.</returns>
     * @param branchesIds (optional) Listado de sucursales para filtrar.
     * @param hasBulk (optional) Bandera indicando si se debe buscar comprobantes
    emitidos dentro de un lote.
     * @param statusSentToSIFEN (optional) Bandera indicando si se debe buscar en estado "Enviado al SIFEN".
     * @param statusApproved (optional) Bandera indicando si se debe buscar en estado "Aprobado".
     * @param statusObserved (optional) Bandera indicando si se debe buscar en estado "Observado".
     * @param statusRejected (optional) Bandera indicando si se debe buscar en estado "Rechazado".
     * @param statusCancelled (optional) Bandera indicando si se debe buscar en estado "Cancelado".
     * @param statusError (optional) Bandera indicando si se debe buscar en estado "Con Errores".
     * @param statusOther (optional) Bandera indicando si se debe buscar en estado "Otro".
     * @param statusProcessed (optional) Bandera indicando si se debe buscar en estado "Procesado".
     * @param electronicDocumentType (optional) Bandera indicando si se debe buscar con el tipo de documento "Factura electrónica".
     * @param selfDocumentType (optional) Bandera indicando si se debe buscar con el tipo de documento "Autofactura electrónica".
     * @param creditNoteType (optional) Bandera indicando si se debe buscar con el tipo de documento "Nota de crédito electrónica".
     * @param debitNoteType (optional) Bandera indicando si se debe buscar con el tipo de documento "Nota de débito electrónica".
     * @param remissionNoteType (optional) Bandera indicando si se debe buscar con el tipo de documento "Nota de remisión electrónica".
     * @param collect (optional) Bandera indicando si se debe buscar por documentos solamente cobrados.
     * @param due (optional) Bandera indicando si se debe buscar por documentos solamente por vencer.
     * @param overdue (optional) Bandera indicando si se debe buscar por documentos solamente vencidos.
     * @param dateTo (optional) Fecha desde.
     * @param dateFrom (optional) Fecha hasta.
     * @param keyword (optional) Búsqueda por número de documento.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(branchesIds: number[] | null | undefined, hasBulk: boolean | null | undefined, statusSentToSIFEN: boolean | null | undefined, statusApproved: boolean | null | undefined, statusObserved: boolean | null | undefined, statusRejected: boolean | null | undefined, statusCancelled: boolean | null | undefined, statusError: boolean | null | undefined, statusOther: boolean | null | undefined, statusProcessed: boolean | null | undefined, electronicDocumentType: boolean | null | undefined, selfDocumentType: boolean | null | undefined, creditNoteType: boolean | null | undefined, debitNoteType: boolean | null | undefined, remissionNoteType: boolean | null | undefined, collect: boolean | null | undefined, due: boolean | null | undefined, overdue: boolean | null | undefined, dateTo: string | null | undefined, dateFrom: string | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetAll?";
        if (branchesIds !== undefined)
            branchesIds && branchesIds.forEach(item => { url_ += "BranchesIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasBulk !== undefined)
            url_ += "HasBulk=" + encodeURIComponent("" + hasBulk) + "&";
        if (statusSentToSIFEN !== undefined)
            url_ += "StatusSentToSIFEN=" + encodeURIComponent("" + statusSentToSIFEN) + "&";
        if (statusApproved !== undefined)
            url_ += "StatusApproved=" + encodeURIComponent("" + statusApproved) + "&";
        if (statusObserved !== undefined)
            url_ += "StatusObserved=" + encodeURIComponent("" + statusObserved) + "&";
        if (statusRejected !== undefined)
            url_ += "StatusRejected=" + encodeURIComponent("" + statusRejected) + "&";
        if (statusCancelled !== undefined)
            url_ += "StatusCancelled=" + encodeURIComponent("" + statusCancelled) + "&";
        if (statusError !== undefined)
            url_ += "StatusError=" + encodeURIComponent("" + statusError) + "&";
        if (statusOther !== undefined)
            url_ += "StatusOther=" + encodeURIComponent("" + statusOther) + "&";
        if (statusProcessed !== undefined)
            url_ += "StatusProcessed=" + encodeURIComponent("" + statusProcessed) + "&";
        if (electronicDocumentType !== undefined)
            url_ += "ElectronicDocumentType=" + encodeURIComponent("" + electronicDocumentType) + "&";
        if (selfDocumentType !== undefined)
            url_ += "SelfDocumentType=" + encodeURIComponent("" + selfDocumentType) + "&";
        if (creditNoteType !== undefined)
            url_ += "CreditNoteType=" + encodeURIComponent("" + creditNoteType) + "&";
        if (debitNoteType !== undefined)
            url_ += "DebitNoteType=" + encodeURIComponent("" + debitNoteType) + "&";
        if (remissionNoteType !== undefined)
            url_ += "RemissionNoteType=" + encodeURIComponent("" + remissionNoteType) + "&";
        if (collect !== undefined)
            url_ += "Collect=" + encodeURIComponent("" + collect) + "&";
        if (due !== undefined)
            url_ += "Due=" + encodeURIComponent("" + due) + "&";
        if (overdue !== undefined)
            url_ += "Overdue=" + encodeURIComponent("" + overdue) + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElectronicDocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDtoPagedResultDto>(<any>null);
    }

    /**
     * @param branchesIds (optional) Listado de sucursales para filtrar.
     * @param hasBulk (optional) Bandera indicando si se debe buscar comprobantes
    emitidos dentro de un lote.
     * @param statusSentToSIFEN (optional) Bandera indicando si se debe buscar en estado "Enviado al SIFEN".
     * @param statusApproved (optional) Bandera indicando si se debe buscar en estado "Aprobado".
     * @param statusObserved (optional) Bandera indicando si se debe buscar en estado "Observado".
     * @param statusRejected (optional) Bandera indicando si se debe buscar en estado "Rechazado".
     * @param statusCancelled (optional) Bandera indicando si se debe buscar en estado "Cancelado".
     * @param statusError (optional) Bandera indicando si se debe buscar en estado "Con Errores".
     * @param statusOther (optional) Bandera indicando si se debe buscar en estado "Otro".
     * @param statusProcessed (optional) Bandera indicando si se debe buscar en estado "Procesado".
     * @param electronicDocumentType (optional) Bandera indicando si se debe buscar con el tipo de documento "Factura electrónica".
     * @param selfDocumentType (optional) Bandera indicando si se debe buscar con el tipo de documento "Autofactura electrónica".
     * @param creditNoteType (optional) Bandera indicando si se debe buscar con el tipo de documento "Nota de crédito electrónica".
     * @param debitNoteType (optional) Bandera indicando si se debe buscar con el tipo de documento "Nota de débito electrónica".
     * @param remissionNoteType (optional) Bandera indicando si se debe buscar con el tipo de documento "Nota de remisión electrónica".
     * @param collect (optional) Bandera indicando si se debe buscar por documentos solamente cobrados.
     * @param due (optional) Bandera indicando si se debe buscar por documentos solamente por vencer.
     * @param overdue (optional) Bandera indicando si se debe buscar por documentos solamente vencidos.
     * @param dateTo (optional) Fecha desde.
     * @param dateFrom (optional) Fecha hasta.
     * @param keyword (optional) Búsqueda por número de documento.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllNoPaged(branchesIds: number[] | null | undefined, hasBulk: boolean | null | undefined, statusSentToSIFEN: boolean | null | undefined, statusApproved: boolean | null | undefined, statusObserved: boolean | null | undefined, statusRejected: boolean | null | undefined, statusCancelled: boolean | null | undefined, statusError: boolean | null | undefined, statusOther: boolean | null | undefined, statusProcessed: boolean | null | undefined, electronicDocumentType: boolean | null | undefined, selfDocumentType: boolean | null | undefined, creditNoteType: boolean | null | undefined, debitNoteType: boolean | null | undefined, remissionNoteType: boolean | null | undefined, collect: boolean | null | undefined, due: boolean | null | undefined, overdue: boolean | null | undefined, dateTo: string | null | undefined, dateFrom: string | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetAllNoPaged?";
        if (branchesIds !== undefined)
            branchesIds && branchesIds.forEach(item => { url_ += "BranchesIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasBulk !== undefined)
            url_ += "HasBulk=" + encodeURIComponent("" + hasBulk) + "&";
        if (statusSentToSIFEN !== undefined)
            url_ += "StatusSentToSIFEN=" + encodeURIComponent("" + statusSentToSIFEN) + "&";
        if (statusApproved !== undefined)
            url_ += "StatusApproved=" + encodeURIComponent("" + statusApproved) + "&";
        if (statusObserved !== undefined)
            url_ += "StatusObserved=" + encodeURIComponent("" + statusObserved) + "&";
        if (statusRejected !== undefined)
            url_ += "StatusRejected=" + encodeURIComponent("" + statusRejected) + "&";
        if (statusCancelled !== undefined)
            url_ += "StatusCancelled=" + encodeURIComponent("" + statusCancelled) + "&";
        if (statusError !== undefined)
            url_ += "StatusError=" + encodeURIComponent("" + statusError) + "&";
        if (statusOther !== undefined)
            url_ += "StatusOther=" + encodeURIComponent("" + statusOther) + "&";
        if (statusProcessed !== undefined)
            url_ += "StatusProcessed=" + encodeURIComponent("" + statusProcessed) + "&";
        if (electronicDocumentType !== undefined)
            url_ += "ElectronicDocumentType=" + encodeURIComponent("" + electronicDocumentType) + "&";
        if (selfDocumentType !== undefined)
            url_ += "SelfDocumentType=" + encodeURIComponent("" + selfDocumentType) + "&";
        if (creditNoteType !== undefined)
            url_ += "CreditNoteType=" + encodeURIComponent("" + creditNoteType) + "&";
        if (debitNoteType !== undefined)
            url_ += "DebitNoteType=" + encodeURIComponent("" + debitNoteType) + "&";
        if (remissionNoteType !== undefined)
            url_ += "RemissionNoteType=" + encodeURIComponent("" + remissionNoteType) + "&";
        if (collect !== undefined)
            url_ += "Collect=" + encodeURIComponent("" + collect) + "&";
        if (due !== undefined)
            url_ += "Due=" + encodeURIComponent("" + due) + "&";
        if (overdue !== undefined)
            url_ += "Overdue=" + encodeURIComponent("" + overdue) + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNoPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNoPaged(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNoPaged(response: HttpResponseBase): Observable<ElectronicDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElectronicDocumentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto[]>(<any>null);
    }

    /**
     * Obtiene un documento electrónico (DE) a partir de su identificador.
     * @param documentId (optional) Identificador del DE.
     * @return Success
     */
    get(documentId: number | undefined): Observable<ElectronicDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/Get?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ElectronicDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto>(<any>null);
    }

    /**
     * Obtiene un documento electrónico (DE) a partir de su CDC.
     * @param cdc (optional) CDC.
     * @return Success
     */
    getByCDC(cdc: string | null | undefined): Observable<ElectronicDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetByCDC?";
        if (cdc !== undefined)
            url_ += "cdc=" + encodeURIComponent("" + cdc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCDC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCDC(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCDC(response: HttpResponseBase): Observable<ElectronicDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto>(<any>null);
    }

    /**
     * Crea un nuevo documento electrónico.
     * @param bulkMode (optional) Modo lote: si es verdadera el documento electrónico
                se enviará en modo de lote
     * @param body (optional) Documento electrónico a crear.
     * @return Success
     */
    create(bulkMode: boolean | undefined, body: ElectronicDocumentDto | undefined): Observable<ElectronicDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/Create?";
        if (bulkMode === null)
            throw new Error("The parameter 'bulkMode' cannot be null.");
        else if (bulkMode !== undefined)
            url_ += "BulkMode=" + encodeURIComponent("" + bulkMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ElectronicDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto>(<any>null);
    }

    /**
     * Crea un nuevo documento electrónico omitiendo las validaciones funcionales de Paranet.
     * @param bulkMode (optional) Si es verdadera el documento electrónico se enviará en modo de lote
     * @param body (optional) Documento electrónico a crear.
     * @return Success
     */
    createRaw(bulkMode: boolean | undefined, body: ElectronicDocumentDto | undefined): Observable<ElectronicDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/CreateRaw?";
        if (bulkMode === null)
            throw new Error("The parameter 'bulkMode' cannot be null.");
        else if (bulkMode !== undefined)
            url_ += "BulkMode=" + encodeURIComponent("" + bulkMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRaw(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRaw(response: HttpResponseBase): Observable<ElectronicDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto>(<any>null);
    }

    /**
     * Reenvío de un documento electrónico por medio de un número de documento dado.
     * @param documentNumber (optional) Número de documento.
     * @param documentSeries (optional) Serie de documento.
     * @param documentTypeId (optional) Tipo de documento.
     * @param branchId (optional) Sucursal del documento.
     * @param bulkMode (optional) Modo lote: si es verdadera el documento electrónico
                se enviará en modo de lote
     * @param body (optional) Documento electrónico a crear.
     * @return Success
     */
    resend(documentNumber: number | undefined, documentSeries: string | null | undefined, documentTypeId: number | undefined, branchId: number | undefined, bulkMode: boolean | undefined, body: ElectronicDocumentDto | undefined): Observable<ElectronicDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/Resend?";
        if (documentNumber === null)
            throw new Error("The parameter 'documentNumber' cannot be null.");
        else if (documentNumber !== undefined)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (documentSeries !== undefined)
            url_ += "DocumentSeries=" + encodeURIComponent("" + documentSeries) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (bulkMode === null)
            throw new Error("The parameter 'bulkMode' cannot be null.");
        else if (bulkMode !== undefined)
            url_ += "BulkMode=" + encodeURIComponent("" + bulkMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResend(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processResend(response: HttpResponseBase): Observable<ElectronicDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto>(<any>null);
    }

    /**
     * Reenvío de un documento electrónico por medio de su número y serie.
     * @param documentNumber (optional) Número de documento.
     * @param documentSeries (optional) Serie de documento.
     * @param documentTypeId (optional) Id del tipo de documento.
     * @param branchId (optional) Id del tipo de documento.
     * @param bulkMode (optional) Modo lote: si es verdadera el documento electrónico
                se enviará en modo de lote
     * @return Success
     */
    retry(documentNumber: number | undefined, documentSeries: string | null | undefined, documentTypeId: number | undefined, branchId: number | undefined, bulkMode: boolean | undefined): Observable<ElectronicDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/Retry?";
        if (documentNumber === null)
            throw new Error("The parameter 'documentNumber' cannot be null.");
        else if (documentNumber !== undefined)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (documentSeries !== undefined)
            url_ += "DocumentSeries=" + encodeURIComponent("" + documentSeries) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (bulkMode === null)
            throw new Error("The parameter 'bulkMode' cannot be null.");
        else if (bulkMode !== undefined)
            url_ += "BulkMode=" + encodeURIComponent("" + bulkMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetry(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processRetry(response: HttpResponseBase): Observable<ElectronicDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDto>(<any>null);
    }

    /**
     * @param cDC (optional) 
     * @return Success
     */
    getXMLByCDC(cDC: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetXMLByCDC?";
        if (cDC !== undefined)
            url_ += "CDC=" + encodeURIComponent("" + cDC) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXMLByCDC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXMLByCDC(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetXMLByCDC(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param cdc (optional) 
     * @param templateType (optional) 
     * @return Success
     */
    getPDF(cdc: string | null | undefined, templateType: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetPDF?";
        if (cdc !== undefined)
            url_ += "cdc=" + encodeURIComponent("" + cdc) + "&";
        if (templateType === null)
            throw new Error("The parameter 'templateType' cannot be null.");
        else if (templateType !== undefined)
            url_ += "templateType=" + encodeURIComponent("" + templateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPDF(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPDF(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProformaPDF(body: ElectronicDocumentDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetProformaPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProformaPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProformaPDF(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetProformaPDF(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPurchaseOrderPDF(body: ElectronicDocumentDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetPurchaseOrderPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrderPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderPDF(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPurchaseOrderPDF(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneralTimeZone(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetGeneralTimeZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralTimeZone(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralTimeZone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLatestSentElectronicDocuments(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetLatestSentElectronicDocuments?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestSentElectronicDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestSentElectronicDocuments(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestSentElectronicDocuments(response: HttpResponseBase): Observable<ElectronicDocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDtoPagedResultDto>(<any>null);
    }

    /**
     * @param documentNumber (optional) 
     * @param documentSeries (optional) 
     * @param documentTypeId (optional) 
     * @param branchId (optional) 
     * @return Success
     */
    sendMailByElectronicDocument(documentNumber: number | undefined, documentSeries: string | null | undefined, documentTypeId: number | undefined, branchId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/SendMailByElectronicDocument?";
        if (documentNumber === null)
            throw new Error("The parameter 'documentNumber' cannot be null.");
        else if (documentNumber !== undefined)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (documentSeries !== undefined)
            url_ += "DocumentSeries=" + encodeURIComponent("" + documentSeries) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailByElectronicDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailByElectronicDocument(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailByElectronicDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param electronicDocumentId (optional) Id del documento electrónico.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllReceiptsDocument(electronicDocumentId: number | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentReceiptDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetAllReceiptsDocument?";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "ElectronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReceiptsDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReceiptsDocument(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentReceiptDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentReceiptDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReceiptsDocument(response: HttpResponseBase): Observable<ElectronicDocumentReceiptDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentReceiptDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentReceiptDtoPagedResultDto>(<any>null);
    }

    /**
     * @param dateFrom (optional) Fecha inicial del listado de recibos relacionados a los documentos.
     * @param dateTo (optional) Fecha final del listado de recibos relacionados a los documentos.
     * @param clientId (optional) Identificador del cliente específico que se quiere obtener los recibos.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRelatedReceiptsRelationatedDocument(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, clientId: number | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentReceiptDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetAllRelatedReceiptsRelationatedDocument?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRelatedReceiptsRelationatedDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRelatedReceiptsRelationatedDocument(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentReceiptDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentReceiptDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRelatedReceiptsRelationatedDocument(response: HttpResponseBase): Observable<ElectronicDocumentReceiptDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentReceiptDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentReceiptDtoPagedResultDto>(<any>null);
    }

    /**
     * @param receiptId (optional) 
     * @param electronicDocumentId (optional) 
     * @return Success
     */
    deleteElectronicDocumentReceipt(receiptId: number | undefined, electronicDocumentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/DeleteElectronicDocumentReceipt?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteElectronicDocumentReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteElectronicDocumentReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteElectronicDocumentReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param receiptId (optional) 
     * @param electronicDocumentId (optional) 
     * @return Success
     */
    getReceiptPDF(receiptId: number | undefined, electronicDocumentId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GetReceiptPDF?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptPDF(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiptPDF(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @param body (optional) 
     * @return Success
     */
    generateAccountBalancePDF(receiverId: number | undefined, body: AccountBalanceReportDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/GenerateAccountBalancePDF?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAccountBalancePDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAccountBalancePDF(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAccountBalancePDF(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param electronicDocumentId (optional) 
     * @return Success
     */
    sendDocumentByDocumentId(electronicDocumentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/SendDocumentByDocumentId?";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDocumentByDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDocumentByDocumentId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendDocumentByDocumentId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param electronicDocumentId (optional) 
     * @return Success
     */
    sendClientDocumentByDocumentId(electronicDocumentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/SendClientDocumentByDocumentId?";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendClientDocumentByDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendClientDocumentByDocumentId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendClientDocumentByDocumentId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param electronicDocumentId (optional) 
     * @param receiptId (optional) 
     * @return Success
     */
    sendReceiptByReceiptId(electronicDocumentId: number | undefined, receiptId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocument/SendReceiptByReceiptId?";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReceiptByReceiptId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReceiptByReceiptId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendReceiptByReceiptId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ElectronicDocumentBulkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los lotes de documentos electrónicos previamente generados.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentBulkDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentBulkDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentBulkDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElectronicDocumentBulkDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentBulkDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentBulkDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene los detalle de un lote de documentos electrónicos enviado,
    a partir de su identificador.
     * @param bulkId (optional) 
     * @return Success
     */
    get(bulkId: number | undefined): Observable<ElectronicDocumentBulkDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/Get?";
        if (bulkId === null)
            throw new Error("The parameter 'bulkId' cannot be null.");
        else if (bulkId !== undefined)
            url_ += "bulkId=" + encodeURIComponent("" + bulkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentBulkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentBulkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ElectronicDocumentBulkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentBulkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentBulkDto>(<any>null);
    }

    /**
     * Crea un lote de documentos electrónicos.
     * @param body (optional) 
     * @return Success
     */
    create(body: ElectronicDocumentBulkDto | undefined): Observable<ElectronicDocumentBulkDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentBulkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentBulkDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ElectronicDocumentBulkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentBulkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentBulkDto>(<any>null);
    }

    /**
     * Verifica un lote de documentos electrónicos
     * @param electronicDocumentId (optional) Identificador interno de Paranet
     * @return Success
     */
    verifyBulkByElectronicDocumentId(electronicDocumentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/VerifyBulkByElectronicDocumentId?";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyBulkByElectronicDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyBulkByElectronicDocumentId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyBulkByElectronicDocumentId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Verifica un lote de documentos electrónicos
     * @param sifenBulkId (optional) 
     * @return Success
     */
    verifyBulk(sifenBulkId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/VerifyBulk?";
        if (sifenBulkId !== undefined)
            url_ += "SifenBulkId=" + encodeURIComponent("" + sifenBulkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyBulk(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Verifica un lote de documentos electrónicos
     * @param number (optional) Número del documento
     * @param series (optional) Serie del documento
     * @param documentTypeId (optional) Id tipo del documento
     * @param branchId (optional) Id de la sucursal
     * @return Success
     */
    verifyBulkByElectronicDocument(number: number | undefined, series: string | null | undefined, documentTypeId: number | undefined, branchId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/VerifyBulkByElectronicDocument?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (series !== undefined)
            url_ += "Series=" + encodeURIComponent("" + series) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyBulkByElectronicDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyBulkByElectronicDocument(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyBulkByElectronicDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Verifica todos los lotes de documentos electrónicos
    que estén en estado "Enviado al SIFEN".
     * @return Success
     */
    verifyAllBulks(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/VerifyAllBulks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyAllBulks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAllBulks(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyAllBulks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLatestSentElectronicDocuments(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentBulk/GetLatestSentElectronicDocuments?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestSentElectronicDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestSentElectronicDocuments(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestSentElectronicDocuments(response: HttpResponseBase): Observable<ElectronicDocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ElectronicDocumentReceptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentReceptionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentReception/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentReceptionDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentReceptionDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElectronicDocumentReceptionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentReceptionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentReceptionDtoPagedResultDto>(<any>null);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    get(documentId: number | undefined): Observable<ElectronicDocumentReceptionDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentReception/Get?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentReceptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentReceptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ElectronicDocumentReceptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentReceptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentReceptionDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLatestReceivedElectronicDocuments(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectronicDocumentReceptionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentReception/GetLatestReceivedElectronicDocuments?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestReceivedElectronicDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestReceivedElectronicDocuments(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentReceptionDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentReceptionDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestReceivedElectronicDocuments(response: HttpResponseBase): Observable<ElectronicDocumentReceptionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentReceptionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentReceptionDtoPagedResultDto>(<any>null);
    }

    /**
     * @param uRL (optional) 
     * @return Success
     */
    insertDocumentWithURL(uRL: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentReception/InsertDocumentWithURL?";
        if (uRL !== undefined)
            url_ += "URL=" + encodeURIComponent("" + uRL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertDocumentWithURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertDocumentWithURL(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processInsertDocumentWithURL(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param cDC (optional) 
     * @return Success
     */
    insertDocumentWithCDC(cDC: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentReception/InsertDocumentWithCDC?";
        if (cDC !== undefined)
            url_ += "CDC=" + encodeURIComponent("" + cDC) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertDocumentWithCDC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertDocumentWithCDC(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processInsertDocumentWithCDC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class ElectronicDocumentTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Prueba el template para PDF actual filtrado por Tenant.
     * @param body (optional) 
     * @return Success
     */
    testPDF(body: ElectronicDocumentTemplateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/TestPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestPDF(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processTestPDF(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Prueba el template para PDF actual filtrado por Tenant.
     * @param body (optional) 
     * @return Success
     */
    testTicket(body: ElectronicDocumentTemplateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/TestTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestTicket(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processTestTicket(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Guarda el template para PDF actual filtrado por Tenant.
     * @param body (optional) 
     * @return Success
     */
    savePDF(body: ElectronicDocumentTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/SavePDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePDF(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSavePDF(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Guarda el template para el e-Ticket actual filtrado por Tenant.
     * @param body (optional) 
     * @return Success
     */
    saveTicket(body: ElectronicDocumentTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/SaveTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTicket(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Guarda el logo filtrado por Tenant.
     * @param body (optional) 
     * @return Success
     */
    saveLogo(body: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/SaveLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene el template para PDF actual filtrado por Tenant.
     * @return Success
     */
    getActualPDF(): Observable<ElectronicDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/GetActualPDF";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualPDF(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActualPDF(response: HttpResponseBase): Observable<ElectronicDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentTemplateDto>(<any>null);
    }

    /**
     * Obtiene el template para e-Ticket actual filtrado por Tenant.
     * @return Success
     */
    getActualTicket(): Observable<ElectronicDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/GetActualTicket";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualTicket(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActualTicket(response: HttpResponseBase): Observable<ElectronicDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentTemplateDto>(<any>null);
    }

    /**
     * Obtiene el logo actual del Tenant.
     * @return Success
     */
    getActualLogo(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/GetActualLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualLogo(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetActualLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Reinicia el template para el e-Ticket colocando el por defecto.
     * @return Success
     */
    setDefaultTicket(): Observable<ElectronicDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/SetDefaultTicket";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultTicket(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultTicket(response: HttpResponseBase): Observable<ElectronicDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentTemplateDto>(<any>null);
    }

    /**
     * Reinicia el template para el PDF colocando el por defecto.
     * @return Success
     */
    setDefaultPDF(): Observable<ElectronicDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectronicDocumentTemplate/SetDefaultPDF";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultPDF(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultPDF(response: HttpResponseBase): Observable<ElectronicDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentTemplateDto>(<any>null);
    }
}

@Injectable()
export class EventIssuerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ObjectPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EventIssuer/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ObjectPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObjectPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentCancellation(body: EventCancellationDto | undefined): Observable<EventCancellationDto> {
        let url_ = this.baseUrl + "/api/services/app/EventIssuer/DocumentCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentCancellation(<any>response_);
                } catch (e) {
                    return <Observable<EventCancellationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventCancellationDto>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentCancellation(response: HttpResponseBase): Observable<EventCancellationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventCancellationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventCancellationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentsDisable(body: EventDisableDto | undefined): Observable<EventDisableDto> {
        let url_ = this.baseUrl + "/api/services/app/EventIssuer/DocumentsDisable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsDisable(<any>response_);
                } catch (e) {
                    return <Observable<EventDisableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventDisableDto>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentsDisable(response: HttpResponseBase): Observable<EventDisableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDisableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDisableDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLatestEventsIssued(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ObjectPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EventIssuer/GetLatestEventsIssued?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestEventsIssued(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestEventsIssued(<any>response_);
                } catch (e) {
                    return <Observable<ObjectPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestEventsIssued(response: HttpResponseBase): Observable<ObjectPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectPagedResultDto>(<any>null);
    }
}

@Injectable()
export class EventReceiverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ObjectPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EventReceiver/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ObjectPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObjectPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentAgreement(body: EventAgreementDto | undefined): Observable<EventAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/EventReceiver/DocumentAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentAgreement(<any>response_);
                } catch (e) {
                    return <Observable<EventAgreementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventAgreementDto>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentAgreement(response: HttpResponseBase): Observable<EventAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventAgreementDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentDisagreement(body: EventDisagreementDto | undefined): Observable<EventDisagreementDto> {
        let url_ = this.baseUrl + "/api/services/app/EventReceiver/DocumentDisagreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentDisagreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentDisagreement(<any>response_);
                } catch (e) {
                    return <Observable<EventDisagreementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventDisagreementDto>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentDisagreement(response: HttpResponseBase): Observable<EventDisagreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDisagreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDisagreementDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentUnknown(body: EventUnknownDto | undefined): Observable<EventUnknownDto> {
        let url_ = this.baseUrl + "/api/services/app/EventReceiver/DocumentUnknown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentUnknown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentUnknown(<any>response_);
                } catch (e) {
                    return <Observable<EventUnknownDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventUnknownDto>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentUnknown(response: HttpResponseBase): Observable<EventUnknownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventUnknownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventUnknownDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLatestEventsReceived(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ObjectPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EventReceiver/GetLatestEventsReceived?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestEventsReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestEventsReceived(<any>response_);
                } catch (e) {
                    return <Observable<ObjectPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestEventsReceived(response: HttpResponseBase): Observable<ObjectPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectPagedResultDto>(<any>null);
    }
}

@Injectable()
export class FuelTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los tipos de combustibles disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FuelTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FuelTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FuelTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FuelTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuelTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un tipo de combustible, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FuelTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FuelTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FuelTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FuelTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuelTypeDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de combustible.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: FuelTypeDto | undefined): Observable<FuelTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FuelTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FuelTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FuelTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuelTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de un tipo de combustible dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: FuelTypeDto | undefined): Observable<FuelTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FuelTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FuelTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FuelTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuelTypeDto>(<any>null);
    }

    /**
     * Elimina un tipo de combustible dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class IdentityDocumentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los tipos de documentos de identidad para personas disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IdentityDocumentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IdentityDocumentType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<IdentityDocumentTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityDocumentTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IdentityDocumentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityDocumentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityDocumentTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un tipo de documento de identidad para personas, dado su 
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<IdentityDocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/IdentityDocumentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<IdentityDocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityDocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IdentityDocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityDocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityDocumentTypeDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de documento de identidad para personas.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: IdentityDocumentTypeDto | undefined): Observable<IdentityDocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/IdentityDocumentType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<IdentityDocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityDocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IdentityDocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityDocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityDocumentTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de un tipo de documento de identidad para personas dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: IdentityDocumentTypeDto | undefined): Observable<IdentityDocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/IdentityDocumentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<IdentityDocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityDocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IdentityDocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityDocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityDocumentTypeDto>(<any>null);
    }

    /**
     * Elimina un tipo de documento de identidad para personas dado un
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IdentityDocumentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MeasurementUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las unidades de medida disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MeasurementUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementUnit/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MeasurementUnitDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeasurementUnitDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MeasurementUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MeasurementUnitDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una unidad de medida, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MeasurementUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementUnit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MeasurementUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeasurementUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MeasurementUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MeasurementUnitDto>(<any>null);
    }

    /**
     * Crea una nueva unidad de medida.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: MeasurementUnitDto | undefined): Observable<MeasurementUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MeasurementUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeasurementUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MeasurementUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MeasurementUnitDto>(<any>null);
    }

    /**
     * Actualiza los datos de una unidad de medida dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: MeasurementUnitDto | undefined): Observable<MeasurementUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MeasurementUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeasurementUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MeasurementUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MeasurementUnitDto>(<any>null);
    }

    /**
     * Elimina una unidad de medida dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MerchandiseNegotiationConditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las condiciones de negociación de mercaderías disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MerchandiseNegotiationConditionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchandiseNegotiationCondition/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MerchandiseNegotiationConditionDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerchandiseNegotiationConditionDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MerchandiseNegotiationConditionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchandiseNegotiationConditionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerchandiseNegotiationConditionDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una condición de negociación de mercaderías, dado su
    identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MerchandiseNegotiationConditionDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchandiseNegotiationCondition/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MerchandiseNegotiationConditionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerchandiseNegotiationConditionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MerchandiseNegotiationConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchandiseNegotiationConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerchandiseNegotiationConditionDto>(<any>null);
    }

    /**
     * Crea una nueva condición de negociación de mercaderías.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: MerchandiseNegotiationConditionDto | undefined): Observable<MerchandiseNegotiationConditionDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchandiseNegotiationCondition/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MerchandiseNegotiationConditionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerchandiseNegotiationConditionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MerchandiseNegotiationConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchandiseNegotiationConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerchandiseNegotiationConditionDto>(<any>null);
    }

    /**
     * Actualiza los datos de una condición de negociación de
    mercaderías dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: MerchandiseNegotiationConditionDto | undefined): Observable<MerchandiseNegotiationConditionDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchandiseNegotiationCondition/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MerchandiseNegotiationConditionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerchandiseNegotiationConditionDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MerchandiseNegotiationConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchandiseNegotiationConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerchandiseNegotiationConditionDto>(<any>null);
    }

    /**
     * Elimina una condición de negociación de mercaderías dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchandiseNegotiationCondition/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NomenclatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene las nomenclaturas disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NomenclatureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Nomenclature/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<NomenclatureDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NomenclatureDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NomenclatureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NomenclatureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NomenclatureDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una nomenclatura, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NomenclatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Nomenclature/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<NomenclatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NomenclatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NomenclatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NomenclatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NomenclatureDto>(<any>null);
    }

    /**
     * Crea una nueva nomenclatura.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: NomenclatureDto | undefined): Observable<NomenclatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Nomenclature/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<NomenclatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NomenclatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NomenclatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NomenclatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NomenclatureDto>(<any>null);
    }

    /**
     * Actualiza los datos de una nomenclatura dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: NomenclatureDto | undefined): Observable<NomenclatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Nomenclature/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<NomenclatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NomenclatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NomenclatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NomenclatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NomenclatureDto>(<any>null);
    }

    /**
     * Elimina una nomenclatura dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Nomenclature/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PaymentMethodServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los métodos de pago disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PaymentMethodDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethod/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaymentMethodDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un método de pago, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethod/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(<any>null);
    }

    /**
     * Crea un nuevo método de pago.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: PaymentMethodDto | undefined): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethod/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(<any>null);
    }

    /**
     * Actualiza los datos de un método de pago dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: PaymentMethodDto | undefined): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethod/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(<any>null);
    }

    /**
     * Elimina un método de pago dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethod/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PresenceIndicatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los indicadores de presencia disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PresenceIndicatorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PresenceIndicator/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PresenceIndicatorDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresenceIndicatorDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PresenceIndicatorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresenceIndicatorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresenceIndicatorDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un indicador de presencia, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PresenceIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/PresenceIndicator/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PresenceIndicatorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresenceIndicatorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PresenceIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresenceIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresenceIndicatorDto>(<any>null);
    }

    /**
     * Crea un nuevo indicador de presencia.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: PresenceIndicatorDto | undefined): Observable<PresenceIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/PresenceIndicator/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PresenceIndicatorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresenceIndicatorDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PresenceIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresenceIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresenceIndicatorDto>(<any>null);
    }

    /**
     * Actualiza los datos de un indicador de presencia dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: PresenceIndicatorDto | undefined): Observable<PresenceIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/PresenceIndicator/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PresenceIndicatorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresenceIndicatorDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PresenceIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresenceIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresenceIndicatorDto>(<any>null);
    }

    /**
     * Elimina un indicador de presencia, dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PresenceIndicator/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los productos actuales disponibles
    de acuerdo a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ProductDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un producto, dado su identificador interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Crea un nuevo producto.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: ProductDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Actualiza los datos de un producto dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: ProductDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Elimina un producto, dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Importa una lista de productos por medio de un archivo tipo JSON.
     * @param body (optional) Lista correspondiente.
     * @return Success
     */
    importProductsByList(body: ProductDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/ImportProductsByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportProductsByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportProductsByList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportProductsByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param productName (optional) 
     * @param receiverName (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSaleByProductResult(productName: string | null | undefined, receiverName: string | null | undefined, dateFrom: moment.Moment | null | undefined, dateTo: moment.Moment | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultSaleByProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetSaleByProductResult?";
        if (productName !== undefined)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (receiverName !== undefined)
            url_ += "ReceiverName=" + encodeURIComponent("" + receiverName) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaleByProductResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleByProductResult(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultSaleByProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultSaleByProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSaleByProductResult(response: HttpResponseBase): Observable<PagedResultSaleByProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultSaleByProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultSaleByProductDto>(<any>null);
    }
}

@Injectable()
export class QRCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Genera un código QR a partir del Documento Electrónico
    recibido.
     * @param body (optional) Datos para la generación del QR, que componen al DE y el tamaño.
     * @return Success
     */
    generateQR(body: QRCodeRequestDto | undefined): Observable<QRCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/QRCode/GenerateQR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQR(<any>response_);
                } catch (e) {
                    return <Observable<QRCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QRCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateQR(response: HttpResponseBase): Observable<QRCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QRCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QRCodeDto>(<any>null);
    }
}

@Injectable()
export class ReceiverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMonthToMonthBilling(): Observable<MonthToMonthBillingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetMonthToMonthBilling";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthToMonthBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthToMonthBilling(<any>response_);
                } catch (e) {
                    return <Observable<MonthToMonthBillingDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthToMonthBillingDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMonthToMonthBilling(response: HttpResponseBase): Observable<MonthToMonthBillingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthToMonthBillingDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthToMonthBillingDto[]>(<any>null);
    }

    /**
     * @param reference (optional) 
     * @param creationTime (optional) 
     * @param body (optional) 
     * @return Success
     */
    createMultipleReceipt(reference: string | null | undefined, creationTime: moment.Moment | undefined, body: ElectronicDocumentMultipleReceiptDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/CreateMultipleReceipt?";
        if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "creationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMultipleReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param receiverId (optional) 
     * @return Success
     */
    getAllReceiverDocumentsForMultipleReceipt(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, receiverId: number | undefined): Observable<ElectronicDocumentMultipleReceiptDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetAllReceiverDocumentsForMultipleReceipt?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReceiverDocumentsForMultipleReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReceiverDocumentsForMultipleReceipt(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentMultipleReceiptDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentMultipleReceiptDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReceiverDocumentsForMultipleReceipt(response: HttpResponseBase): Observable<ElectronicDocumentMultipleReceiptDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentMultipleReceiptDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentMultipleReceiptDtoPagedResultDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param receiverId (optional) 
     * @return Success
     */
    getAllReceiverBranchesPaged(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, receiverId: number | undefined): Observable<ReceiverBranchDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetAllReceiverBranchesPaged?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReceiverBranchesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReceiverBranchesPaged(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverBranchDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverBranchDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReceiverBranchesPaged(response: HttpResponseBase): Observable<ReceiverBranchDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverBranchDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverBranchDtoPagedResultDto>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getAllReceiverBranches(receiverId: number | undefined): Observable<ReceiverBranchDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetAllReceiverBranches?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReceiverBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReceiverBranches(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverBranchDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverBranchDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReceiverBranches(response: HttpResponseBase): Observable<ReceiverBranchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReceiverBranchDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverBranchDto[]>(<any>null);
    }

    /**
     * @param receiverBranchId (optional) 
     * @return Success
     */
    deleteReceiverBranch(receiverBranchId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/DeleteReceiverBranch?";
        if (receiverBranchId === null)
            throw new Error("The parameter 'receiverBranchId' cannot be null.");
        else if (receiverBranchId !== undefined)
            url_ += "receiverBranchId=" + encodeURIComponent("" + receiverBranchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReceiverBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceiverBranch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReceiverBranch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReceiverBranch(body: ReceiverBranchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/UpdateReceiverBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceiverBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceiverBranch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReceiverBranch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createReceiverBranch(body: ReceiverBranchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/CreateReceiverBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReceiverBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReceiverBranch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateReceiverBranch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene los receptores electrónicos/clientes disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra de búsqueda.
     * @param isActive (optional) Filtro (bandera 0 o 1) para receptores
    activos o inactivos.
     * @param isProvider (optional) Filtro (bandera 0 o 1) para proveedores
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, isProvider: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReceiverDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isProvider !== undefined)
            url_ += "IsProvider=" + encodeURIComponent("" + isProvider) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReceiverDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un receptor electrónico/cliente, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReceiverDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReceiverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverDto>(<any>null);
    }

    /**
     * Crea un nuevo receptor electrónico.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: ReceiverDto | undefined): Observable<ReceiverDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReceiverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverDto>(<any>null);
    }

    /**
     * Actualiza los datos de un receptor electrónico dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: ReceiverDto | undefined): Observable<ReceiverDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReceiverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverDto>(<any>null);
    }

    /**
     * Elimina un receptor electrónico dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene todos los documentos electrónicos de un cliente.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param receiverId (optional) .
     * @return Success
     */
    getAllReceiverDocuments(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, receiverId: number | undefined): Observable<ElectronicDocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetAllReceiverDocuments?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReceiverDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReceiverDocuments(<any>response_);
                } catch (e) {
                    return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ElectronicDocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReceiverDocuments(response: HttpResponseBase): Observable<ElectronicDocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicDocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElectronicDocumentDtoPagedResultDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getClientsAccountBalance(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReceiverAccountBalanceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetClientsAccountBalance?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsAccountBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsAccountBalance(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverAccountBalanceDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverAccountBalanceDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientsAccountBalance(response: HttpResponseBase): Observable<ReceiverAccountBalanceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverAccountBalanceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverAccountBalanceDtoPagedResultDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTotalsClientsAccountBalance(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReceiverTotalAccountBalanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetTotalsClientsAccountBalance?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalsClientsAccountBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalsClientsAccountBalance(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverTotalAccountBalanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverTotalAccountBalanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalsClientsAccountBalance(response: HttpResponseBase): Observable<ReceiverTotalAccountBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiverTotalAccountBalanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverTotalAccountBalanceDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getClientsAccountBalanceList(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReceiverAccountBalanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetClientsAccountBalanceList?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsAccountBalanceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsAccountBalanceList(<any>response_);
                } catch (e) {
                    return <Observable<ReceiverAccountBalanceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiverAccountBalanceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientsAccountBalanceList(response: HttpResponseBase): Observable<ReceiverAccountBalanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReceiverAccountBalanceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiverAccountBalanceDto[]>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getReceiverChargedAmount(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetReceiverChargedAmount?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiverChargedAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiverChargedAmount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiverChargedAmount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getReceiverToExpirateAmount(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetReceiverToExpirateAmount?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiverToExpirateAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiverToExpirateAmount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiverToExpirateAmount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getReceiverExpiratedAmount(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetReceiverExpiratedAmount?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiverExpiratedAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiverExpiratedAmount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiverExpiratedAmount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getExtraReceiptsAmount(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetExtraReceiptsAmount?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtraReceiptsAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtraReceiptsAmount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetExtraReceiptsAmount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Crea un recibo y lo vincula a un documento electrónico.
     * @param electronicDocumentId (optional) Identificador del documento electrónico
     * @param body (optional) Recibo
     * @return Success
     */
    createElectronicDocumentReceipt(electronicDocumentId: number | undefined, body: ReceiptDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/CreateElectronicDocumentReceipt?";
        if (electronicDocumentId === null)
            throw new Error("The parameter 'electronicDocumentId' cannot be null.");
        else if (electronicDocumentId !== undefined)
            url_ += "electronicDocumentId=" + encodeURIComponent("" + electronicDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateElectronicDocumentReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateElectronicDocumentReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateElectronicDocumentReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Crea un recibo y lo vincula a un cliente.
     * @param receiverId (optional) Identificador del cliente
     * @param body (optional) Recibo
     * @return Success
     */
    createOpenReceipt(receiverId: number | undefined, body: ReceiptDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/CreateOpenReceipt?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOpenReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOpenReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOpenReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param receiptId (optional) 
     * @return Success
     */
    getTotalElectronicDocumentReceipts(receiptId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/GetTotalElectronicDocumentReceipts?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalElectronicDocumentReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalElectronicDocumentReceipts(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalElectronicDocumentReceipts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Importa una lista de clientes por medio de un archivo tipo JSON.
     * @param body (optional) Lista correspondiente.
     * @return Success
     */
    importReceiversByList(body: ReceiverDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receiver/ImportReceiversByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportReceiversByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportReceiversByList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportReceiversByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los tipos de régimen disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RegimeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Regime/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RegimeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegimeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RegimeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegimeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegimeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un tipo de régimen dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RegimeDto> {
        let url_ = this.baseUrl + "/api/services/app/Regime/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RegimeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegimeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RegimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegimeDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de régimen.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: RegimeDto | undefined): Observable<RegimeDto> {
        let url_ = this.baseUrl + "/api/services/app/Regime/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RegimeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegimeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RegimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegimeDto>(<any>null);
    }

    /**
     * Actualiza los datos de un tipo de régimen dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: RegimeDto | undefined): Observable<RegimeDto> {
        let url_ = this.baseUrl + "/api/services/app/Regime/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RegimeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegimeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegimeDto>(<any>null);
    }

    /**
     * Elimina un tipo de régimen dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regime/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RemissionNoteReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los motivos de emisión para notas de remisión disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RemissionNoteReasonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RemissionNoteReason/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RemissionNoteReasonDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemissionNoteReasonDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RemissionNoteReasonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemissionNoteReasonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemissionNoteReasonDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un motivo de emisión para notas de remisión, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RemissionNoteReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/RemissionNoteReason/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RemissionNoteReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemissionNoteReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RemissionNoteReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemissionNoteReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemissionNoteReasonDto>(<any>null);
    }

    /**
     * Crea un nuevo motivo de emisión para notas de remisión
    electrónica.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: RemissionNoteReasonDto | undefined): Observable<RemissionNoteReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/RemissionNoteReason/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RemissionNoteReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemissionNoteReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RemissionNoteReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemissionNoteReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemissionNoteReasonDto>(<any>null);
    }

    /**
     * Actualiza los datos de un motivo de emisión dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: RemissionNoteReasonDto | undefined): Observable<RemissionNoteReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/RemissionNoteReason/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RemissionNoteReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemissionNoteReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RemissionNoteReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemissionNoteReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemissionNoteReasonDto>(<any>null);
    }

    /**
     * Elimina un motivo de emisión dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemissionNoteReason/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ReportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Reporte de totales de documentos electrónicos (emitidos/recibidos), para
    la generación de un gráfico.
     * @param issuedOrReceived (optional) Parámetro para indicar si se quiere obtener los resultados de
    los documentos emitidos o recibidos.
     * @param grouping (optional) Parámetro para la agrupación de los resultados (totales).
     * @param skip (optional) Cantidad de filas que se quiera saltear.
    Parámetro necesario para la obtención de una
    página de resultados específica.
    Se utiliza en combinación del parámetro "Count".
     * @param count (optional) Cantidad de resultados que se quiera obtener.
    Parámetro necesario para generar una paginación.
    Se utiliza en combinación del parámetro "Skip".
     * @param documentTypeId (optional) Filtro para buscar por un tipo de documento
    específico.
    Se debe proporcionar el identificador interno
    del tipo de documento.
     * @param clientId (optional) Filtro para buscar por un cliente específico.
    Se debe proporcionar el identificador interno del
    mismo.
    Parámetro opcional.
     * @param fromDate (optional) Fecha de inicio de emisión/recepción para la
    búsqueda de los Documentos Electrónicos.
    Parámetro opcional.
     * @param toDate (optional) Fecha de fin de emisión/recepción para la
    búsqueda de los Documentos Electrónicos.
    Parámetro opcional.
     * @return Success
     */
    getTotalTransactionsGraph(issuedOrReceived: string | null | undefined, grouping: string | null | undefined, skip: number | undefined, count: number | undefined, documentTypeId: number | undefined, clientId: number | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<TransactionGraphResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetTotalTransactionsGraph?";
        if (issuedOrReceived !== undefined)
            url_ += "IssuedOrReceived=" + encodeURIComponent("" + issuedOrReceived) + "&";
        if (grouping !== undefined)
            url_ += "Grouping=" + encodeURIComponent("" + grouping) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalTransactionsGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalTransactionsGraph(<any>response_);
                } catch (e) {
                    return <Observable<TransactionGraphResultDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionGraphResultDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalTransactionsGraph(response: HttpResponseBase): Observable<TransactionGraphResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionGraphResultDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionGraphResultDto[]>(<any>null);
    }

    /**
     * Reporte de montos totales de documentos electrónicos (emitidos/recibidos), para
    la generación de un gráfico.
     * @param issuedOrReceived (optional) Parámetro para indicar si se quiere obtener los resultados de
    los documentos emitidos o recibidos.
     * @param grouping (optional) Parámetro para la agrupación de los resultados (totales).
     * @param skip (optional) Cantidad de filas que se quiera saltear.
    Parámetro necesario para la obtención de una
    página de resultados específica.
    Se utiliza en combinación del parámetro "Count".
     * @param count (optional) Cantidad de resultados que se quiera obtener.
    Parámetro necesario para generar una paginación.
    Se utiliza en combinación del parámetro "Skip".
     * @param documentTypeId (optional) Filtro para buscar por un tipo de documento
    específico.
    Se debe proporcionar el identificador interno
    del tipo de documento.
     * @param clientId (optional) Filtro para buscar por un cliente específico.
    Se debe proporcionar el identificador interno del
    mismo.
    Parámetro opcional.
     * @param fromDate (optional) Fecha de inicio de emisión/recepción para la
    búsqueda de los Documentos Electrónicos.
    Parámetro opcional.
     * @param toDate (optional) Fecha de fin de emisión/recepción para la
    búsqueda de los Documentos Electrónicos.
    Parámetro opcional.
     * @return Success
     */
    getTotalAmountsGraph(issuedOrReceived: string | null | undefined, grouping: string | null | undefined, skip: number | undefined, count: number | undefined, documentTypeId: number | undefined, clientId: number | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<AmountGraphResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetTotalAmountsGraph?";
        if (issuedOrReceived !== undefined)
            url_ += "IssuedOrReceived=" + encodeURIComponent("" + issuedOrReceived) + "&";
        if (grouping !== undefined)
            url_ += "Grouping=" + encodeURIComponent("" + grouping) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountsGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountsGraph(<any>response_);
                } catch (e) {
                    return <Observable<AmountGraphResultDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AmountGraphResultDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalAmountsGraph(response: HttpResponseBase): Observable<AmountGraphResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AmountGraphResultDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AmountGraphResultDto[]>(<any>null);
    }

    /**
     * Obtiene los totales facturados (Factura Electrónica) mensualmente para los
    últimos seis meses.
     * @return Success
     */
    getMonthlyAmountsGraphData(): Observable<MonthlyAmountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetMonthlyAmountsGraphData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyAmountsGraphData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyAmountsGraphData(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyAmountDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyAmountDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMonthlyAmountsGraphData(response: HttpResponseBase): Observable<MonthlyAmountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthlyAmountDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyAmountDto[]>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getDailyAccountBalanceGraphData(receiverId: number | undefined): Observable<MonthlyAmountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetDailyAccountBalanceGraphData?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyAccountBalanceGraphData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyAccountBalanceGraphData(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyAmountDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyAmountDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyAccountBalanceGraphData(response: HttpResponseBase): Observable<MonthlyAmountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthlyAmountDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyAmountDto[]>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los roles de usuario disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un rol de usuarios, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de régimen.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * Obtiene los roles de usuarios que posean los permisos
    recibidos.
     * @param permission (optional) Permiso que debe poseer el rol para
    ser encontrado.
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleListDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleListDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(<any>null);
    }

    /**
     * Actualiza los datos de un rol de usuarios dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * Elimina un rol de usuarios dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene todos los permisos disponibles para la
    creación o edición de un rol de usuarios.
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(<any>null);
    }

    /**
     * Obtiene los datos de un rol de usuarios, para su edición
    en pantalla.
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class ShoppingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dateFrom (optional) Fecha inicial del listado de compras.
     * @param dateTo (optional) Fecha final del listado de compras .
     * @param clientId (optional) Identificador del cliente específico que se quiere obtener las compras.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllShoppings(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, clientId: number | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShoppingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetAllShoppings?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShoppings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShoppings(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllShoppings(response: HttpResponseBase): Observable<ShoppingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDtoPagedResultDto>(<any>null);
    }

    /**
     * @param clientId (optional) Identificador del cliente específico que se quiere obtener las compras.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllShoppingsByClientId(clientId: number | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShoppingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetAllShoppingsByClientId?";
        if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShoppingsByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShoppingsByClientId(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllShoppingsByClientId(response: HttpResponseBase): Observable<ShoppingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDtoPagedResultDto>(<any>null);
    }

    /**
     * @param shoppingId (optional) 
     * @return Success
     */
    getShoppingById(shoppingId: number | undefined): Observable<ShoppingDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetShoppingById?";
        if (shoppingId === null)
            throw new Error("The parameter 'shoppingId' cannot be null.");
        else if (shoppingId !== undefined)
            url_ += "shoppingId=" + encodeURIComponent("" + shoppingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShoppingById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShoppingById(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetShoppingById(response: HttpResponseBase): Observable<ShoppingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShopping(body: ShoppingDto | undefined): Observable<ShoppingDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/CreateShopping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShopping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShopping(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateShopping(response: HttpResponseBase): Observable<ShoppingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShoppingPayment(body: ShoppingPaymentDto | undefined): Observable<ShoppingPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/CreateShoppingPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShoppingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShoppingPayment(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateShoppingPayment(response: HttpResponseBase): Observable<ShoppingPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingPaymentDto>(<any>null);
    }

    /**
     * @param shoppingPaymentId (optional) 
     * @return Success
     */
    deleteShoppingPayment(shoppingPaymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/DeleteShoppingPayment?";
        if (shoppingPaymentId === null)
            throw new Error("The parameter 'shoppingPaymentId' cannot be null.");
        else if (shoppingPaymentId !== undefined)
            url_ += "shoppingPaymentId=" + encodeURIComponent("" + shoppingPaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShoppingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShoppingPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteShoppingPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    getAllShoppingPaymentsByClientId(clientId: number | undefined): Observable<ShoppingPaymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetAllShoppingPaymentsByClientId?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShoppingPaymentsByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShoppingPaymentsByClientId(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingPaymentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingPaymentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllShoppingPaymentsByClientId(response: HttpResponseBase): Observable<ShoppingPaymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShoppingPaymentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingPaymentDto[]>(<any>null);
    }

    /**
     * @param shoppingId (optional) 
     * @return Success
     */
    getShoppingPaymentByShoppingId(shoppingId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetShoppingPaymentByShoppingId?";
        if (shoppingId === null)
            throw new Error("The parameter 'shoppingId' cannot be null.");
        else if (shoppingId !== undefined)
            url_ += "shoppingId=" + encodeURIComponent("" + shoppingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShoppingPaymentByShoppingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShoppingPaymentByShoppingId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetShoppingPaymentByShoppingId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getTotalPaidByReceiverId(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetTotalPaidByReceiverId?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalPaidByReceiverId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalPaidByReceiverId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalPaidByReceiverId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getTotalAmountDueByReceiverId(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetTotalAmountDueByReceiverId?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountDueByReceiverId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountDueByReceiverId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalAmountDueByReceiverId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param receiverId (optional) 
     * @return Success
     */
    getTotalAmountBeDefeatedByReceiverId(receiverId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetTotalAmountBeDefeatedByReceiverId?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountBeDefeatedByReceiverId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountBeDefeatedByReceiverId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalAmountBeDefeatedByReceiverId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param shoppingId (optional) 
     * @return Success
     */
    getAllShoppingPaymentsByShoppingId(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, shoppingId: number | undefined): Observable<ShoppingPaymentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetAllShoppingPaymentsByShoppingId?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (shoppingId === null)
            throw new Error("The parameter 'shoppingId' cannot be null.");
        else if (shoppingId !== undefined)
            url_ += "shoppingId=" + encodeURIComponent("" + shoppingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShoppingPaymentsByShoppingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShoppingPaymentsByShoppingId(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingPaymentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingPaymentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllShoppingPaymentsByShoppingId(response: HttpResponseBase): Observable<ShoppingPaymentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingPaymentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingPaymentDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ShoppingDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShoppingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShoppingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShoppingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ShoppingDto | undefined): Observable<ShoppingDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShoppingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ShoppingDto | undefined): Observable<ShoppingDto> {
        let url_ = this.baseUrl + "/api/services/app/Shopping/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ShoppingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShoppingDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShoppingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShoppingDto>(<any>null);
    }
}

@Injectable()
export class SignatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Carga el certificado (pfx) para el firmado de las comunicaciones
    con el SIFEN.
     * @param body (optional) Datos de carga del certificado.
     * @return Success
     */
    create(body: CreateSignatureDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Signature/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Obtiene los certificados/firmas que se encuentran
    registrados en la plataforma.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SignatureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Signature/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<SignatureDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignatureDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SignatureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignatureDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un certificado de firma dado su identificador
    en la plataforma.
     * @param signatureId (optional) Identificador del certificado.
     * @return Success
     */
    get(signatureId: number | undefined): Observable<SignatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Signature/Get?";
        if (signatureId === null)
            throw new Error("The parameter 'signatureId' cannot be null.");
        else if (signatureId !== undefined)
            url_ += "signatureId=" + encodeURIComponent("" + signatureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SignatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignatureDto>(<any>null);
    }

    /**
     * Obtiene la última firma cargada en la plataforma.
     * @return Success
     */
    getLatestValidSignature(): Observable<SignatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Signature/GetLatestValidSignature";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestValidSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestValidSignature(<any>response_);
                } catch (e) {
                    return <Observable<SignatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestValidSignature(response: HttpResponseBase): Observable<SignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignatureDto>(<any>null);
    }

    /**
     * Método para actualizar la fecha de vencimiento de las firmas de las empresas activas.
     * @param tenantId (optional) Si recibe un id de una empresa se actualiza solo la firma de esa empresa, sino actualiza todas las empresas.
     * @return Success
     */
    updateExpirationDate(tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Signature/UpdateExpirationDate?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExpirationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExpirationDate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExpirationDate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class SMTPServerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los ajustes del servidor SMTP correspondientes al tenant.
     * @return Success
     */
    get(): Observable<SMTPServerDto> {
        let url_ = this.baseUrl + "/api/services/app/SMTPServer/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SMTPServerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMTPServerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SMTPServerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMTPServerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SMTPServerDto>(<any>null);
    }

    /**
     * Actualiza los ajustes del servidor SMTP correspondientes al tenant.
     * @param body (optional) 
     * @return Success
     */
    update(body: SMTPServerDto | undefined): Observable<SMTPServerDto> {
        let url_ = this.baseUrl + "/api/services/app/SMTPServer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<SMTPServerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMTPServerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SMTPServerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMTPServerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SMTPServerDto>(<any>null);
    }

    /**
     * Actualiza los ajustes del servidor SMTP correspondientes al tenant.
     * @param body (optional) 
     * @return Success
     */
    testServerSettings(body: SMTPServerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SMTPServer/TestServerSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestServerSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestServerSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestServerSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StockServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getAllProductStock(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, productId: number | undefined): Observable<StockDocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAllProductStock?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProductStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductStock(<any>response_);
                } catch (e) {
                    return <Observable<StockDocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockDocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductStock(response: HttpResponseBase): Observable<StockDocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockDocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDocumentDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStock(body: StockDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stock/CreateStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStock(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateStock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dropStock(body: StockDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stock/DropStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDropStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDropStock(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDropStock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StockDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDto>(<any>null);
    }

    /**
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<StockDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: StockDto | undefined): Observable<StockDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<StockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StockDto | undefined): Observable<StockDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<StockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SummariesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene el resumen de datos registrados al momento
    de la plataforma, para conformar el dashboard de la
    aplicación.
     * @return Success
     */
    getSummary(): Observable<SummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Summaries/GetSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(<any>response_);
                } catch (e) {
                    return <Observable<SummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<SummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SummaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTotalDue(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Summaries/GetTotalDue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalDue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalDue(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalDue(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getTotalOverdue(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Summaries/GetTotalOverdue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalOverdue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalOverdue(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalOverdue(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class TaxTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los tipos de impuestos disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TaxTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TaxType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TaxTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaxTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TaxTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un tipo de impuesto, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TaxTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TaxType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TaxTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaxTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TaxTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxTypeDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de impuesto.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: TaxTypeDto | undefined): Observable<TaxTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TaxType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TaxTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaxTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TaxTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de un tipo de impuesto dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: TaxTypeDto | undefined): Observable<TaxTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TaxType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TaxTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaxTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TaxTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxTypeDto>(<any>null);
    }

    /**
     * Elimina un tipo de impuesto dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaxType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los empresas inquilinas disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Pablabra clave de búsqueda.
     * @param isActive (optional) Filtro por estado (activo/inactivo).
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene las últimas 5 empresas inquilinas creadas.
     * @return Success
     */
    getLatestTenants(): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetLatestTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestTenants(<any>response_);
                } catch (e) {
                    return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestTenants(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene una empresa inquilina, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * Crea una nueva empresa inquilina, usuaria de Paranet.
     * @param body (optional) Datos para la creación de la empresa.
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * Actualiza los datos de una empresa inquilina dada.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    updateById(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateById(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateById(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * Elimina una empresa inquilina dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Cambia el estado (activo/inactivo) de la empresa inquilina dada.
     * @param body (optional) Identificador interno de la empresa inquilina.
     * @return Success
     */
    changeStatus(body: Int32EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ChangeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene una empresa inquilina, dado su número de
    RUC.
     * @param ruc (optional) RUC de la empresa buscada.
     * @return Success
     */
    getByRUC(ruc: string | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetByRUC?";
        if (ruc !== undefined)
            url_ += "ruc=" + encodeURIComponent("" + ruc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRUC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRUC(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByRUC(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * Obtiene el logo de la empresa actual.
     * @return Success
     */
    getTenantLogo(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Busca la información de un contribuyente dado
    su número de RUC.
     * @param ruc (optional) Número de RUC del contribuyente.
     * @return Success
     */
    checkCompanyOnSIFEN(ruc: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CheckCompanyOnSIFEN?";
        if (ruc !== undefined)
            url_ += "ruc=" + encodeURIComponent("" + ruc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCompanyOnSIFEN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCompanyOnSIFEN(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCompanyOnSIFEN(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Actualiza la información de la empresa.
     * @param body (optional) Datos de la empresa a actualizar.
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recoverPassword(body: RecoverPasswordModel | undefined): Observable<RecoverPasswordResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/RecoverPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverPassword(<any>response_);
                } catch (e) {
                    return <Observable<RecoverPasswordResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecoverPasswordResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRecoverPassword(response: HttpResponseBase): Observable<RecoverPasswordResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecoverPasswordResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecoverPasswordResultModel>(<any>null);
    }
}

@Injectable()
export class TransactionTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Obtiene los tipos de transacciones disponibles de acuerdo
    a los parámetros de búsqueda y paginado.
     * @param keyword (optional) Palabra clave de búsqueda.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransactionTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TransactionTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TransactionTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * Obtiene un tipo de transacción, dado su identificador
    interno.
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TransactionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TransactionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TransactionTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionTypeDto>(<any>null);
    }

    /**
     * Crea un nuevo tipo de transacción.
     * @param body (optional) Datos para la creación.
     * @return Success
     */
    create(body: TransactionTypeDto | undefined): Observable<TransactionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TransactionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TransactionTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionTypeDto>(<any>null);
    }

    /**
     * Actualiza los datos de un tipo de transacción dado.
     * @param body (optional) Datos para la actualización.
     * @return Success
     */
    update(body: TransactionTypeDto | undefined): Observable<TransactionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TransactionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TransactionTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionTypeDto>(<any>null);
    }

    /**
     * Elimina un tipo de transacción dado un identificador interno.
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tenantRUC (optional) 
     * @return Success
     */
    getUserByTenantRUC(tenantRUC: string | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserByTenantRUC?";
        if (tenantRUC !== undefined)
            url_ += "tenantRUC=" + encodeURIComponent("" + tenantRUC) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByTenantRUC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByTenantRUC(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserByTenantRUC(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class UserBranchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserBranchesByUserId(userId: number | undefined): Observable<UserBranchDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserBranch/GetUserBranchesByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserBranchesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserBranchesByUserId(<any>response_);
                } catch (e) {
                    return <Observable<UserBranchDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserBranchDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserBranchesByUserId(response: HttpResponseBase): Observable<UserBranchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserBranchDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserBranchDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserBranches(body: CreateUserBranchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserBranch/CreateUserBranches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserBranches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUserBranches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUserBranches(userId: number | undefined, tenantId: number | undefined, body: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserBranch/UpdateUserBranches?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserBranches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserBranches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WebhookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Agrega una suscripción al sistema de webhooks.
     * @param body (optional) 
     * @return Success
     */
    addWebhookSubscriptions(body: WebhookSubscriptionDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Webhook/AddWebhookSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWebhookSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWebhookSubscriptions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddWebhookSubscriptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Obtiene todas las suscripciones al sistema de webhooks.
     * @return Success
     */
    getWebhookSubscriptions(): Observable<WebhookSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Webhook/GetWebhookSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebhookSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebhookSubscriptions(<any>response_);
                } catch (e) {
                    return <Observable<WebhookSubscriptionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WebhookSubscriptionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWebhookSubscriptions(response: HttpResponseBase): Observable<WebhookSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WebhookSubscriptionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebhookSubscriptionDto[]>(<any>null);
    }
}

/** Código de resultado de acción "Recuperar Contraseña".<p>Members:</p><ul><li><i>1</i> = Éxito</li><li><i>2</i> = Usuario y RUC no coinciden</li><li><i>3</i> = Formato de contraseña incorrecto</li><li><i>4</i> = Error en envío por email</li></ul> */
export enum RecoverPasswordStatusCode {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** Actividad económica. */
export class ActivityDto implements IActivityDto {
    /** Descripción de la actividad
económica de un emisor.
SIFEN: dDesActEco - D132 */
    name: string;
    /** Código SIFEN de la actividad
económica de un emisor.
SIFEN: cActEco - D131 */
    identifier: string;
    /** Identificador interno en Paranet
de la actividad padre de la misma. */
    parentId: number | undefined;
    id: number;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.parentId = _data["parentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

/** Actividad económica. */
export interface IActivityDto {
    /** Descripción de la actividad
económica de un emisor.
SIFEN: dDesActEco - D132 */
    name: string;
    /** Código SIFEN de la actividad
económica de un emisor.
SIFEN: cActEco - D131 */
    identifier: string;
    /** Identificador interno en Paranet
de la actividad padre de la misma. */
    parentId: number | undefined;
    id: number;
}

export class ActivityDtoPagedResultDto implements IActivityDtoPagedResultDto {
    totalCount: number;
    items: ActivityDto[] | undefined;

    constructor(data?: IActivityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ActivityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDtoPagedResultDto {
    totalCount: number;
    items: ActivityDto[] | undefined;
}

/** Tipo de régimen de una empresa. SIFEN: D104 - cTipReg */
export class RegimeDto implements IRegimeDto {
    /** Nombre del tipo de régimen de la empresa. */
    name: string;
    /** Identificador del tipo de régimen
de la empresa en el SIFEN.
SIFEN: D104 - cTipReg */
    identifier: number;
    id: number;

    constructor(data?: IRegimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegimeDto {
        const json = this.toJSON();
        let result = new RegimeDto();
        result.init(json);
        return result;
    }
}

/** Tipo de régimen de una empresa. SIFEN: D104 - cTipReg */
export interface IRegimeDto {
    /** Nombre del tipo de régimen de la empresa. */
    name: string;
    /** Identificador del tipo de régimen
de la empresa en el SIFEN.
SIFEN: D104 - cTipReg */
    identifier: number;
    id: number;
}

/** Datos asociados a los tipos de documentos con sus respectivos códigos de establecimiento y puntos de expedición. SIFEN: C002 - iTiDE, C005 - dEst, C006 - dPunExp */
export class BranchDocumentTypeDto implements IBranchDocumentTypeDto {
    /** Identificador interno en Paranet de la
sucursal. */
    branchId: number;
    /** Identificador interno en Paranet del
tipo de documento de emisión.
SIFEN: C002 - iTiDE */
    documentTypeId: number;
    /** Nombre del tipo de documento. */
    documentTypeName: string | undefined;
    /** Establecimiento (dato otorgado por el
SIFEN, asociado al tipo de documento y
sucursal, requerido para la emisión de
comprobantes).
SIFEN: C005 - dEst */
    stablishment: string;
    /** Punto de expedición (dato otorgado por el
SIFEN, asociado al tipo de documento y
sucursal, requerido para la emisión de
comprobantes).
SIFEN: C006 - dPunExp */
    expeditionPoint: string;
    id: number;

    constructor(data?: IBranchDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.stablishment = _data["stablishment"];
            this.expeditionPoint = _data["expeditionPoint"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BranchDocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["stablishment"] = this.stablishment;
        data["expeditionPoint"] = this.expeditionPoint;
        data["id"] = this.id;
        return data; 
    }

    clone(): BranchDocumentTypeDto {
        const json = this.toJSON();
        let result = new BranchDocumentTypeDto();
        result.init(json);
        return result;
    }
}

/** Datos asociados a los tipos de documentos con sus respectivos códigos de establecimiento y puntos de expedición. SIFEN: C002 - iTiDE, C005 - dEst, C006 - dPunExp */
export interface IBranchDocumentTypeDto {
    /** Identificador interno en Paranet de la
sucursal. */
    branchId: number;
    /** Identificador interno en Paranet del
tipo de documento de emisión.
SIFEN: C002 - iTiDE */
    documentTypeId: number;
    /** Nombre del tipo de documento. */
    documentTypeName: string | undefined;
    /** Establecimiento (dato otorgado por el
SIFEN, asociado al tipo de documento y
sucursal, requerido para la emisión de
comprobantes).
SIFEN: C005 - dEst */
    stablishment: string;
    /** Punto de expedición (dato otorgado por el
SIFEN, asociado al tipo de documento y
sucursal, requerido para la emisión de
comprobantes).
SIFEN: C006 - dPunExp */
    expeditionPoint: string;
    id: number;
}

/** Datos del departamento. SIFEN: D219 - cDepRec y D220 - dDesDepRec */
export class DepartmentDto implements IDepartmentDto {
    /** Nombre del departamento.
SIFEN: D220 - dDesDepRec */
    name: string;
    /** Código SIFEN identificador del departamento.
SIFEN: D219 - cDepRec */
    identifier: number;
    /** Código SIFEN identificador del país al cual
pertenece el departamento. */
    countryCode: string | undefined;
    id: number;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): DepartmentDto {
        const json = this.toJSON();
        let result = new DepartmentDto();
        result.init(json);
        return result;
    }
}

/** Datos del departamento. SIFEN: D219 - cDepRec y D220 - dDesDepRec */
export interface IDepartmentDto {
    /** Nombre del departamento.
SIFEN: D220 - dDesDepRec */
    name: string;
    /** Código SIFEN identificador del departamento.
SIFEN: D219 - cDepRec */
    identifier: number;
    /** Código SIFEN identificador del país al cual
pertenece el departamento. */
    countryCode: string | undefined;
    id: number;
}

/** Distrito. */
export class DistrictDto implements IDistrictDto {
    /** Nombre del distrito. */
    name: string;
    /** Código SIFEN identificador del distrito. */
    identifier: number;
    /** Código SIFEN identificador del departamento al cual
pertenece el distrito. */
    departmentCode: number;
    department: DepartmentDto;
    id: number;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.departmentCode = _data["departmentCode"];
            this.department = _data["department"] ? DepartmentDto.fromJS(_data["department"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["departmentCode"] = this.departmentCode;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): DistrictDto {
        const json = this.toJSON();
        let result = new DistrictDto();
        result.init(json);
        return result;
    }
}

/** Distrito. */
export interface IDistrictDto {
    /** Nombre del distrito. */
    name: string;
    /** Código SIFEN identificador del distrito. */
    identifier: number;
    /** Código SIFEN identificador del departamento al cual
pertenece el distrito. */
    departmentCode: number;
    department: DepartmentDto;
    id: number;
}

/** Datos de la ciudad. SIFEN: D223 - cCiuRec y D224 - dDesCiuRec */
export class CityDto implements ICityDto {
    /** Nombre de la ciudad.
SIFEN: D224 - dDesCiuRec */
    name: string;
    /** Código SIFEN identificador de la ciudad.
SIFEN: D223 - cCiuRec */
    identifier: number;
    /** Código SIFEN identificador del distrito al cual
pertenece la ciudad. */
    districtCode: number;
    district: DistrictDto;
    id: number;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.districtCode = _data["districtCode"];
            this.district = _data["district"] ? DistrictDto.fromJS(_data["district"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["districtCode"] = this.districtCode;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

/** Datos de la ciudad. SIFEN: D223 - cCiuRec y D224 - dDesCiuRec */
export interface ICityDto {
    /** Nombre de la ciudad.
SIFEN: D224 - dDesCiuRec */
    name: string;
    /** Código SIFEN identificador de la ciudad.
SIFEN: D223 - cCiuRec */
    identifier: number;
    /** Código SIFEN identificador del distrito al cual
pertenece la ciudad. */
    districtCode: number;
    district: DistrictDto;
    id: number;
}

/** Sucursal. */
export class BranchDto implements IBranchDto {
    /** Datos asociados a los tipos de documentos con sus
respectivos códigos de establecimiento y puntos de
expedición.
SIFEN: C002 - iTiDE, C005 - dEst, C006 - dPunExp */
    branchDocumentTypes: BranchDocumentTypeDto[] | undefined;
    /** Dirección del local dónde se emite
el DE.
SIFEN: D107 - dDirEmi */
    address: string;
    /** Número de casa del local dónde se emite
el DE.
SIFEN: D108 - dNumCas */
    houseNumber: number;
    /** Complemento 1 de la dirección del local
de emisión del DE.
SIFEN: D109 - dCompDir1 */
    addressComplement1: string | undefined;
    /** Complemento 2 de la dirección del local
de emisión del DE.
SIFEN: D110 - dCompDir2 */
    addressComplement2: string | undefined;
    /** Código de la ciudad del local de emisión del DE.
SIFEN: D115 - cCiuEmi */
    cityCode: number;
    city: CityDto;
    /** Teléfono del local de emisión del DE.
SIFEN: D117 - dTelEmi */
    phone: string | undefined;
    /** Correo electrónico del local de emisión del DE.
SIFEN: D118 - dEmailE */
    email: string;
    /** Denominación comercial de la sucursal de
emisión del DE (denominación interna).
SIFEN: D119 - dDenSuc */
    name: string;
    /** RUC de la empresa. */
    tenantRUC: string;
    /** Indica si quiere vincular a todos los usuarios a la sucursal. */
    linkAllUsers: boolean;
    id: number;

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchDocumentTypes"])) {
                this.branchDocumentTypes = [] as any;
                for (let item of _data["branchDocumentTypes"])
                    this.branchDocumentTypes.push(BranchDocumentTypeDto.fromJS(item));
            }
            this.address = _data["address"];
            this.houseNumber = _data["houseNumber"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.cityCode = _data["cityCode"];
            this.city = _data["city"] ? CityDto.fromJS(_data["city"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.tenantRUC = _data["tenantRUC"];
            this.linkAllUsers = _data["linkAllUsers"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchDocumentTypes)) {
            data["branchDocumentTypes"] = [];
            for (let item of this.branchDocumentTypes)
                data["branchDocumentTypes"].push(item.toJSON());
        }
        data["address"] = this.address;
        data["houseNumber"] = this.houseNumber;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["cityCode"] = this.cityCode;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["name"] = this.name;
        data["tenantRUC"] = this.tenantRUC;
        data["linkAllUsers"] = this.linkAllUsers;
        data["id"] = this.id;
        return data; 
    }

    clone(): BranchDto {
        const json = this.toJSON();
        let result = new BranchDto();
        result.init(json);
        return result;
    }
}

/** Sucursal. */
export interface IBranchDto {
    /** Datos asociados a los tipos de documentos con sus
respectivos códigos de establecimiento y puntos de
expedición.
SIFEN: C002 - iTiDE, C005 - dEst, C006 - dPunExp */
    branchDocumentTypes: BranchDocumentTypeDto[] | undefined;
    /** Dirección del local dónde se emite
el DE.
SIFEN: D107 - dDirEmi */
    address: string;
    /** Número de casa del local dónde se emite
el DE.
SIFEN: D108 - dNumCas */
    houseNumber: number;
    /** Complemento 1 de la dirección del local
de emisión del DE.
SIFEN: D109 - dCompDir1 */
    addressComplement1: string | undefined;
    /** Complemento 2 de la dirección del local
de emisión del DE.
SIFEN: D110 - dCompDir2 */
    addressComplement2: string | undefined;
    /** Código de la ciudad del local de emisión del DE.
SIFEN: D115 - cCiuEmi */
    cityCode: number;
    city: CityDto;
    /** Teléfono del local de emisión del DE.
SIFEN: D117 - dTelEmi */
    phone: string | undefined;
    /** Correo electrónico del local de emisión del DE.
SIFEN: D118 - dEmailE */
    email: string;
    /** Denominación comercial de la sucursal de
emisión del DE (denominación interna).
SIFEN: D119 - dDenSuc */
    name: string;
    /** RUC de la empresa. */
    tenantRUC: string;
    /** Indica si quiere vincular a todos los usuarios a la sucursal. */
    linkAllUsers: boolean;
    id: number;
}

/** Actividad económica de la empresa. */
export class TenantActivityDto implements ITenantActivityDto {
    /** Identificador interno en Paranet
de la actividad económica.
SIFEN: D131 - cActEco */
    activityId: number;
    activity: ActivityDto;
    id: number;

    constructor(data?: ITenantActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? ActivityDto.fromJS(_data["activity"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantActivityDto {
        const json = this.toJSON();
        let result = new TenantActivityDto();
        result.init(json);
        return result;
    }
}

/** Actividad económica de la empresa. */
export interface ITenantActivityDto {
    /** Identificador interno en Paranet
de la actividad económica.
SIFEN: D131 - cActEco */
    activityId: number;
    activity: ActivityDto;
    id: number;
}

/** Datos de la empresa. */
export class TenantDto implements ITenantDto {
    /** Número del tibrado (dato otorgado por el
SIFEN, asociado al tipo de documento y
sucursal, requerido para la emisión de
comprobantes).
SIFEN: C004 - dNumTim */
    stampNumber: string;
    /** Fecha de inicio de vigencia del
timbrado.
SIFEN: C008 - dFeIniT */
    stampDate: moment.Moment;
    /** RUC del contribuyente emisor.
SIFEN: D101 - dRucEm + d102 - dDVEmi */
    ruc: string;
    /** Tipo de contribuyente.
SIFEN: D103 - iTipCont */
    taxpayerType: number;
    /** Identificador interno en Paranet
del tipo de régimen de la empresa.
SIFEN: D104 - cTipReg */
    regimeId: number | undefined;
    regime: RegimeDto;
    /** Nombre o razón social del emisor.
SIFEN: D105 - dNomEmi */
    tenancyName: string;
    /** Nombre de fantasía de la empresa.
SIFEN: D106 - dNomFanEmi */
    name: string | undefined;
    /** Datos asociados al local/sucursal de dónde
se emiten los DE.
SIFEN: D10X */
    branches: BranchDto[] | undefined;
    /** Bandera indicando si se encuentra o no
activa. */
    isActive: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a la energía eléctrica. */
    deElectricPower: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los segudos. */
    deInsurance: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los supermercados. */
    deSupermarket: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a más información. */
    deInformation: boolean;
    /** Bandera indicando si el total se tiene que redondear. */
    totalMultipleOfFifTy: boolean;
    /** Actividades económicas que posee la
empresa. */
    activities: TenantActivityDto[] | undefined;
    /** Fecha de alta/creación en Paranet. */
    creationTime: moment.Moment;
    /** Identificador correspondiente al CSC del Tenant. */
    idCSC: string;
    /** CSC del Tenant. */
    csc: string;
    maxDaysWithoutInvoicing: number;
    notificationFrequencyDays: number;
    /** Bandera indicando si se envían correos de las facturas emitadas a los clientes */
    sendInvoicesCustomersViaEmail: boolean;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stampNumber = _data["stampNumber"];
            this.stampDate = _data["stampDate"] ? moment(_data["stampDate"].toString()) : <any>undefined;
            this.ruc = _data["ruc"];
            this.taxpayerType = _data["taxpayerType"];
            this.regimeId = _data["regimeId"];
            this.regime = _data["regime"] ? RegimeDto.fromJS(_data["regime"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches.push(BranchDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.deElectricPower = _data["deElectricPower"];
            this.deInsurance = _data["deInsurance"];
            this.deSupermarket = _data["deSupermarket"];
            this.deInformation = _data["deInformation"];
            this.totalMultipleOfFifTy = _data["totalMultipleOfFifTy"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(TenantActivityDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.idCSC = _data["idCSC"];
            this.csc = _data["csc"];
            this.maxDaysWithoutInvoicing = _data["maxDaysWithoutInvoicing"];
            this.notificationFrequencyDays = _data["notificationFrequencyDays"];
            this.sendInvoicesCustomersViaEmail = _data["sendInvoicesCustomersViaEmail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stampNumber"] = this.stampNumber;
        data["stampDate"] = this.stampDate ? this.stampDate.toISOString() : <any>undefined;
        data["ruc"] = this.ruc;
        data["taxpayerType"] = this.taxpayerType;
        data["regimeId"] = this.regimeId;
        data["regime"] = this.regime ? this.regime.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["deElectricPower"] = this.deElectricPower;
        data["deInsurance"] = this.deInsurance;
        data["deSupermarket"] = this.deSupermarket;
        data["deInformation"] = this.deInformation;
        data["totalMultipleOfFifTy"] = this.totalMultipleOfFifTy;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["idCSC"] = this.idCSC;
        data["csc"] = this.csc;
        data["maxDaysWithoutInvoicing"] = this.maxDaysWithoutInvoicing;
        data["notificationFrequencyDays"] = this.notificationFrequencyDays;
        data["sendInvoicesCustomersViaEmail"] = this.sendInvoicesCustomersViaEmail;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

/** Datos de la empresa. */
export interface ITenantDto {
    /** Número del tibrado (dato otorgado por el
SIFEN, asociado al tipo de documento y
sucursal, requerido para la emisión de
comprobantes).
SIFEN: C004 - dNumTim */
    stampNumber: string;
    /** Fecha de inicio de vigencia del
timbrado.
SIFEN: C008 - dFeIniT */
    stampDate: moment.Moment;
    /** RUC del contribuyente emisor.
SIFEN: D101 - dRucEm + d102 - dDVEmi */
    ruc: string;
    /** Tipo de contribuyente.
SIFEN: D103 - iTipCont */
    taxpayerType: number;
    /** Identificador interno en Paranet
del tipo de régimen de la empresa.
SIFEN: D104 - cTipReg */
    regimeId: number | undefined;
    regime: RegimeDto;
    /** Nombre o razón social del emisor.
SIFEN: D105 - dNomEmi */
    tenancyName: string;
    /** Nombre de fantasía de la empresa.
SIFEN: D106 - dNomFanEmi */
    name: string | undefined;
    /** Datos asociados al local/sucursal de dónde
se emiten los DE.
SIFEN: D10X */
    branches: BranchDto[] | undefined;
    /** Bandera indicando si se encuentra o no
activa. */
    isActive: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a la energía eléctrica. */
    deElectricPower: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los segudos. */
    deInsurance: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los supermercados. */
    deSupermarket: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a más información. */
    deInformation: boolean;
    /** Bandera indicando si el total se tiene que redondear. */
    totalMultipleOfFifTy: boolean;
    /** Actividades económicas que posee la
empresa. */
    activities: TenantActivityDto[] | undefined;
    /** Fecha de alta/creación en Paranet. */
    creationTime: moment.Moment;
    /** Identificador correspondiente al CSC del Tenant. */
    idCSC: string;
    /** CSC del Tenant. */
    csc: string;
    maxDaysWithoutInvoicing: number;
    notificationFrequencyDays: number;
    /** Bandera indicando si se envían correos de las facturas emitadas a los clientes */
    sendInvoicesCustomersViaEmail: boolean;
    id: number;
}

/** Grupo de campos que identifican al responsable de la generación de los DE. SIFEN: D140 - gRespDE */
export class UserDto implements IUserDto {
    /** Código SIFEN del tipo de documento de
identidad del responsable de la generación
del DE.
SIFEN: D141 - iTipIDRespDE */
    identityDocumentTypeCode: number | undefined;
    /** Número de documento de identidad del responsable
de la generación del DE.
SIFEN: D143 - dNumIDRespDE */
    identityDocumentNumber: string | undefined;
    /** Nombre del responsable de la generación
del DE.
SIFEN: D144 - dNomRespDE */
    name: string;
    /** Apellido del responsable de la generación
del DE.
SIFEN: D144 - dNomRespDE */
    surname: string;
    /** Nombre y apellido del responsable de la generación
del DE.
SIFEN: D144 - dNomRespDE */
    fullName: string | undefined;
    /** Cargo del responsable de la generación
del DE.
SIFEN: D145 - dCarRespDE */
    position: string | undefined;
    /** Nombre de usuario para realizar
la autenticación en Paranet. */
    userName: string;
    /** Contraseña de usuario para realizar
la autenticación en Paranet. */
    password: string | undefined;
    /** Dirección de correo electrónico del
responsable de la generación del DE. */
    emailAddress: string;
    /** Bandera indicando si el usuario se
encuentra activo para operar en Paranet. */
    isActive: boolean;
    /** Última fecha de autenticación del
usuario. */
    lastLoginTime: moment.Moment | undefined;
    /** Fecha de creación en Paranet
del usuario. */
    creationTime: moment.Moment;
    /** Roles de permisos que posee el usuario. */
    roleNames: string[] | undefined;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityDocumentTypeCode = _data["identityDocumentTypeCode"];
            this.identityDocumentNumber = _data["identityDocumentNumber"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityDocumentTypeCode"] = this.identityDocumentTypeCode;
        data["identityDocumentNumber"] = this.identityDocumentNumber;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

/** Grupo de campos que identifican al responsable de la generación de los DE. SIFEN: D140 - gRespDE */
export interface IUserDto {
    /** Código SIFEN del tipo de documento de
identidad del responsable de la generación
del DE.
SIFEN: D141 - iTipIDRespDE */
    identityDocumentTypeCode: number | undefined;
    /** Número de documento de identidad del responsable
de la generación del DE.
SIFEN: D143 - dNumIDRespDE */
    identityDocumentNumber: string | undefined;
    /** Nombre del responsable de la generación
del DE.
SIFEN: D144 - dNomRespDE */
    name: string;
    /** Apellido del responsable de la generación
del DE.
SIFEN: D144 - dNomRespDE */
    surname: string;
    /** Nombre y apellido del responsable de la generación
del DE.
SIFEN: D144 - dNomRespDE */
    fullName: string | undefined;
    /** Cargo del responsable de la generación
del DE.
SIFEN: D145 - dCarRespDE */
    position: string | undefined;
    /** Nombre de usuario para realizar
la autenticación en Paranet. */
    userName: string;
    /** Contraseña de usuario para realizar
la autenticación en Paranet. */
    password: string | undefined;
    /** Dirección de correo electrónico del
responsable de la generación del DE. */
    emailAddress: string;
    /** Bandera indicando si el usuario se
encuentra activo para operar en Paranet. */
    isActive: boolean;
    /** Última fecha de autenticación del
usuario. */
    lastLoginTime: moment.Moment | undefined;
    /** Fecha de creación en Paranet
del usuario. */
    creationTime: moment.Moment;
    /** Roles de permisos que posee el usuario. */
    roleNames: string[] | undefined;
    id: number;
}

/** Entrada de auditoría, representando una acción ejecutada contra la API. */
export class AuditLogDto implements IAuditLogDto {
    /** Fecha y hora de ejecución de la acción. */
    executionTime: moment.Moment;
    /** Id del usuario para casos de impersonificación. */
    impersonatorUserId: number | undefined;
    /** Detalles de la excepción ocurrida (en caso
de que existiese). */
    exception: string | undefined;
    /** Información del navegador consultante. */
    browserInfo: string | undefined;
    /** Nombre del navegador utilizado. */
    clientName: string | undefined;
    /** Dirección IP del cliente que realizó
la consulta a la API. */
    clientIpAddress: string | undefined;
    /** Duracíón (en segundos) de la ejecución. */
    executionDuration: number;
    /** Resultado de la invocación (en caso de que
hubiese alguna). */
    returnValue: string | undefined;
    /** Identificador interno de la empresa que
ejecuta la acción. */
    tenantId: number | undefined;
    tenant: TenantDto;
    /** Nombre de la operación invocada. */
    methodName: string | undefined;
    /** Nombre del servicio invocado. */
    serviceName: string | undefined;
    user: UserDto;
    /** Identificador interno del usuario que
realiza la invocación. */
    userId: number | undefined;
    /** Identificador interno de la empresa para
casos de impersonificación. */
    impersonatorTenantId: number | undefined;
    /** Parámetros de invocación. */
    parameters: string | undefined;
    /** Datos extra registrados durante la
invocación. */
    customData: string | undefined;
    id: number;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.exception = _data["exception"];
            this.browserInfo = _data["browserInfo"];
            this.clientName = _data["clientName"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.executionDuration = _data["executionDuration"];
            this.returnValue = _data["returnValue"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.methodName = _data["methodName"];
            this.serviceName = _data["serviceName"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.parameters = _data["parameters"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["exception"] = this.exception;
        data["browserInfo"] = this.browserInfo;
        data["clientName"] = this.clientName;
        data["clientIpAddress"] = this.clientIpAddress;
        data["executionDuration"] = this.executionDuration;
        data["returnValue"] = this.returnValue;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["methodName"] = this.methodName;
        data["serviceName"] = this.serviceName;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["parameters"] = this.parameters;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }

    clone(): AuditLogDto {
        const json = this.toJSON();
        let result = new AuditLogDto();
        result.init(json);
        return result;
    }
}

/** Entrada de auditoría, representando una acción ejecutada contra la API. */
export interface IAuditLogDto {
    /** Fecha y hora de ejecución de la acción. */
    executionTime: moment.Moment;
    /** Id del usuario para casos de impersonificación. */
    impersonatorUserId: number | undefined;
    /** Detalles de la excepción ocurrida (en caso
de que existiese). */
    exception: string | undefined;
    /** Información del navegador consultante. */
    browserInfo: string | undefined;
    /** Nombre del navegador utilizado. */
    clientName: string | undefined;
    /** Dirección IP del cliente que realizó
la consulta a la API. */
    clientIpAddress: string | undefined;
    /** Duracíón (en segundos) de la ejecución. */
    executionDuration: number;
    /** Resultado de la invocación (en caso de que
hubiese alguna). */
    returnValue: string | undefined;
    /** Identificador interno de la empresa que
ejecuta la acción. */
    tenantId: number | undefined;
    tenant: TenantDto;
    /** Nombre de la operación invocada. */
    methodName: string | undefined;
    /** Nombre del servicio invocado. */
    serviceName: string | undefined;
    user: UserDto;
    /** Identificador interno del usuario que
realiza la invocación. */
    userId: number | undefined;
    /** Identificador interno de la empresa para
casos de impersonificación. */
    impersonatorTenantId: number | undefined;
    /** Parámetros de invocación. */
    parameters: string | undefined;
    /** Datos extra registrados durante la
invocación. */
    customData: string | undefined;
    id: number;
}

export class AuditLogDtoPagedResultDto implements IAuditLogDtoPagedResultDto {
    totalCount: number;
    items: AuditLogDto[] | undefined;

    constructor(data?: IAuditLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AuditLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AuditLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogDtoPagedResultDto {
    totalCount: number;
    items: AuditLogDto[] | undefined;
}

export class BranchDtoPagedResultDto implements IBranchDtoPagedResultDto {
    totalCount: number;
    items: BranchDto[] | undefined;

    constructor(data?: IBranchDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BranchDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BranchDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBranchDtoPagedResultDto {
    totalCount: number;
    items: BranchDto[] | undefined;
}

/** Tarjeta de crédito. */
export class CardTypeDto implements ICardTypeDto {
    /** Nombre de la tarjeta de crédito. */
    name: string;
    /** Identificador de la tarjeta de crédito en
el SIFEN. */
    identifier: number;
    id: number;

    constructor(data?: ICardTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CardTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): CardTypeDto {
        const json = this.toJSON();
        let result = new CardTypeDto();
        result.init(json);
        return result;
    }
}

/** Tarjeta de crédito. */
export interface ICardTypeDto {
    /** Nombre de la tarjeta de crédito. */
    name: string;
    /** Identificador de la tarjeta de crédito en
el SIFEN. */
    identifier: number;
    id: number;
}

export class CardTypeDtoPagedResultDto implements ICardTypeDtoPagedResultDto {
    totalCount: number;
    items: CardTypeDto[] | undefined;

    constructor(data?: ICardTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CardTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CardTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CardTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICardTypeDtoPagedResultDto {
    totalCount: number;
    items: CardTypeDto[] | undefined;
}

export class CityDtoPagedResultDto implements ICityDtoPagedResultDto {
    totalCount: number;
    items: CityDto[] | undefined;

    constructor(data?: ICityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICityDtoPagedResultDto {
    totalCount: number;
    items: CityDto[] | undefined;
}

/** Datos del País. SIFEN: D204 - dDesPaisRe */
export class CountryDto implements ICountryDto {
    /** Nombre del país.
SIFEN: D204 - dDesPaisRe */
    name: string;
    /** Código identificador del país.
SIFEN: D203 - cPaisRec */
    identifier: string;
    id: number;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): CountryDto {
        const json = this.toJSON();
        let result = new CountryDto();
        result.init(json);
        return result;
    }
}

/** Datos del País. SIFEN: D204 - dDesPaisRe */
export interface ICountryDto {
    /** Nombre del país.
SIFEN: D204 - dDesPaisRe */
    name: string;
    /** Código identificador del país.
SIFEN: D203 - cPaisRec */
    identifier: string;
    id: number;
}

export class CountryDtoPagedResultDto implements ICountryDtoPagedResultDto {
    totalCount: number;
    items: CountryDto[] | undefined;

    constructor(data?: ICountryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CountryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CountryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDtoPagedResultDto {
    totalCount: number;
    items: CountryDto[] | undefined;
}

/** Motivo de emisión de la nota de crédito. */
export class CreditNoteReasonDto implements ICreditNoteReasonDto {
    /** Nombre/descripción del motivo. */
    name: string;
    /** Identificador utilizado por el SIFEN. */
    identifier: number;
    id: number;

    constructor(data?: ICreditNoteReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreditNoteReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreditNoteReasonDto {
        const json = this.toJSON();
        let result = new CreditNoteReasonDto();
        result.init(json);
        return result;
    }
}

/** Motivo de emisión de la nota de crédito. */
export interface ICreditNoteReasonDto {
    /** Nombre/descripción del motivo. */
    name: string;
    /** Identificador utilizado por el SIFEN. */
    identifier: number;
    id: number;
}

export class CreditNoteReasonDtoPagedResultDto implements ICreditNoteReasonDtoPagedResultDto {
    totalCount: number;
    items: CreditNoteReasonDto[] | undefined;

    constructor(data?: ICreditNoteReasonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CreditNoteReasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreditNoteReasonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteReasonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreditNoteReasonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CreditNoteReasonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICreditNoteReasonDtoPagedResultDto {
    totalCount: number;
    items: CreditNoteReasonDto[] | undefined;
}

/** Moneda de la operación. SIFEN: D015 - cMoneOpe */
export class CurrencyTypeDto implements ICurrencyTypeDto {
    /** Descripción de la moneda.
SIFEN: D016 - dDesMoneOpe */
    currency: string;
    /** Identificador de la moneda (ISO 4217)
en SIFEN.
SIFEN: D015 - cMoneOpe */
    code: string;
    /** Bandera indicando si la moneda
se encuentra activa o no en Paranet. */
    isActive: boolean;
    id: number;

    constructor(data?: ICurrencyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurrencyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): CurrencyTypeDto {
        const json = this.toJSON();
        let result = new CurrencyTypeDto();
        result.init(json);
        return result;
    }
}

/** Moneda de la operación. SIFEN: D015 - cMoneOpe */
export interface ICurrencyTypeDto {
    /** Descripción de la moneda.
SIFEN: D016 - dDesMoneOpe */
    currency: string;
    /** Identificador de la moneda (ISO 4217)
en SIFEN.
SIFEN: D015 - cMoneOpe */
    code: string;
    /** Bandera indicando si la moneda
se encuentra activa o no en Paranet. */
    isActive: boolean;
    id: number;
}

export class CurrencyTypeDtoPagedResultDto implements ICurrencyTypeDtoPagedResultDto {
    totalCount: number;
    items: CurrencyTypeDto[] | undefined;

    constructor(data?: ICurrencyTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CurrencyTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrencyTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CurrencyTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CurrencyTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyTypeDtoPagedResultDto {
    totalCount: number;
    items: CurrencyTypeDto[] | undefined;
}

/** <p>Members:</p><ul><li><i>1</i> = Enviado</li><li><i>2</i> = Aprobado</li><li><i>3</i> = Observado</li><li><i>4</i> = Rechazado</li><li><i>5</i> = Cancelado</li><li><i>6</i> = Error</li><li><i>7</i> = Otro</li><li><i>8</i> = Procesado</li><li><i>9</i> = Error de conexión</li></ul> */
export enum DocumentStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

/** <p>Members:</p><ul><li><i>1</i> = No contribuyente</li><li><i>2</i> = Extranjero</li></ul> */
export enum SellerNatureType {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Emisor de la factura</li><li><i>2</i> = Poseedor de la factura y bienes</li><li><i>3</i> = Empresa transportista</li><li><i>4</i> = Despachante de Aduanas</li><li><i>5</i> = Agente de transporte o intermediario</li></ul> */
export enum RemissionNoteResponsible {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** <p>Members:</p><ul><li><i>1</i> = Contado</li><li><i>2</i> = Crédito</li></ul> */
export enum OperationCondition {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Normal</li><li><i>2</i> = Contingencia</li></ul> */
export enum IssuingType {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Anticipo Global</li><li><i>2</i> = Anticipo por Ítem</li></ul> */
export enum AdvanceConditionEnum {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Contribuyente</li><li><i>2</i> = No Contribuyente</li></ul> */
export enum NatureType {
    _1 = 1,
    _2 = 2,
}

export class DefaultElectronicDocumentDataDto implements IDefaultElectronicDocumentDataDto {
    /** Código de Control */
    cdc: string | undefined;
    /** Identificador de cliente. */
    clientId: number;
    /** Fecha de emisión (por defecto, la actual). */
    issuedDate: moment.Moment;
    /** Número del documento. */
    number: number;
    /** Código de seguridad. */
    securityCode: string | undefined;
    statusId: DocumentStatus;
    /** Fecha de aprobación en SIFEN. */
    approvedDate: moment.Moment | undefined;
    /** Mensaje de estado. */
    statusMessage: string | undefined;
    /** Tipo de documento. */
    documentTypeCode: number | undefined;
    /** Código de transacción. */
    transactionTypeCode: number | undefined;
    sellerNatureTypeId: SellerNatureType;
    /** Código de ciudad dónde ocurre la transacción. */
    transactionCityCode: number | undefined;
    /** Nombre de la ciudad dónde ocurre la transacción. */
    transactionCityName: string | undefined;
    /** ID de distrito dónde ocurre la transacción. */
    transactionDistrictId: number | undefined;
    /** Nombre del distrito dónde ocurre la transacción. */
    transactionDistrictName: string | undefined;
    /** ID de departamento dónde ocurre la transacción. */
    transactionDepartmentId: number | undefined;
    /** Departamento dónde ocurre al transacción. */
    transactionDepartmentName: string | undefined;
    /** Lugar de la transacción (dirección dónde se provee el servicio/producto) */
    transactionPlace: string | undefined;
    creditNoteReasonCode: number | undefined;
    remissionNoteReasonCode: number | undefined;
    customRemissionReason: string | undefined;
    estimatedKilometersOfTravel: number | undefined;
    futureDateOfInvoiceIssue: moment.Moment | undefined;
    remissionNoteResponsible: RemissionNoteResponsible;
    operationCondition: OperationCondition;
    taxTypeCode: number | undefined;
    issuingType: IssuingType;
    series: string | undefined;
    currencyTypeCode: string | undefined;
    exchangeRateCondition: number | undefined;
    advanceCondition: AdvanceConditionEnum;
    exchangeRate: number | undefined;
    subTotal: number;
    total: number;
    tax: number;
    branchId: number | undefined;
    tenantId: number | undefined;
    presenceIndicatorCode: number | undefined;
    dateOfShipment: moment.Moment | undefined;
    modality: string | undefined;
    entity: number | undefined;
    year: number | undefined;
    sequence: number | undefined;
    aditionalInformation: string | undefined;
    aditionalTreasuryInformation: string | undefined;
    contractingDate: moment.Moment | undefined;
    electronicDocumentBulkId: number | undefined;
    qrCode: string | undefined;
    paymentMethodCode: string | undefined;
    paymentProcessorOption: string | undefined;
    addenda: string | undefined;
    carrierNatureType: NatureType;
    carrierName: string | undefined;
    carrierRUC: string | undefined;
    carrierIdentityDocumentTypeCode: number | undefined;
    carrierNationalityCountryCode: string | undefined;
    carrierAddress: string | undefined;
    driverDocumentNumber: string | undefined;
    driverNameAndLastName: string | undefined;
    driverAddress: string | undefined;
    agentName: string | undefined;
    agentRUC: string | undefined;
    agentAddress: string | undefined;
    id: number;

    constructor(data?: IDefaultElectronicDocumentDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cdc = _data["cdc"];
            this.clientId = _data["clientId"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.securityCode = _data["securityCode"];
            this.statusId = _data["statusId"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.statusMessage = _data["statusMessage"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.transactionTypeCode = _data["transactionTypeCode"];
            this.sellerNatureTypeId = _data["sellerNatureTypeId"];
            this.transactionCityCode = _data["transactionCityCode"];
            this.transactionCityName = _data["transactionCityName"];
            this.transactionDistrictId = _data["transactionDistrictId"];
            this.transactionDistrictName = _data["transactionDistrictName"];
            this.transactionDepartmentId = _data["transactionDepartmentId"];
            this.transactionDepartmentName = _data["transactionDepartmentName"];
            this.transactionPlace = _data["transactionPlace"];
            this.creditNoteReasonCode = _data["creditNoteReasonCode"];
            this.remissionNoteReasonCode = _data["remissionNoteReasonCode"];
            this.customRemissionReason = _data["customRemissionReason"];
            this.estimatedKilometersOfTravel = _data["estimatedKilometersOfTravel"];
            this.futureDateOfInvoiceIssue = _data["futureDateOfInvoiceIssue"] ? moment(_data["futureDateOfInvoiceIssue"].toString()) : <any>undefined;
            this.remissionNoteResponsible = _data["remissionNoteResponsible"];
            this.operationCondition = _data["operationCondition"];
            this.taxTypeCode = _data["taxTypeCode"];
            this.issuingType = _data["issuingType"];
            this.series = _data["series"];
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.exchangeRateCondition = _data["exchangeRateCondition"];
            this.advanceCondition = _data["advanceCondition"];
            this.exchangeRate = _data["exchangeRate"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.tax = _data["tax"];
            this.branchId = _data["branchId"];
            this.tenantId = _data["tenantId"];
            this.presenceIndicatorCode = _data["presenceIndicatorCode"];
            this.dateOfShipment = _data["dateOfShipment"] ? moment(_data["dateOfShipment"].toString()) : <any>undefined;
            this.modality = _data["modality"];
            this.entity = _data["entity"];
            this.year = _data["year"];
            this.sequence = _data["sequence"];
            this.aditionalInformation = _data["aditionalInformation"];
            this.aditionalTreasuryInformation = _data["aditionalTreasuryInformation"];
            this.contractingDate = _data["contractingDate"] ? moment(_data["contractingDate"].toString()) : <any>undefined;
            this.electronicDocumentBulkId = _data["electronicDocumentBulkId"];
            this.qrCode = _data["qrCode"];
            this.paymentMethodCode = _data["paymentMethodCode"];
            this.paymentProcessorOption = _data["paymentProcessorOption"];
            this.addenda = _data["addenda"];
            this.carrierNatureType = _data["carrierNatureType"];
            this.carrierName = _data["carrierName"];
            this.carrierRUC = _data["carrierRUC"];
            this.carrierIdentityDocumentTypeCode = _data["carrierIdentityDocumentTypeCode"];
            this.carrierNationalityCountryCode = _data["carrierNationalityCountryCode"];
            this.carrierAddress = _data["carrierAddress"];
            this.driverDocumentNumber = _data["driverDocumentNumber"];
            this.driverNameAndLastName = _data["driverNameAndLastName"];
            this.driverAddress = _data["driverAddress"];
            this.agentName = _data["agentName"];
            this.agentRUC = _data["agentRUC"];
            this.agentAddress = _data["agentAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DefaultElectronicDocumentDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultElectronicDocumentDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cdc"] = this.cdc;
        data["clientId"] = this.clientId;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["securityCode"] = this.securityCode;
        data["statusId"] = this.statusId;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["statusMessage"] = this.statusMessage;
        data["documentTypeCode"] = this.documentTypeCode;
        data["transactionTypeCode"] = this.transactionTypeCode;
        data["sellerNatureTypeId"] = this.sellerNatureTypeId;
        data["transactionCityCode"] = this.transactionCityCode;
        data["transactionCityName"] = this.transactionCityName;
        data["transactionDistrictId"] = this.transactionDistrictId;
        data["transactionDistrictName"] = this.transactionDistrictName;
        data["transactionDepartmentId"] = this.transactionDepartmentId;
        data["transactionDepartmentName"] = this.transactionDepartmentName;
        data["transactionPlace"] = this.transactionPlace;
        data["creditNoteReasonCode"] = this.creditNoteReasonCode;
        data["remissionNoteReasonCode"] = this.remissionNoteReasonCode;
        data["customRemissionReason"] = this.customRemissionReason;
        data["estimatedKilometersOfTravel"] = this.estimatedKilometersOfTravel;
        data["futureDateOfInvoiceIssue"] = this.futureDateOfInvoiceIssue ? this.futureDateOfInvoiceIssue.toISOString() : <any>undefined;
        data["remissionNoteResponsible"] = this.remissionNoteResponsible;
        data["operationCondition"] = this.operationCondition;
        data["taxTypeCode"] = this.taxTypeCode;
        data["issuingType"] = this.issuingType;
        data["series"] = this.series;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["exchangeRateCondition"] = this.exchangeRateCondition;
        data["advanceCondition"] = this.advanceCondition;
        data["exchangeRate"] = this.exchangeRate;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["tax"] = this.tax;
        data["branchId"] = this.branchId;
        data["tenantId"] = this.tenantId;
        data["presenceIndicatorCode"] = this.presenceIndicatorCode;
        data["dateOfShipment"] = this.dateOfShipment ? this.dateOfShipment.toISOString() : <any>undefined;
        data["modality"] = this.modality;
        data["entity"] = this.entity;
        data["year"] = this.year;
        data["sequence"] = this.sequence;
        data["aditionalInformation"] = this.aditionalInformation;
        data["aditionalTreasuryInformation"] = this.aditionalTreasuryInformation;
        data["contractingDate"] = this.contractingDate ? this.contractingDate.toISOString() : <any>undefined;
        data["electronicDocumentBulkId"] = this.electronicDocumentBulkId;
        data["qrCode"] = this.qrCode;
        data["paymentMethodCode"] = this.paymentMethodCode;
        data["paymentProcessorOption"] = this.paymentProcessorOption;
        data["addenda"] = this.addenda;
        data["carrierNatureType"] = this.carrierNatureType;
        data["carrierName"] = this.carrierName;
        data["carrierRUC"] = this.carrierRUC;
        data["carrierIdentityDocumentTypeCode"] = this.carrierIdentityDocumentTypeCode;
        data["carrierNationalityCountryCode"] = this.carrierNationalityCountryCode;
        data["carrierAddress"] = this.carrierAddress;
        data["driverDocumentNumber"] = this.driverDocumentNumber;
        data["driverNameAndLastName"] = this.driverNameAndLastName;
        data["driverAddress"] = this.driverAddress;
        data["agentName"] = this.agentName;
        data["agentRUC"] = this.agentRUC;
        data["agentAddress"] = this.agentAddress;
        data["id"] = this.id;
        return data; 
    }

    clone(): DefaultElectronicDocumentDataDto {
        const json = this.toJSON();
        let result = new DefaultElectronicDocumentDataDto();
        result.init(json);
        return result;
    }
}

export interface IDefaultElectronicDocumentDataDto {
    /** Código de Control */
    cdc: string | undefined;
    /** Identificador de cliente. */
    clientId: number;
    /** Fecha de emisión (por defecto, la actual). */
    issuedDate: moment.Moment;
    /** Número del documento. */
    number: number;
    /** Código de seguridad. */
    securityCode: string | undefined;
    statusId: DocumentStatus;
    /** Fecha de aprobación en SIFEN. */
    approvedDate: moment.Moment | undefined;
    /** Mensaje de estado. */
    statusMessage: string | undefined;
    /** Tipo de documento. */
    documentTypeCode: number | undefined;
    /** Código de transacción. */
    transactionTypeCode: number | undefined;
    sellerNatureTypeId: SellerNatureType;
    /** Código de ciudad dónde ocurre la transacción. */
    transactionCityCode: number | undefined;
    /** Nombre de la ciudad dónde ocurre la transacción. */
    transactionCityName: string | undefined;
    /** ID de distrito dónde ocurre la transacción. */
    transactionDistrictId: number | undefined;
    /** Nombre del distrito dónde ocurre la transacción. */
    transactionDistrictName: string | undefined;
    /** ID de departamento dónde ocurre la transacción. */
    transactionDepartmentId: number | undefined;
    /** Departamento dónde ocurre al transacción. */
    transactionDepartmentName: string | undefined;
    /** Lugar de la transacción (dirección dónde se provee el servicio/producto) */
    transactionPlace: string | undefined;
    creditNoteReasonCode: number | undefined;
    remissionNoteReasonCode: number | undefined;
    customRemissionReason: string | undefined;
    estimatedKilometersOfTravel: number | undefined;
    futureDateOfInvoiceIssue: moment.Moment | undefined;
    remissionNoteResponsible: RemissionNoteResponsible;
    operationCondition: OperationCondition;
    taxTypeCode: number | undefined;
    issuingType: IssuingType;
    series: string | undefined;
    currencyTypeCode: string | undefined;
    exchangeRateCondition: number | undefined;
    advanceCondition: AdvanceConditionEnum;
    exchangeRate: number | undefined;
    subTotal: number;
    total: number;
    tax: number;
    branchId: number | undefined;
    tenantId: number | undefined;
    presenceIndicatorCode: number | undefined;
    dateOfShipment: moment.Moment | undefined;
    modality: string | undefined;
    entity: number | undefined;
    year: number | undefined;
    sequence: number | undefined;
    aditionalInformation: string | undefined;
    aditionalTreasuryInformation: string | undefined;
    contractingDate: moment.Moment | undefined;
    electronicDocumentBulkId: number | undefined;
    qrCode: string | undefined;
    paymentMethodCode: string | undefined;
    paymentProcessorOption: string | undefined;
    addenda: string | undefined;
    carrierNatureType: NatureType;
    carrierName: string | undefined;
    carrierRUC: string | undefined;
    carrierIdentityDocumentTypeCode: number | undefined;
    carrierNationalityCountryCode: string | undefined;
    carrierAddress: string | undefined;
    driverDocumentNumber: string | undefined;
    driverNameAndLastName: string | undefined;
    driverAddress: string | undefined;
    agentName: string | undefined;
    agentRUC: string | undefined;
    agentAddress: string | undefined;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Producto</li><li><i>2</i> = Servicio</li></ul> */
export enum ProductService {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Gravado IVA</li><li><i>2</i> = Exonerado (Art. 100 - Ley 6380/2019)</li><li><i>3</i> = Exento</li><li><i>4</i> = Gravado parcial (Grav-Exento)</li></ul> */
export enum TaxImpact {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** <p>Members:</p><ul><li><i>0</i> = 0%</li><li><i>5</i> = 5%</li><li><i>10</i> = 10%</li></ul> */
export enum TaxEnum {
    _0 = 0,
    _5 = 5,
    _10 = 10,
}

export class DefaultProductDataDto implements IDefaultProductDataDto {
    /** Descripción o detalles del producto/servicio. */
    description: string | undefined;
    /** Nombre del producto/servicio. */
    name: string | undefined;
    /** Identificador interno de la unidad de medida. */
    measurementUnitId: number;
    tariffHeading: number | undefined;
    /** NCM (Nomenclatura Común del Mercosur) del producto. */
    mercosurNomenclature: number | undefined;
    /** Código emitido por la DNCP. */
    generalDNCPCode: string | undefined;
    /** Código específico emitido por la DNCP. */
    specificDNCPCode: string | undefined;
    /** Código GTIN del producto */
    productGTIN: number | undefined;
    /** País de origen del producto. */
    productCountryId: number | undefined;
    /** Identificador interno de la moneda en la que se
comerciliza el producto. */
    currencyTypeId: number;
    /** Precio del producto (acorde a la moneda seleccionada). */
    price: number;
    productService: ProductService;
    /** Cantidad/Stock del producto. */
    stock: number;
    /** Precio unitario del producto con impuestos. */
    unitPriceWithTax: number | undefined;
    /** Tipo de cambio del precio del producto. */
    itemExchangeRate: number | undefined;
    taxImpact: TaxImpact;
    /** Proporción gravada de IVA del producto/servicio.
Corresponde al porcentaje (%) gravado. */
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    /** Bandera indicando si el producto es un vehículo
o no. */
    isVehicle: boolean;
    id: number;

    constructor(data?: IDefaultProductDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.name = _data["name"];
            this.measurementUnitId = _data["measurementUnitId"];
            this.tariffHeading = _data["tariffHeading"];
            this.mercosurNomenclature = _data["mercosurNomenclature"];
            this.generalDNCPCode = _data["generalDNCPCode"];
            this.specificDNCPCode = _data["specificDNCPCode"];
            this.productGTIN = _data["productGTIN"];
            this.productCountryId = _data["productCountryId"];
            this.currencyTypeId = _data["currencyTypeId"];
            this.price = _data["price"];
            this.productService = _data["productService"];
            this.stock = _data["stock"];
            this.unitPriceWithTax = _data["unitPriceWithTax"];
            this.itemExchangeRate = _data["itemExchangeRate"];
            this.taxImpact = _data["taxImpact"];
            this.taxedProportion = _data["taxedProportion"];
            this.taxRate = _data["taxRate"];
            this.isVehicle = _data["isVehicle"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DefaultProductDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultProductDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["measurementUnitId"] = this.measurementUnitId;
        data["tariffHeading"] = this.tariffHeading;
        data["mercosurNomenclature"] = this.mercosurNomenclature;
        data["generalDNCPCode"] = this.generalDNCPCode;
        data["specificDNCPCode"] = this.specificDNCPCode;
        data["productGTIN"] = this.productGTIN;
        data["productCountryId"] = this.productCountryId;
        data["currencyTypeId"] = this.currencyTypeId;
        data["price"] = this.price;
        data["productService"] = this.productService;
        data["stock"] = this.stock;
        data["unitPriceWithTax"] = this.unitPriceWithTax;
        data["itemExchangeRate"] = this.itemExchangeRate;
        data["taxImpact"] = this.taxImpact;
        data["taxedProportion"] = this.taxedProportion;
        data["taxRate"] = this.taxRate;
        data["isVehicle"] = this.isVehicle;
        data["id"] = this.id;
        return data; 
    }

    clone(): DefaultProductDataDto {
        const json = this.toJSON();
        let result = new DefaultProductDataDto();
        result.init(json);
        return result;
    }
}

export interface IDefaultProductDataDto {
    /** Descripción o detalles del producto/servicio. */
    description: string | undefined;
    /** Nombre del producto/servicio. */
    name: string | undefined;
    /** Identificador interno de la unidad de medida. */
    measurementUnitId: number;
    tariffHeading: number | undefined;
    /** NCM (Nomenclatura Común del Mercosur) del producto. */
    mercosurNomenclature: number | undefined;
    /** Código emitido por la DNCP. */
    generalDNCPCode: string | undefined;
    /** Código específico emitido por la DNCP. */
    specificDNCPCode: string | undefined;
    /** Código GTIN del producto */
    productGTIN: number | undefined;
    /** País de origen del producto. */
    productCountryId: number | undefined;
    /** Identificador interno de la moneda en la que se
comerciliza el producto. */
    currencyTypeId: number;
    /** Precio del producto (acorde a la moneda seleccionada). */
    price: number;
    productService: ProductService;
    /** Cantidad/Stock del producto. */
    stock: number;
    /** Precio unitario del producto con impuestos. */
    unitPriceWithTax: number | undefined;
    /** Tipo de cambio del precio del producto. */
    itemExchangeRate: number | undefined;
    taxImpact: TaxImpact;
    /** Proporción gravada de IVA del producto/servicio.
Corresponde al porcentaje (%) gravado. */
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    /** Bandera indicando si el producto es un vehículo
o no. */
    isVehicle: boolean;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = B2B</li><li><i>2</i> = B2C</li><li><i>3</i> = B2G</li><li><i>4</i> = B2F</li></ul> */
export enum OperationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** <p>Members:</p><ul><li><i>1</i> = Persona Natural</li><li><i>2</i> = Persona Legal</li></ul> */
export enum ContributorType {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Cédula paraguaya</li><li><i>2</i> = Pasaporte</li><li><i>3</i> = Cédula extranjera</li><li><i>4</i> = Carnet de residencia</li><li><i>5</i> = Innominado</li><li><i>6</i> = Tarjeta Diplomática de exoneración fiscal</li><li><i>9</i> = Otro</li></ul> */
export enum IdentityDocumentTypeReceiver {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

export class DefaultReceiversDataDto implements IDefaultReceiversDataDto {
    nature: NatureType;
    operationType: OperationType;
    /** Código de país del cliente, de acuerdo al código ISO 4217. */
    countryCode: string | undefined;
    countryName: string | undefined;
    contributorType: ContributorType;
    /** RUC del receptor/cliente. */
    ruc: string | undefined;
    identityDocumentType: IdentityDocumentTypeReceiver;
    /** Nombre o razón social del receptor del documento
electrónico. */
    businessName: string | undefined;
    /** Nombre fantasía del receptor del documento
electrónico. */
    fantasyName: string | undefined;
    /** Dirección (domicilio) del receptor electrónico. */
    address: string | undefined;
    /** Número de casa. */
    houseNumber: number | undefined;
    /** Código SIFEN identificador del departamento. */
    departmentCode: number | undefined;
    /** Código SIFEN identificador del distrito. */
    districtCode: number | undefined;
    /** Código SIFEN identificador de la ciudad. */
    cityCode: number | undefined;
    /** Teléfono de contacto. */
    telephone: string | undefined;
    /** Teléfono móvil de contacto. */
    cellphone: string | undefined;
    /** Dirección de correo electrónico. */
    email: string | undefined;
    /** Código del cliente. */
    clientCode: string | undefined;
    /** Bandera que indica el estado del receptor/cliente. */
    isActive: boolean;
    /** Bandera indicando es el cliente por defecto. */
    defaultClient: boolean;
    /** Cantidad de días por defecto para el vencimiento de los DE de crédito. */
    expirationDateDays: number | undefined;
    id: number;

    constructor(data?: IDefaultReceiversDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nature = _data["nature"];
            this.operationType = _data["operationType"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.contributorType = _data["contributorType"];
            this.ruc = _data["ruc"];
            this.identityDocumentType = _data["identityDocumentType"];
            this.businessName = _data["businessName"];
            this.fantasyName = _data["fantasyName"];
            this.address = _data["address"];
            this.houseNumber = _data["houseNumber"];
            this.departmentCode = _data["departmentCode"];
            this.districtCode = _data["districtCode"];
            this.cityCode = _data["cityCode"];
            this.telephone = _data["telephone"];
            this.cellphone = _data["cellphone"];
            this.email = _data["email"];
            this.clientCode = _data["clientCode"];
            this.isActive = _data["isActive"];
            this.defaultClient = _data["defaultClient"];
            this.expirationDateDays = _data["expirationDateDays"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DefaultReceiversDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultReceiversDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nature"] = this.nature;
        data["operationType"] = this.operationType;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["contributorType"] = this.contributorType;
        data["ruc"] = this.ruc;
        data["identityDocumentType"] = this.identityDocumentType;
        data["businessName"] = this.businessName;
        data["fantasyName"] = this.fantasyName;
        data["address"] = this.address;
        data["houseNumber"] = this.houseNumber;
        data["departmentCode"] = this.departmentCode;
        data["districtCode"] = this.districtCode;
        data["cityCode"] = this.cityCode;
        data["telephone"] = this.telephone;
        data["cellphone"] = this.cellphone;
        data["email"] = this.email;
        data["clientCode"] = this.clientCode;
        data["isActive"] = this.isActive;
        data["defaultClient"] = this.defaultClient;
        data["expirationDateDays"] = this.expirationDateDays;
        data["id"] = this.id;
        return data; 
    }

    clone(): DefaultReceiversDataDto {
        const json = this.toJSON();
        let result = new DefaultReceiversDataDto();
        result.init(json);
        return result;
    }
}

export interface IDefaultReceiversDataDto {
    nature: NatureType;
    operationType: OperationType;
    /** Código de país del cliente, de acuerdo al código ISO 4217. */
    countryCode: string | undefined;
    countryName: string | undefined;
    contributorType: ContributorType;
    /** RUC del receptor/cliente. */
    ruc: string | undefined;
    identityDocumentType: IdentityDocumentTypeReceiver;
    /** Nombre o razón social del receptor del documento
electrónico. */
    businessName: string | undefined;
    /** Nombre fantasía del receptor del documento
electrónico. */
    fantasyName: string | undefined;
    /** Dirección (domicilio) del receptor electrónico. */
    address: string | undefined;
    /** Número de casa. */
    houseNumber: number | undefined;
    /** Código SIFEN identificador del departamento. */
    departmentCode: number | undefined;
    /** Código SIFEN identificador del distrito. */
    districtCode: number | undefined;
    /** Código SIFEN identificador de la ciudad. */
    cityCode: number | undefined;
    /** Teléfono de contacto. */
    telephone: string | undefined;
    /** Teléfono móvil de contacto. */
    cellphone: string | undefined;
    /** Dirección de correo electrónico. */
    email: string | undefined;
    /** Código del cliente. */
    clientCode: string | undefined;
    /** Bandera que indica el estado del receptor/cliente. */
    isActive: boolean;
    /** Bandera indicando es el cliente por defecto. */
    defaultClient: boolean;
    /** Cantidad de días por defecto para el vencimiento de los DE de crédito. */
    expirationDateDays: number | undefined;
    id: number;
}

export class DepartmentDtoPagedResultDto implements IDepartmentDtoPagedResultDto {
    totalCount: number;
    items: DepartmentDto[] | undefined;

    constructor(data?: IDepartmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DepartmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DepartmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DepartmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentDtoPagedResultDto {
    totalCount: number;
    items: DepartmentDto[] | undefined;
}

export class DistrictDtoPagedResultDto implements IDistrictDtoPagedResultDto {
    totalCount: number;
    items: DistrictDto[] | undefined;

    constructor(data?: IDistrictDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DistrictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistrictDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DistrictDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DistrictDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDistrictDtoPagedResultDto {
    totalCount: number;
    items: DistrictDto[] | undefined;
}

/** Tipos de documentos disponibles para emitir. SIFEN: C002 - iTiDE */
export class DocumentTypeDto implements IDocumentTypeDto {
    /** Descripción del tipo de documento electrónico.
SIFEN: C003 - dDesTiDE */
    name: string;
    /** Identificador en SIFEN del tipo de documento.
SIFEN: C002 - iTiDE */
    identifier: number;
    id: number;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentTypeDto {
        const json = this.toJSON();
        let result = new DocumentTypeDto();
        result.init(json);
        return result;
    }
}

/** Tipos de documentos disponibles para emitir. SIFEN: C002 - iTiDE */
export interface IDocumentTypeDto {
    /** Descripción del tipo de documento electrónico.
SIFEN: C003 - dDesTiDE */
    name: string;
    /** Identificador en SIFEN del tipo de documento.
SIFEN: C002 - iTiDE */
    identifier: number;
    id: number;
}

export class DocumentTypeDtoPagedResultDto implements IDocumentTypeDtoPagedResultDto {
    totalCount: number;
    items: DocumentTypeDto[] | undefined;

    constructor(data?: IDocumentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DocumentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DocumentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDtoPagedResultDto {
    totalCount: number;
    items: DocumentTypeDto[] | undefined;
}

/** Tipo de transacción. SIFEN: D011 - iTipTra */
export class TransactionTypeDto implements ITransactionTypeDto {
    /** Descripción del tipo de transacción.
SIFEN: D012 - dDesTipTra */
    name: string;
    /** Identificador del tipo de transacción
en SIFEN.
SIFEN: D011 - iTipTra */
    identifier: number;
    id: number;

    constructor(data?: ITransactionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransactionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransactionTypeDto {
        const json = this.toJSON();
        let result = new TransactionTypeDto();
        result.init(json);
        return result;
    }
}

/** Tipo de transacción. SIFEN: D011 - iTipTra */
export interface ITransactionTypeDto {
    /** Descripción del tipo de transacción.
SIFEN: D012 - dDesTipTra */
    name: string;
    /** Identificador del tipo de transacción
en SIFEN.
SIFEN: D011 - iTipTra */
    identifier: number;
    id: number;
}

/** Tipo de impuesto afectado. SIFEN: D013 - iTImp */
export class TaxTypeDto implements ITaxTypeDto {
    /** Descripción del tipo de impuesto
afectado.
SIFEN: D014 - dDesTImp */
    name: string;
    /** Identificador del tipo de impuesto afectado
en SIFEN.
SIFEN: D013 - iTImp */
    identifier: number;
    id: number;

    constructor(data?: ITaxTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaxTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): TaxTypeDto {
        const json = this.toJSON();
        let result = new TaxTypeDto();
        result.init(json);
        return result;
    }
}

/** Tipo de impuesto afectado. SIFEN: D013 - iTImp */
export interface ITaxTypeDto {
    /** Descripción del tipo de impuesto
afectado.
SIFEN: D014 - dDesTImp */
    name: string;
    /** Identificador del tipo de impuesto afectado
en SIFEN.
SIFEN: D013 - iTImp */
    identifier: number;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Global</li><li><i>2</i> = Por ítem</li></ul> */
export enum ExchangeRateConditionEnum {
    _1 = 1,
    _2 = 2,
}

/** Datos del cliente (receptor electrónico) del DE. SIFEN: D200 - gDatRec */
export class ReceiverDto implements IReceiverDto {
    nature: NatureType;
    operationType: OperationType;
    /** Código identificador del país.
SIFEN: D203 - cPaisRec */
    countryCode: string;
    countryName: string | undefined;
    contributorType: ContributorType;
    /** RUC del receptor electrónico.
SIFEN: D206 - dRucRec y D207 - dDVRec */
    ruc: string | undefined;
    identityDocumentType: IdentityDocumentTypeReceiver;
    /** Descripción del tipo de documento de identidad.
SIFEN: D209 - dDTipIDRec */
    otherDocumentType: string | undefined;
    /** Nombre o razón social del receptor
electrónico del DE.
SIFEN: D211 - dNomRec */
    businessName: string;
    /** Nombre de fantasía del receptor
electrónico del DE.
SIFEN: D212 - dNomFanRec */
    fantasyName: string | undefined;
    /** Dirección del domicilio del receptor
electrónico.
SIFEN: D213 - dDirRec */
    address: string | undefined;
    /** Número de casa del domicilio del receptor
electrónico.
SIFEN: D218 - dNumCasRec */
    houseNumber: number | undefined;
    /** Código SIFEN identificador del departamento.
SIFEN: D219 - cDepRec */
    departmentCode: number | undefined;
    /** Código SIFEN identificador del distrito.
SIFEN: D221 - cDisRec */
    districtCode: number | undefined;
    /** Código SIFEN identificador de la ciudad.
SIFEN: D223 - cCiuRec */
    cityCode: number | undefined;
    /** Número de teléfono del receptor
electrónico.
Opcional.
SIFEN: D214 - dTelRec */
    telephone: string | undefined;
    /** Número de celular del receptor
electrónico.
Opcional.
SIFEN: D215 - dCelRec */
    cellphone: string | undefined;
    /** Correo electrónico del receptor
electrónico.
Opcional.
SIFEN: D216 - dEmailRec */
    email: string | undefined;
    /** Código del cliente.
Opcional.
SIFEN: D217 - dCodCliente */
    clientCode: string | undefined;
    /** Bandera que indica el estado del receptor/cliente. */
    isActive: boolean;
    /** Bandera indicando es el cliente por defecto. */
    defaultClient: boolean;
    /** Cantidad de días por defecto para el vencimiento de los DE de crédito. */
    expirationDateDays: number | undefined;
    /** Es proveedor. */
    isProvider: boolean;
    id: number;

    constructor(data?: IReceiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nature = _data["nature"];
            this.operationType = _data["operationType"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.contributorType = _data["contributorType"];
            this.ruc = _data["ruc"];
            this.identityDocumentType = _data["identityDocumentType"];
            this.otherDocumentType = _data["otherDocumentType"];
            this.businessName = _data["businessName"];
            this.fantasyName = _data["fantasyName"];
            this.address = _data["address"];
            this.houseNumber = _data["houseNumber"];
            this.departmentCode = _data["departmentCode"];
            this.districtCode = _data["districtCode"];
            this.cityCode = _data["cityCode"];
            this.telephone = _data["telephone"];
            this.cellphone = _data["cellphone"];
            this.email = _data["email"];
            this.clientCode = _data["clientCode"];
            this.isActive = _data["isActive"];
            this.defaultClient = _data["defaultClient"];
            this.expirationDateDays = _data["expirationDateDays"];
            this.isProvider = _data["isProvider"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReceiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nature"] = this.nature;
        data["operationType"] = this.operationType;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["contributorType"] = this.contributorType;
        data["ruc"] = this.ruc;
        data["identityDocumentType"] = this.identityDocumentType;
        data["otherDocumentType"] = this.otherDocumentType;
        data["businessName"] = this.businessName;
        data["fantasyName"] = this.fantasyName;
        data["address"] = this.address;
        data["houseNumber"] = this.houseNumber;
        data["departmentCode"] = this.departmentCode;
        data["districtCode"] = this.districtCode;
        data["cityCode"] = this.cityCode;
        data["telephone"] = this.telephone;
        data["cellphone"] = this.cellphone;
        data["email"] = this.email;
        data["clientCode"] = this.clientCode;
        data["isActive"] = this.isActive;
        data["defaultClient"] = this.defaultClient;
        data["expirationDateDays"] = this.expirationDateDays;
        data["isProvider"] = this.isProvider;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReceiverDto {
        const json = this.toJSON();
        let result = new ReceiverDto();
        result.init(json);
        return result;
    }
}

/** Datos del cliente (receptor electrónico) del DE. SIFEN: D200 - gDatRec */
export interface IReceiverDto {
    nature: NatureType;
    operationType: OperationType;
    /** Código identificador del país.
SIFEN: D203 - cPaisRec */
    countryCode: string;
    countryName: string | undefined;
    contributorType: ContributorType;
    /** RUC del receptor electrónico.
SIFEN: D206 - dRucRec y D207 - dDVRec */
    ruc: string | undefined;
    identityDocumentType: IdentityDocumentTypeReceiver;
    /** Descripción del tipo de documento de identidad.
SIFEN: D209 - dDTipIDRec */
    otherDocumentType: string | undefined;
    /** Nombre o razón social del receptor
electrónico del DE.
SIFEN: D211 - dNomRec */
    businessName: string;
    /** Nombre de fantasía del receptor
electrónico del DE.
SIFEN: D212 - dNomFanRec */
    fantasyName: string | undefined;
    /** Dirección del domicilio del receptor
electrónico.
SIFEN: D213 - dDirRec */
    address: string | undefined;
    /** Número de casa del domicilio del receptor
electrónico.
SIFEN: D218 - dNumCasRec */
    houseNumber: number | undefined;
    /** Código SIFEN identificador del departamento.
SIFEN: D219 - cDepRec */
    departmentCode: number | undefined;
    /** Código SIFEN identificador del distrito.
SIFEN: D221 - cDisRec */
    districtCode: number | undefined;
    /** Código SIFEN identificador de la ciudad.
SIFEN: D223 - cCiuRec */
    cityCode: number | undefined;
    /** Número de teléfono del receptor
electrónico.
Opcional.
SIFEN: D214 - dTelRec */
    telephone: string | undefined;
    /** Número de celular del receptor
electrónico.
Opcional.
SIFEN: D215 - dCelRec */
    cellphone: string | undefined;
    /** Correo electrónico del receptor
electrónico.
Opcional.
SIFEN: D216 - dEmailRec */
    email: string | undefined;
    /** Código del cliente.
Opcional.
SIFEN: D217 - dCodCliente */
    clientCode: string | undefined;
    /** Bandera que indica el estado del receptor/cliente. */
    isActive: boolean;
    /** Bandera indicando es el cliente por defecto. */
    defaultClient: boolean;
    /** Cantidad de días por defecto para el vencimiento de los DE de crédito. */
    expirationDateDays: number | undefined;
    /** Es proveedor. */
    isProvider: boolean;
    id: number;
}

export class City implements ICity {
    name: string | undefined;
    identifier: number;
    districtId: number | undefined;
    district: District;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.districtId = _data["districtId"];
            this.district = _data["district"] ? District.fromJS(_data["district"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): City {
        data = typeof data === 'object' ? data : {};
        let result = new City();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["districtId"] = this.districtId;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): City {
        const json = this.toJSON();
        let result = new City();
        result.init(json);
        return result;
    }
}

export interface ICity {
    name: string | undefined;
    identifier: number;
    districtId: number | undefined;
    district: District;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class District implements IDistrict {
    name: string | undefined;
    identifier: number;
    cities: City[] | undefined;
    departmentId: number | undefined;
    department: Department;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDistrict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(City.fromJS(item));
            }
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): District {
        data = typeof data === 'object' ? data : {};
        let result = new District();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): District {
        const json = this.toJSON();
        let result = new District();
        result.init(json);
        return result;
    }
}

export interface IDistrict {
    name: string | undefined;
    identifier: number;
    cities: City[] | undefined;
    departmentId: number | undefined;
    department: Department;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Department implements IDepartment {
    name: string | undefined;
    identifier: number;
    districts: District[] | undefined;
    countryId: number | undefined;
    country: Country;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts.push(District.fromJS(item));
            }
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Department {
        const json = this.toJSON();
        let result = new Department();
        result.init(json);
        return result;
    }
}

export interface IDepartment {
    name: string | undefined;
    identifier: number;
    districts: District[] | undefined;
    countryId: number | undefined;
    country: Country;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Country implements ICountry {
    name: string | undefined;
    identifier: string | undefined;
    departments: Department[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments.push(Department.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    name: string | undefined;
    identifier: string | undefined;
    departments: Department[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Regime implements IRegime {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRegime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Regime {
        data = typeof data === 'object' ? data : {};
        let result = new Regime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Regime {
        const json = this.toJSON();
        let result = new Regime();
        result.init(json);
        return result;
    }
}

export interface IRegime {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentType implements IDocumentType {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentType {
        const json = this.toJSON();
        let result = new DocumentType();
        result.init(json);
        return result;
    }
}

export interface IDocumentType {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class BranchDocumentType implements IBranchDocumentType {
    branchId: number;
    branch: Branch;
    documentTypeId: number;
    documentType: DocumentType;
    stablishment: string | undefined;
    expeditionPoint: string | undefined;
    id: number;

    constructor(data?: IBranchDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? DocumentType.fromJS(_data["documentType"]) : <any>undefined;
            this.stablishment = _data["stablishment"];
            this.expeditionPoint = _data["expeditionPoint"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BranchDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["stablishment"] = this.stablishment;
        data["expeditionPoint"] = this.expeditionPoint;
        data["id"] = this.id;
        return data; 
    }

    clone(): BranchDocumentType {
        const json = this.toJSON();
        let result = new BranchDocumentType();
        result.init(json);
        return result;
    }
}

export interface IBranchDocumentType {
    branchId: number;
    branch: Branch;
    documentTypeId: number;
    documentType: DocumentType;
    stablishment: string | undefined;
    expeditionPoint: string | undefined;
    id: number;
}

export class Branch implements IBranch {
    branchDocumentTypes: BranchDocumentType[] | undefined;
    address: string | undefined;
    houseNumber: number;
    addressComplement1: string | undefined;
    addressComplement2: string | undefined;
    cityId: number | undefined;
    city: City;
    phone: string | undefined;
    email: string | undefined;
    name: string | undefined;
    tenantId: number;
    isDefault: boolean;
    tenant: Tenant;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchDocumentTypes"])) {
                this.branchDocumentTypes = [] as any;
                for (let item of _data["branchDocumentTypes"])
                    this.branchDocumentTypes.push(BranchDocumentType.fromJS(item));
            }
            this.address = _data["address"];
            this.houseNumber = _data["houseNumber"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.cityId = _data["cityId"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
            this.isDefault = _data["isDefault"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Branch {
        data = typeof data === 'object' ? data : {};
        let result = new Branch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchDocumentTypes)) {
            data["branchDocumentTypes"] = [];
            for (let item of this.branchDocumentTypes)
                data["branchDocumentTypes"].push(item.toJSON());
        }
        data["address"] = this.address;
        data["houseNumber"] = this.houseNumber;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["cityId"] = this.cityId;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["isDefault"] = this.isDefault;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Branch {
        const json = this.toJSON();
        let result = new Branch();
        result.init(json);
        return result;
    }
}

export interface IBranch {
    branchDocumentTypes: BranchDocumentType[] | undefined;
    address: string | undefined;
    houseNumber: number;
    addressComplement1: string | undefined;
    addressComplement2: string | undefined;
    cityId: number | undefined;
    city: City;
    phone: string | undefined;
    email: string | undefined;
    name: string | undefined;
    tenantId: number;
    isDefault: boolean;
    tenant: Tenant;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Activity implements IActivity {
    name: string | undefined;
    identifier: string | undefined;
    parentId: number | undefined;
    parent: Activity;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Activity.fromJS(_data["parent"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Activity {
        const json = this.toJSON();
        let result = new Activity();
        result.init(json);
        return result;
    }
}

export interface IActivity {
    name: string | undefined;
    identifier: string | undefined;
    parentId: number | undefined;
    parent: Activity;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TenantActivity implements ITenantActivity {
    tenantId: number;
    activityId: number;
    activity: Activity;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITenantActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantActivity {
        data = typeof data === 'object' ? data : {};
        let result = new TenantActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantActivity {
        const json = this.toJSON();
        let result = new TenantActivity();
        result.init(json);
        return result;
    }
}

export interface ITenantActivity {
    tenantId: number;
    activityId: number;
    activity: Activity;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Edition implements IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Edition {
        const json = this.toJSON();
        let result = new Edition();
        result.init(json);
        return result;
    }
}

export interface IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class IdentityDocumentType implements IIdentityDocumentType {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IIdentityDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdentityDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityDocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): IdentityDocumentType {
        const json = this.toJSON();
        let result = new IdentityDocumentType();
        result.init(json);
        return result;
    }
}

export interface IIdentityDocumentType {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    identityDocumentTypeId: number | undefined;
    identityDocumentType: IdentityDocumentType;
    identityDocumentNumber: string | undefined;
    position: string | undefined;
    defaultBranchId: number | undefined;
    defaultBranch: Branch;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityDocumentTypeId = _data["identityDocumentTypeId"];
            this.identityDocumentType = _data["identityDocumentType"] ? IdentityDocumentType.fromJS(_data["identityDocumentType"]) : <any>undefined;
            this.identityDocumentNumber = _data["identityDocumentNumber"];
            this.position = _data["position"];
            this.defaultBranchId = _data["defaultBranchId"];
            this.defaultBranch = _data["defaultBranch"] ? Branch.fromJS(_data["defaultBranch"]) : <any>undefined;
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityDocumentTypeId"] = this.identityDocumentTypeId;
        data["identityDocumentType"] = this.identityDocumentType ? this.identityDocumentType.toJSON() : <any>undefined;
        data["identityDocumentNumber"] = this.identityDocumentNumber;
        data["position"] = this.position;
        data["defaultBranchId"] = this.defaultBranchId;
        data["defaultBranch"] = this.defaultBranch ? this.defaultBranch.toJSON() : <any>undefined;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    identityDocumentTypeId: number | undefined;
    identityDocumentType: IdentityDocumentType;
    identityDocumentNumber: string | undefined;
    position: string | undefined;
    defaultBranchId: number | undefined;
    defaultBranch: Branch;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Tenant implements ITenant {
    stampNumber: string | undefined;
    stampDate: moment.Moment | undefined;
    ruc: string | undefined;
    taxpayerType: number;
    regimeId: number | undefined;
    idCSC: string | undefined;
    csc: string | undefined;
    regime: Regime;
    branches: Branch[] | undefined;
    activities: TenantActivity[] | undefined;
    deElectricPower: boolean;
    deInsurance: boolean;
    deSupermarket: boolean;
    deInformation: boolean;
    wasManuallyDisabled: boolean;
    totalMultipleOfFifTy: boolean;
    warningExpirationDate: moment.Moment | undefined;
    sendInvoicesCustomersViaEmail: boolean;
    maxDaysWithoutInvoicing: number;
    notificationFrequencyDays: number;
    lastInvoicingThresholdNotifiedAt: moment.Moment | undefined;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stampNumber = _data["stampNumber"];
            this.stampDate = _data["stampDate"] ? moment(_data["stampDate"].toString()) : <any>undefined;
            this.ruc = _data["ruc"];
            this.taxpayerType = _data["taxpayerType"];
            this.regimeId = _data["regimeId"];
            this.idCSC = _data["idCSC"];
            this.csc = _data["csc"];
            this.regime = _data["regime"] ? Regime.fromJS(_data["regime"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches.push(Branch.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(TenantActivity.fromJS(item));
            }
            this.deElectricPower = _data["deElectricPower"];
            this.deInsurance = _data["deInsurance"];
            this.deSupermarket = _data["deSupermarket"];
            this.deInformation = _data["deInformation"];
            this.wasManuallyDisabled = _data["wasManuallyDisabled"];
            this.totalMultipleOfFifTy = _data["totalMultipleOfFifTy"];
            this.warningExpirationDate = _data["warningExpirationDate"] ? moment(_data["warningExpirationDate"].toString()) : <any>undefined;
            this.sendInvoicesCustomersViaEmail = _data["sendInvoicesCustomersViaEmail"];
            this.maxDaysWithoutInvoicing = _data["maxDaysWithoutInvoicing"];
            this.notificationFrequencyDays = _data["notificationFrequencyDays"];
            this.lastInvoicingThresholdNotifiedAt = _data["lastInvoicingThresholdNotifiedAt"] ? moment(_data["lastInvoicingThresholdNotifiedAt"].toString()) : <any>undefined;
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stampNumber"] = this.stampNumber;
        data["stampDate"] = this.stampDate ? this.stampDate.toISOString() : <any>undefined;
        data["ruc"] = this.ruc;
        data["taxpayerType"] = this.taxpayerType;
        data["regimeId"] = this.regimeId;
        data["idCSC"] = this.idCSC;
        data["csc"] = this.csc;
        data["regime"] = this.regime ? this.regime.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["deElectricPower"] = this.deElectricPower;
        data["deInsurance"] = this.deInsurance;
        data["deSupermarket"] = this.deSupermarket;
        data["deInformation"] = this.deInformation;
        data["wasManuallyDisabled"] = this.wasManuallyDisabled;
        data["totalMultipleOfFifTy"] = this.totalMultipleOfFifTy;
        data["warningExpirationDate"] = this.warningExpirationDate ? this.warningExpirationDate.toISOString() : <any>undefined;
        data["sendInvoicesCustomersViaEmail"] = this.sendInvoicesCustomersViaEmail;
        data["maxDaysWithoutInvoicing"] = this.maxDaysWithoutInvoicing;
        data["notificationFrequencyDays"] = this.notificationFrequencyDays;
        data["lastInvoicingThresholdNotifiedAt"] = this.lastInvoicingThresholdNotifiedAt ? this.lastInvoicingThresholdNotifiedAt.toISOString() : <any>undefined;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    stampNumber: string | undefined;
    stampDate: moment.Moment | undefined;
    ruc: string | undefined;
    taxpayerType: number;
    regimeId: number | undefined;
    idCSC: string | undefined;
    csc: string | undefined;
    regime: Regime;
    branches: Branch[] | undefined;
    activities: TenantActivity[] | undefined;
    deElectricPower: boolean;
    deInsurance: boolean;
    deSupermarket: boolean;
    deInformation: boolean;
    wasManuallyDisabled: boolean;
    totalMultipleOfFifTy: boolean;
    warningExpirationDate: moment.Moment | undefined;
    sendInvoicesCustomersViaEmail: boolean;
    maxDaysWithoutInvoicing: number;
    notificationFrequencyDays: number;
    lastInvoicingThresholdNotifiedAt: moment.Moment | undefined;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Receiver implements IReceiver {
    nature: NatureType;
    operationType: OperationType;
    countryId: number | undefined;
    country: Country;
    contributorType: ContributorType;
    ruc: string | undefined;
    identityDocumentType: IdentityDocumentTypeReceiver;
    otherDocumentType: string | undefined;
    businessName: string | undefined;
    fantasyName: string | undefined;
    address: string | undefined;
    houseNumber: number | undefined;
    departmentId: number | undefined;
    department: Department;
    districtId: number | undefined;
    district: District;
    cityId: number | undefined;
    city: City;
    telephone: string | undefined;
    cellphone: string | undefined;
    email: string | undefined;
    clientCode: string | undefined;
    tenantId: number;
    tenant: Tenant;
    isActive: boolean;
    defaultClient: boolean;
    expirationDateDays: number | undefined;
    isProvider: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IReceiver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nature = _data["nature"];
            this.operationType = _data["operationType"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.contributorType = _data["contributorType"];
            this.ruc = _data["ruc"];
            this.identityDocumentType = _data["identityDocumentType"];
            this.otherDocumentType = _data["otherDocumentType"];
            this.businessName = _data["businessName"];
            this.fantasyName = _data["fantasyName"];
            this.address = _data["address"];
            this.houseNumber = _data["houseNumber"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.districtId = _data["districtId"];
            this.district = _data["district"] ? District.fromJS(_data["district"]) : <any>undefined;
            this.cityId = _data["cityId"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.telephone = _data["telephone"];
            this.cellphone = _data["cellphone"];
            this.email = _data["email"];
            this.clientCode = _data["clientCode"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.defaultClient = _data["defaultClient"];
            this.expirationDateDays = _data["expirationDateDays"];
            this.isProvider = _data["isProvider"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Receiver {
        data = typeof data === 'object' ? data : {};
        let result = new Receiver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nature"] = this.nature;
        data["operationType"] = this.operationType;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["contributorType"] = this.contributorType;
        data["ruc"] = this.ruc;
        data["identityDocumentType"] = this.identityDocumentType;
        data["otherDocumentType"] = this.otherDocumentType;
        data["businessName"] = this.businessName;
        data["fantasyName"] = this.fantasyName;
        data["address"] = this.address;
        data["houseNumber"] = this.houseNumber;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["districtId"] = this.districtId;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["cityId"] = this.cityId;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["telephone"] = this.telephone;
        data["cellphone"] = this.cellphone;
        data["email"] = this.email;
        data["clientCode"] = this.clientCode;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["defaultClient"] = this.defaultClient;
        data["expirationDateDays"] = this.expirationDateDays;
        data["isProvider"] = this.isProvider;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Receiver {
        const json = this.toJSON();
        let result = new Receiver();
        result.init(json);
        return result;
    }
}

export interface IReceiver {
    nature: NatureType;
    operationType: OperationType;
    countryId: number | undefined;
    country: Country;
    contributorType: ContributorType;
    ruc: string | undefined;
    identityDocumentType: IdentityDocumentTypeReceiver;
    otherDocumentType: string | undefined;
    businessName: string | undefined;
    fantasyName: string | undefined;
    address: string | undefined;
    houseNumber: number | undefined;
    departmentId: number | undefined;
    department: Department;
    districtId: number | undefined;
    district: District;
    cityId: number | undefined;
    city: City;
    telephone: string | undefined;
    cellphone: string | undefined;
    email: string | undefined;
    clientCode: string | undefined;
    tenantId: number;
    tenant: Tenant;
    isActive: boolean;
    defaultClient: boolean;
    expirationDateDays: number | undefined;
    isProvider: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** Entidad de sucursal del cliente. */
export class ReceiverBranchDto implements IReceiverBranchDto {
    /** Nombre de la sucursal. */
    name: string | undefined;
    /** Correo electrónico de la sucursal. */
    email: string | undefined;
    /** Teléfono de la sucursal. */
    telephone: string | undefined;
    /** Dirección de la sucursal. */
    address: string | undefined;
    /** Identificador interno en Paranet del
departamento de locación de la sucursal. */
    departmentCode: number | undefined;
    department: DepartmentDto;
    /** Identificador interno en Paranet del
distrito de locación de la sucursal. */
    districtCode: number | undefined;
    district: DistrictDto;
    /** Identificador interno en Paranet de la
ciudad de locación de la sucursal. */
    cityCode: number | undefined;
    city: CityDto;
    /** Número de casa de la sucursal. */
    houseNumber: number | undefined;
    /** Identificador interno en Paranet del
cliente de la sucursal. */
    receiverId: number | undefined;
    receiver: Receiver;
    /** Identificador interno en Paranet
de la empresa "dueña" de la sucursal. */
    tenantId: number;
    tenant: TenantDto;
    id: number;

    constructor(data?: IReceiverBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
            this.address = _data["address"];
            this.departmentCode = _data["departmentCode"];
            this.department = _data["department"] ? DepartmentDto.fromJS(_data["department"]) : <any>undefined;
            this.districtCode = _data["districtCode"];
            this.district = _data["district"] ? DistrictDto.fromJS(_data["district"]) : <any>undefined;
            this.cityCode = _data["cityCode"];
            this.city = _data["city"] ? CityDto.fromJS(_data["city"]) : <any>undefined;
            this.houseNumber = _data["houseNumber"];
            this.receiverId = _data["receiverId"];
            this.receiver = _data["receiver"] ? Receiver.fromJS(_data["receiver"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReceiverBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        data["address"] = this.address;
        data["departmentCode"] = this.departmentCode;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["districtCode"] = this.districtCode;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["cityCode"] = this.cityCode;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["houseNumber"] = this.houseNumber;
        data["receiverId"] = this.receiverId;
        data["receiver"] = this.receiver ? this.receiver.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReceiverBranchDto {
        const json = this.toJSON();
        let result = new ReceiverBranchDto();
        result.init(json);
        return result;
    }
}

/** Entidad de sucursal del cliente. */
export interface IReceiverBranchDto {
    /** Nombre de la sucursal. */
    name: string | undefined;
    /** Correo electrónico de la sucursal. */
    email: string | undefined;
    /** Teléfono de la sucursal. */
    telephone: string | undefined;
    /** Dirección de la sucursal. */
    address: string | undefined;
    /** Identificador interno en Paranet del
departamento de locación de la sucursal. */
    departmentCode: number | undefined;
    department: DepartmentDto;
    /** Identificador interno en Paranet del
distrito de locación de la sucursal. */
    districtCode: number | undefined;
    district: DistrictDto;
    /** Identificador interno en Paranet de la
ciudad de locación de la sucursal. */
    cityCode: number | undefined;
    city: CityDto;
    /** Número de casa de la sucursal. */
    houseNumber: number | undefined;
    /** Identificador interno en Paranet del
cliente de la sucursal. */
    receiverId: number | undefined;
    receiver: Receiver;
    /** Identificador interno en Paranet
de la empresa "dueña" de la sucursal. */
    tenantId: number;
    tenant: TenantDto;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Tolerancia de quiebra</li><li><i>2</i> = Tolerancia de merma</li></ul> */
export enum RelevanceDataCodeEnum {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Venta al representante</li><li><i>2</i> = Venta al Consumidor final</li><li><i>3</i> = Venta al gobierno</li><li><i>4</i> = Venta a flota de vehículos</li></ul> */
export enum VehicleSale {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ElectronicDocumentItemDto implements IElectronicDocumentItemDto {
    internalCode: string;
    tariffHeading: number | undefined;
    mercosurNomenclature: number | undefined;
    generalDNCPCode: string | undefined;
    specificDNCPCode: string | undefined;
    productGTIN: number | undefined;
    packageGTIN: number | undefined;
    description: string;
    measurementUnitCode: number;
    quantity: number;
    productCountryCode: string | undefined;
    informationOfInterest: string | undefined;
    relevanceDataCode: RelevanceDataCodeEnum;
    brokeShrinkQuantity: number | undefined;
    brokeShrinkPercentage: number | undefined;
    advanceCDC: string | undefined;
    unitPriceWithTax: number | undefined;
    itemExchangeRate: number | undefined;
    itemUnitPriceDiscountWithTax: number | undefined;
    itemDiscountPercentage: number | undefined;
    itemUnitPriceGlobalDiscountWithTax: number | undefined;
    itemUnitPriceAdvanceWithTax: number | undefined;
    itemUnitPriceGlobalAdvanceWithTax: number | undefined;
    itemTotalPrice: number | undefined;
    itemIvaLiquidation: number | undefined;
    itemBaseIva: number | undefined;
    itemTotalGuaranies: number | undefined;
    taxImpact: TaxImpact;
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    lotNumber: string | undefined;
    merchandiseExpiringDate: moment.Moment | undefined;
    serialNumber: string | undefined;
    orderNumber: string | undefined;
    trackingNumber: string | undefined;
    importerName: string | undefined;
    importerAddress: string | undefined;
    importerSignatureNumber: string | undefined;
    senaveProductRegistrationNumber: string | undefined;
    senaveBusinessRegistrationNumber: string | undefined;
    typeOfVehicleSale: VehicleSale;
    vehicleChassis: string | undefined;
    vechicleColor: string | undefined;
    enginePower: number | undefined;
    engineCapacity: number | undefined;
    netWeightInTons: number | undefined;
    grossWeightInTons: number | undefined;
    fuelTypeCode: number | undefined;
    engineNumber: string | undefined;
    tractionCapacityInTons: number | undefined;
    fabricationYear: number | undefined;
    vehicleType: string | undefined;
    seatedPassengersCapacity: number | undefined;
    engineDisplacement: string | undefined;
    currency: string | undefined;
    priority: number | undefined;
    productId: number;
    electronicDocumentId: number;
    electronicDocument: ElectronicDocumentDto;
    id: number;

    constructor(data?: IElectronicDocumentItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalCode = _data["internalCode"];
            this.tariffHeading = _data["tariffHeading"];
            this.mercosurNomenclature = _data["mercosurNomenclature"];
            this.generalDNCPCode = _data["generalDNCPCode"];
            this.specificDNCPCode = _data["specificDNCPCode"];
            this.productGTIN = _data["productGTIN"];
            this.packageGTIN = _data["packageGTIN"];
            this.description = _data["description"];
            this.measurementUnitCode = _data["measurementUnitCode"];
            this.quantity = _data["quantity"];
            this.productCountryCode = _data["productCountryCode"];
            this.informationOfInterest = _data["informationOfInterest"];
            this.relevanceDataCode = _data["relevanceDataCode"];
            this.brokeShrinkQuantity = _data["brokeShrinkQuantity"];
            this.brokeShrinkPercentage = _data["brokeShrinkPercentage"];
            this.advanceCDC = _data["advanceCDC"];
            this.unitPriceWithTax = _data["unitPriceWithTax"];
            this.itemExchangeRate = _data["itemExchangeRate"];
            this.itemUnitPriceDiscountWithTax = _data["itemUnitPriceDiscountWithTax"];
            this.itemDiscountPercentage = _data["itemDiscountPercentage"];
            this.itemUnitPriceGlobalDiscountWithTax = _data["itemUnitPriceGlobalDiscountWithTax"];
            this.itemUnitPriceAdvanceWithTax = _data["itemUnitPriceAdvanceWithTax"];
            this.itemUnitPriceGlobalAdvanceWithTax = _data["itemUnitPriceGlobalAdvanceWithTax"];
            this.itemTotalPrice = _data["itemTotalPrice"];
            this.itemIvaLiquidation = _data["itemIvaLiquidation"];
            this.itemBaseIva = _data["itemBaseIva"];
            this.itemTotalGuaranies = _data["itemTotalGuaranies"];
            this.taxImpact = _data["taxImpact"];
            this.taxedProportion = _data["taxedProportion"];
            this.taxRate = _data["taxRate"];
            this.lotNumber = _data["lotNumber"];
            this.merchandiseExpiringDate = _data["merchandiseExpiringDate"] ? moment(_data["merchandiseExpiringDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.orderNumber = _data["orderNumber"];
            this.trackingNumber = _data["trackingNumber"];
            this.importerName = _data["importerName"];
            this.importerAddress = _data["importerAddress"];
            this.importerSignatureNumber = _data["importerSignatureNumber"];
            this.senaveProductRegistrationNumber = _data["senaveProductRegistrationNumber"];
            this.senaveBusinessRegistrationNumber = _data["senaveBusinessRegistrationNumber"];
            this.typeOfVehicleSale = _data["typeOfVehicleSale"];
            this.vehicleChassis = _data["vehicleChassis"];
            this.vechicleColor = _data["vechicleColor"];
            this.enginePower = _data["enginePower"];
            this.engineCapacity = _data["engineCapacity"];
            this.netWeightInTons = _data["netWeightInTons"];
            this.grossWeightInTons = _data["grossWeightInTons"];
            this.fuelTypeCode = _data["fuelTypeCode"];
            this.engineNumber = _data["engineNumber"];
            this.tractionCapacityInTons = _data["tractionCapacityInTons"];
            this.fabricationYear = _data["fabricationYear"];
            this.vehicleType = _data["vehicleType"];
            this.seatedPassengersCapacity = _data["seatedPassengersCapacity"];
            this.engineDisplacement = _data["engineDisplacement"];
            this.currency = _data["currency"];
            this.priority = _data["priority"];
            this.productId = _data["productId"];
            this.electronicDocumentId = _data["electronicDocumentId"];
            this.electronicDocument = _data["electronicDocument"] ? ElectronicDocumentDto.fromJS(_data["electronicDocument"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicDocumentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalCode"] = this.internalCode;
        data["tariffHeading"] = this.tariffHeading;
        data["mercosurNomenclature"] = this.mercosurNomenclature;
        data["generalDNCPCode"] = this.generalDNCPCode;
        data["specificDNCPCode"] = this.specificDNCPCode;
        data["productGTIN"] = this.productGTIN;
        data["packageGTIN"] = this.packageGTIN;
        data["description"] = this.description;
        data["measurementUnitCode"] = this.measurementUnitCode;
        data["quantity"] = this.quantity;
        data["productCountryCode"] = this.productCountryCode;
        data["informationOfInterest"] = this.informationOfInterest;
        data["relevanceDataCode"] = this.relevanceDataCode;
        data["brokeShrinkQuantity"] = this.brokeShrinkQuantity;
        data["brokeShrinkPercentage"] = this.brokeShrinkPercentage;
        data["advanceCDC"] = this.advanceCDC;
        data["unitPriceWithTax"] = this.unitPriceWithTax;
        data["itemExchangeRate"] = this.itemExchangeRate;
        data["itemUnitPriceDiscountWithTax"] = this.itemUnitPriceDiscountWithTax;
        data["itemDiscountPercentage"] = this.itemDiscountPercentage;
        data["itemUnitPriceGlobalDiscountWithTax"] = this.itemUnitPriceGlobalDiscountWithTax;
        data["itemUnitPriceAdvanceWithTax"] = this.itemUnitPriceAdvanceWithTax;
        data["itemUnitPriceGlobalAdvanceWithTax"] = this.itemUnitPriceGlobalAdvanceWithTax;
        data["itemTotalPrice"] = this.itemTotalPrice;
        data["itemIvaLiquidation"] = this.itemIvaLiquidation;
        data["itemBaseIva"] = this.itemBaseIva;
        data["itemTotalGuaranies"] = this.itemTotalGuaranies;
        data["taxImpact"] = this.taxImpact;
        data["taxedProportion"] = this.taxedProportion;
        data["taxRate"] = this.taxRate;
        data["lotNumber"] = this.lotNumber;
        data["merchandiseExpiringDate"] = this.merchandiseExpiringDate ? this.merchandiseExpiringDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["orderNumber"] = this.orderNumber;
        data["trackingNumber"] = this.trackingNumber;
        data["importerName"] = this.importerName;
        data["importerAddress"] = this.importerAddress;
        data["importerSignatureNumber"] = this.importerSignatureNumber;
        data["senaveProductRegistrationNumber"] = this.senaveProductRegistrationNumber;
        data["senaveBusinessRegistrationNumber"] = this.senaveBusinessRegistrationNumber;
        data["typeOfVehicleSale"] = this.typeOfVehicleSale;
        data["vehicleChassis"] = this.vehicleChassis;
        data["vechicleColor"] = this.vechicleColor;
        data["enginePower"] = this.enginePower;
        data["engineCapacity"] = this.engineCapacity;
        data["netWeightInTons"] = this.netWeightInTons;
        data["grossWeightInTons"] = this.grossWeightInTons;
        data["fuelTypeCode"] = this.fuelTypeCode;
        data["engineNumber"] = this.engineNumber;
        data["tractionCapacityInTons"] = this.tractionCapacityInTons;
        data["fabricationYear"] = this.fabricationYear;
        data["vehicleType"] = this.vehicleType;
        data["seatedPassengersCapacity"] = this.seatedPassengersCapacity;
        data["engineDisplacement"] = this.engineDisplacement;
        data["currency"] = this.currency;
        data["priority"] = this.priority;
        data["productId"] = this.productId;
        data["electronicDocumentId"] = this.electronicDocumentId;
        data["electronicDocument"] = this.electronicDocument ? this.electronicDocument.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectronicDocumentItemDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentItemDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentItemDto {
    internalCode: string;
    tariffHeading: number | undefined;
    mercosurNomenclature: number | undefined;
    generalDNCPCode: string | undefined;
    specificDNCPCode: string | undefined;
    productGTIN: number | undefined;
    packageGTIN: number | undefined;
    description: string;
    measurementUnitCode: number;
    quantity: number;
    productCountryCode: string | undefined;
    informationOfInterest: string | undefined;
    relevanceDataCode: RelevanceDataCodeEnum;
    brokeShrinkQuantity: number | undefined;
    brokeShrinkPercentage: number | undefined;
    advanceCDC: string | undefined;
    unitPriceWithTax: number | undefined;
    itemExchangeRate: number | undefined;
    itemUnitPriceDiscountWithTax: number | undefined;
    itemDiscountPercentage: number | undefined;
    itemUnitPriceGlobalDiscountWithTax: number | undefined;
    itemUnitPriceAdvanceWithTax: number | undefined;
    itemUnitPriceGlobalAdvanceWithTax: number | undefined;
    itemTotalPrice: number | undefined;
    itemIvaLiquidation: number | undefined;
    itemBaseIva: number | undefined;
    itemTotalGuaranies: number | undefined;
    taxImpact: TaxImpact;
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    lotNumber: string | undefined;
    merchandiseExpiringDate: moment.Moment | undefined;
    serialNumber: string | undefined;
    orderNumber: string | undefined;
    trackingNumber: string | undefined;
    importerName: string | undefined;
    importerAddress: string | undefined;
    importerSignatureNumber: string | undefined;
    senaveProductRegistrationNumber: string | undefined;
    senaveBusinessRegistrationNumber: string | undefined;
    typeOfVehicleSale: VehicleSale;
    vehicleChassis: string | undefined;
    vechicleColor: string | undefined;
    enginePower: number | undefined;
    engineCapacity: number | undefined;
    netWeightInTons: number | undefined;
    grossWeightInTons: number | undefined;
    fuelTypeCode: number | undefined;
    engineNumber: string | undefined;
    tractionCapacityInTons: number | undefined;
    fabricationYear: number | undefined;
    vehicleType: string | undefined;
    seatedPassengersCapacity: number | undefined;
    engineDisplacement: string | undefined;
    currency: string | undefined;
    priority: number | undefined;
    productId: number;
    electronicDocumentId: number;
    electronicDocument: ElectronicDocumentDto;
    id: number;
}

/** Indicador de presencia (utilizado para la emisión de Facturas Electrónicas). */
export class PresenceIndicatorDto implements IPresenceIndicatorDto {
    /** Nombre del indicador de presencia. */
    name: string;
    /** Identificador en SIFEN del indicador de presencia. */
    identifier: number;
    id: number;

    constructor(data?: IPresenceIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PresenceIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): PresenceIndicatorDto {
        const json = this.toJSON();
        let result = new PresenceIndicatorDto();
        result.init(json);
        return result;
    }
}

/** Indicador de presencia (utilizado para la emisión de Facturas Electrónicas). */
export interface IPresenceIndicatorDto {
    /** Nombre del indicador de presencia. */
    name: string;
    /** Identificador en SIFEN del indicador de presencia. */
    identifier: number;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = POS</li><li><i>2</i> = Pago Electrónico</li><li><i>9</i> = Otro</li></ul> */
export enum PaymentProcessorOptions {
    _1 = 1,
    _2 = 2,
    _9 = 9,
}

/** Información sobre el pago de un DE, para una operáción al contado, o a crédito con un monto de entrega inicial. SIFEN: E605 - gPaConEIni */
export class PaymentDto implements IPaymentDto {
    /** Código SIFEN que identifica el método de pago.
SIFEN: E606 - iTiPago */
    paymentMethodCode: number;
    /** Descripción del tipo de pago cuando el tipo
de pago es "Otro" (paymentMethodCode = 99).
SIFEN: E607 - dDesTiPag */
    customPaymentMethod: string | undefined;
    /** Monto del pago.
SIFEN: E608 - dMonTiPag */
    ammount: number;
    /** Código de moneda asociada al pago.
SIFEN: E609 - cMoneTiPag */
    currencyCode: string | undefined;
    /** Tipo de cambio para monedas distintas
a PYG.
SIFEN: E611 - dTiCamTiPag */
    exchangeRate: number | undefined;
    /** Código de tarjeta (VISA, Master, etc.) para tipos de
pago con tarjeta de crédito/débito.
Requerido cuando paymentMethodCode = 3 o 4.
SIFEN: E621 - iDenTarj */
    cardTypeCode: number | undefined;
    cardType: CardTypeDto;
    /** Descripción de la tarjeta cuando el tipo
de la tarjeta es "Otro" (CardTypeCode=99).
Requerido cuando paymentMethodCode = 3 o 4.
SIFEN: E622 - dDesDenTarj */
    customCardType: string | undefined;
    /** Razón social de la procesadora de la tarjeta.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E623 - dRSProTar */
    cardProcessorName: string | undefined;
    /** RUC de la procesadora de la tarjeta.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E624 - dRUCProTar / E625 - dDVProTar */
    cardProcessorRUC: string | undefined;
    paymentProcessorOption: PaymentProcessorOptions;
    /** Código de autorización de la operación con tarjeta.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E627 - dCodAuOpe */
    operationAuthorizationCode: number | undefined;
    /** Nombre del titular de la tarjeta de crédito/débito.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E628 - dNomTit */
    cardHolderName: string | undefined;
    /** Cuatro últimos dígitos de la tarjeta de
crédito/débito.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E629 - dNumTarj */
    cardLastFourNumbers: string | undefined;
    /** Número del cheque para tipos de
pago con cheque (paymentMethodCode=2).
SIFEN: E631 - dNumCheq */
    checkNumber: string | undefined;
    /** Banco emisor del cheque para tipos de
pago con cheque (paymentMethodCode=2).
SIFEN: E632 - dBcoEmi */
    issuingBank: string | undefined;
    id: number;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodCode = _data["paymentMethodCode"];
            this.customPaymentMethod = _data["customPaymentMethod"];
            this.ammount = _data["ammount"];
            this.currencyCode = _data["currencyCode"];
            this.exchangeRate = _data["exchangeRate"];
            this.cardTypeCode = _data["cardTypeCode"];
            this.cardType = _data["cardType"] ? CardTypeDto.fromJS(_data["cardType"]) : <any>undefined;
            this.customCardType = _data["customCardType"];
            this.cardProcessorName = _data["cardProcessorName"];
            this.cardProcessorRUC = _data["cardProcessorRUC"];
            this.paymentProcessorOption = _data["paymentProcessorOption"];
            this.operationAuthorizationCode = _data["operationAuthorizationCode"];
            this.cardHolderName = _data["cardHolderName"];
            this.cardLastFourNumbers = _data["cardLastFourNumbers"];
            this.checkNumber = _data["checkNumber"];
            this.issuingBank = _data["issuingBank"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodCode"] = this.paymentMethodCode;
        data["customPaymentMethod"] = this.customPaymentMethod;
        data["ammount"] = this.ammount;
        data["currencyCode"] = this.currencyCode;
        data["exchangeRate"] = this.exchangeRate;
        data["cardTypeCode"] = this.cardTypeCode;
        data["cardType"] = this.cardType ? this.cardType.toJSON() : <any>undefined;
        data["customCardType"] = this.customCardType;
        data["cardProcessorName"] = this.cardProcessorName;
        data["cardProcessorRUC"] = this.cardProcessorRUC;
        data["paymentProcessorOption"] = this.paymentProcessorOption;
        data["operationAuthorizationCode"] = this.operationAuthorizationCode;
        data["cardHolderName"] = this.cardHolderName;
        data["cardLastFourNumbers"] = this.cardLastFourNumbers;
        data["checkNumber"] = this.checkNumber;
        data["issuingBank"] = this.issuingBank;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaymentDto {
        const json = this.toJSON();
        let result = new PaymentDto();
        result.init(json);
        return result;
    }
}

/** Información sobre el pago de un DE, para una operáción al contado, o a crédito con un monto de entrega inicial. SIFEN: E605 - gPaConEIni */
export interface IPaymentDto {
    /** Código SIFEN que identifica el método de pago.
SIFEN: E606 - iTiPago */
    paymentMethodCode: number;
    /** Descripción del tipo de pago cuando el tipo
de pago es "Otro" (paymentMethodCode = 99).
SIFEN: E607 - dDesTiPag */
    customPaymentMethod: string | undefined;
    /** Monto del pago.
SIFEN: E608 - dMonTiPag */
    ammount: number;
    /** Código de moneda asociada al pago.
SIFEN: E609 - cMoneTiPag */
    currencyCode: string | undefined;
    /** Tipo de cambio para monedas distintas
a PYG.
SIFEN: E611 - dTiCamTiPag */
    exchangeRate: number | undefined;
    /** Código de tarjeta (VISA, Master, etc.) para tipos de
pago con tarjeta de crédito/débito.
Requerido cuando paymentMethodCode = 3 o 4.
SIFEN: E621 - iDenTarj */
    cardTypeCode: number | undefined;
    cardType: CardTypeDto;
    /** Descripción de la tarjeta cuando el tipo
de la tarjeta es "Otro" (CardTypeCode=99).
Requerido cuando paymentMethodCode = 3 o 4.
SIFEN: E622 - dDesDenTarj */
    customCardType: string | undefined;
    /** Razón social de la procesadora de la tarjeta.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E623 - dRSProTar */
    cardProcessorName: string | undefined;
    /** RUC de la procesadora de la tarjeta.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E624 - dRUCProTar / E625 - dDVProTar */
    cardProcessorRUC: string | undefined;
    paymentProcessorOption: PaymentProcessorOptions;
    /** Código de autorización de la operación con tarjeta.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E627 - dCodAuOpe */
    operationAuthorizationCode: number | undefined;
    /** Nombre del titular de la tarjeta de crédito/débito.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E628 - dNomTit */
    cardHolderName: string | undefined;
    /** Cuatro últimos dígitos de la tarjeta de
crédito/débito.
Opcional cuando paymentMethodCode = 3 o 4.
SIFEN: E629 - dNumTarj */
    cardLastFourNumbers: string | undefined;
    /** Número del cheque para tipos de
pago con cheque (paymentMethodCode=2).
SIFEN: E631 - dNumCheq */
    checkNumber: string | undefined;
    /** Banco emisor del cheque para tipos de
pago con cheque (paymentMethodCode=2).
SIFEN: E632 - dBcoEmi */
    issuingBank: string | undefined;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Plazo</li><li><i>2</i> = Cuota</li></ul> */
export enum CreditOperationCondition {
    _1 = 1,
    _2 = 2,
}

/** Detalle de cuota de una operación a crédito en cuotas. SIFEN: E650 - gCuotas */
export class FeeDto implements IFeeDto {
    /** Monto de la cuota.
SIFEN: E651 - dMonCuota */
    feeAmmount: number;
    /** Fecha de vencimiento de la cuota.
SIFEN: E652 - dVencCuo
Formato: AAAA-MM-DD */
    feeDueDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeAmmount = _data["feeAmmount"];
            this.feeDueDate = _data["feeDueDate"] ? moment(_data["feeDueDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeAmmount"] = this.feeAmmount;
        data["feeDueDate"] = this.feeDueDate ? this.feeDueDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): FeeDto {
        const json = this.toJSON();
        let result = new FeeDto();
        result.init(json);
        return result;
    }
}

/** Detalle de cuota de una operación a crédito en cuotas. SIFEN: E650 - gCuotas */
export interface IFeeDto {
    /** Monto de la cuota.
SIFEN: E651 - dMonCuota */
    feeAmmount: number;
    /** Fecha de vencimiento de la cuota.
SIFEN: E652 - dVencCuo
Formato: AAAA-MM-DD */
    feeDueDate: moment.Moment | undefined;
    id: number;
}

/** Entidad con la información que describe una operación a crédito. SIFEN: E640 - gPagCred */
export class CreditDto implements ICreditDto {
    creditOperationCondition: CreditOperationCondition;
    /** Plazo del crédito.
SIFEN: EE643 - dPlazoCre */
    creditDeadline: string | undefined;
    /** Cantidad de cuotas. del crédito.
SIFEN: E644 - dCuotas */
    feeNumbers: number | undefined;
    /** Monto de la entrega inicial del crédito.
SIFEN: E645 - dMonEnt */
    initialDeliveryAmmount: number | undefined;
    /** Detalles de las cuotas de la operación a crédito en cuotas.
SIFEN: E650 - gCuotas
Obligatorio si creditOperationCondition = 2 (Cuotas). */
    fees: FeeDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICreditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditOperationCondition = _data["creditOperationCondition"];
            this.creditDeadline = _data["creditDeadline"];
            this.feeNumbers = _data["feeNumbers"];
            this.initialDeliveryAmmount = _data["initialDeliveryAmmount"];
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees.push(FeeDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditOperationCondition"] = this.creditOperationCondition;
        data["creditDeadline"] = this.creditDeadline;
        data["feeNumbers"] = this.feeNumbers;
        data["initialDeliveryAmmount"] = this.initialDeliveryAmmount;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreditDto {
        const json = this.toJSON();
        let result = new CreditDto();
        result.init(json);
        return result;
    }
}

/** Entidad con la información que describe una operación a crédito. SIFEN: E640 - gPagCred */
export interface ICreditDto {
    creditOperationCondition: CreditOperationCondition;
    /** Plazo del crédito.
SIFEN: EE643 - dPlazoCre */
    creditDeadline: string | undefined;
    /** Cantidad de cuotas. del crédito.
SIFEN: E644 - dCuotas */
    feeNumbers: number | undefined;
    /** Monto de la entrega inicial del crédito.
SIFEN: E645 - dMonEnt */
    initialDeliveryAmmount: number | undefined;
    /** Detalles de las cuotas de la operación a crédito en cuotas.
SIFEN: E650 - gCuotas
Obligatorio si creditOperationCondition = 2 (Cuotas). */
    fees: FeeDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ElectricEnergyDto implements IElectricEnergyDto {
    meterNumber: string | undefined;
    activityCode: number | undefined;
    categoryCode: string | undefined;
    previousReading: number | undefined;
    actualReading: number | undefined;
    consumption: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IElectricEnergyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.activityCode = _data["activityCode"];
            this.categoryCode = _data["categoryCode"];
            this.previousReading = _data["previousReading"];
            this.actualReading = _data["actualReading"];
            this.consumption = _data["consumption"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectricEnergyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricEnergyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["activityCode"] = this.activityCode;
        data["categoryCode"] = this.categoryCode;
        data["previousReading"] = this.previousReading;
        data["actualReading"] = this.actualReading;
        data["consumption"] = this.consumption;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectricEnergyDto {
        const json = this.toJSON();
        let result = new ElectricEnergyDto();
        result.init(json);
        return result;
    }
}

export interface IElectricEnergyDto {
    meterNumber: string | undefined;
    activityCode: number | undefined;
    categoryCode: string | undefined;
    previousReading: number | undefined;
    actualReading: number | undefined;
    consumption: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SupermarketDto implements ISupermarketDto {
    cashierName: string | undefined;
    cash: number | undefined;
    change: number | undefined;
    donationAmmount: number | undefined;
    donationDescription: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISupermarketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashierName = _data["cashierName"];
            this.cash = _data["cash"];
            this.change = _data["change"];
            this.donationAmmount = _data["donationAmmount"];
            this.donationDescription = _data["donationDescription"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupermarketDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupermarketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierName"] = this.cashierName;
        data["cash"] = this.cash;
        data["change"] = this.change;
        data["donationAmmount"] = this.donationAmmount;
        data["donationDescription"] = this.donationDescription;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SupermarketDto {
        const json = this.toJSON();
        let result = new SupermarketDto();
        result.init(json);
        return result;
    }
}

export interface ISupermarketDto {
    cashierName: string | undefined;
    cash: number | undefined;
    change: number | undefined;
    donationAmmount: number | undefined;
    donationDescription: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommercialDataDto implements ICommercialDataDto {
    cycle: string | undefined;
    cycleStartDate: moment.Moment | undefined;
    cycleEndDate: moment.Moment | undefined;
    paymentDueDate: moment.Moment | undefined;
    contractNumber: string | undefined;
    previousBalance: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommercialDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycle = _data["cycle"];
            this.cycleStartDate = _data["cycleStartDate"] ? moment(_data["cycleStartDate"].toString()) : <any>undefined;
            this.cycleEndDate = _data["cycleEndDate"] ? moment(_data["cycleEndDate"].toString()) : <any>undefined;
            this.paymentDueDate = _data["paymentDueDate"] ? moment(_data["paymentDueDate"].toString()) : <any>undefined;
            this.contractNumber = _data["contractNumber"];
            this.previousBalance = _data["previousBalance"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommercialDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycle"] = this.cycle;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : <any>undefined;
        data["cycleEndDate"] = this.cycleEndDate ? this.cycleEndDate.toISOString() : <any>undefined;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : <any>undefined;
        data["contractNumber"] = this.contractNumber;
        data["previousBalance"] = this.previousBalance;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CommercialDataDto {
        const json = this.toJSON();
        let result = new CommercialDataDto();
        result.init(json);
        return result;
    }
}

export interface ICommercialDataDto {
    cycle: string | undefined;
    cycleStartDate: moment.Moment | undefined;
    cycleEndDate: moment.Moment | undefined;
    paymentDueDate: moment.Moment | undefined;
    contractNumber: string | undefined;
    previousBalance: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Propio</li><li><i>2</i> = Tercero</li></ul> */
export enum TransportType {
    _1 = 1,
    _2 = 2,
}

/** <p>Members:</p><ul><li><i>1</i> = Terrestre</li><li><i>2</i> = Fluvial</li><li><i>3</i> = Aéreo</li><li><i>4</i> = Multimodal</li></ul> */
export enum TransportMode {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** <p>Members:</p><ul><li><i>1</i> = Emisor de la Factura Electrónica</li><li><i>2</i> = Receptor de la Factura Electrónica</li><li><i>3</i> = Tercero</li><li><i>4</i> = Agente intermediario del transporte</li><li><i>5</i> = Transporte propio</li></ul> */
export enum FreightCostResponsibleEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** Información sobre el local de salida de las mercaderías. SIFEN: E920 - gCamSal */
export class MerchandiseDepartureDto implements IMerchandiseDepartureDto {
    /** Dirección del local de salida de
las mercaderías.
SIFEN: E921 - dDirLocSal */
    departureLocationAddress: string;
    /** Número de casa del local de salida de
las mercaderías.
SIFEN: E922 - dNumCasSal */
    departureHouseNumber: number;
    /** Complemento 1 de dirección del local de
salida de las mercaderías.
SIFEN: E923 - dComp1Sal */
    addressComplement1: string | undefined;
    /** Complemento 2 de dirección del local de
salida de las mercaderías.
SIFEN: E924 - dComp2Sal */
    addressComplement2: string | undefined;
    /** Código de la ciudad del local de salida
de las mercaderías.
SIFEN: E929 - cCiuSal */
    cityCode: number;
    /** Teléfono de contacto del local de salida
de las mercaderías.
SIFEN: E931 - dTelSal */
    departurePhoneNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMerchandiseDepartureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureLocationAddress = _data["departureLocationAddress"];
            this.departureHouseNumber = _data["departureHouseNumber"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.cityCode = _data["cityCode"];
            this.departurePhoneNumber = _data["departurePhoneNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseDepartureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseDepartureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureLocationAddress"] = this.departureLocationAddress;
        data["departureHouseNumber"] = this.departureHouseNumber;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["cityCode"] = this.cityCode;
        data["departurePhoneNumber"] = this.departurePhoneNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseDepartureDto {
        const json = this.toJSON();
        let result = new MerchandiseDepartureDto();
        result.init(json);
        return result;
    }
}

/** Información sobre el local de salida de las mercaderías. SIFEN: E920 - gCamSal */
export interface IMerchandiseDepartureDto {
    /** Dirección del local de salida de
las mercaderías.
SIFEN: E921 - dDirLocSal */
    departureLocationAddress: string;
    /** Número de casa del local de salida de
las mercaderías.
SIFEN: E922 - dNumCasSal */
    departureHouseNumber: number;
    /** Complemento 1 de dirección del local de
salida de las mercaderías.
SIFEN: E923 - dComp1Sal */
    addressComplement1: string | undefined;
    /** Complemento 2 de dirección del local de
salida de las mercaderías.
SIFEN: E924 - dComp2Sal */
    addressComplement2: string | undefined;
    /** Código de la ciudad del local de salida
de las mercaderías.
SIFEN: E929 - cCiuSal */
    cityCode: number;
    /** Teléfono de contacto del local de salida
de las mercaderías.
SIFEN: E931 - dTelSal */
    departurePhoneNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** Información del local de entrega de las mercaderías. SIFEN: E940 - gCamEnt */
export class MerchandiseDeliveryDto implements IMerchandiseDeliveryDto {
    /** Dirección del local de la entrega de
las mercaderías.
SIFEN: E941 - dDirLocEnt */
    deliveryLocationAddress: string;
    /** Número de casa del local de la
entrega de las mercaderías.
SIFEN: E942 - dNumCasEnt */
    deliveryHouseNumber: number;
    /** Complemento 1 de dirección del local de
entrega de las mercaderías.
SIFEN: E943 - dComp1Ent */
    addressComplement1: string | undefined;
    /** Complemento 2 de dirección del local de
entrega de las mercaderías.
SIFEN: E944 - dComp2Ent */
    addressComplement2: string | undefined;
    /** Código de la ciudad del local de entrega
de las mercaderías.
SIFEN: E949 - cCiuEnt */
    cityCode: number;
    /** Teléfono de contacto del local de entrega
de las mercaderías.
SIFEN: E951 - dTelEnt */
    deliveryPhoneNumber: string | undefined;

    constructor(data?: IMerchandiseDeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryLocationAddress = _data["deliveryLocationAddress"];
            this.deliveryHouseNumber = _data["deliveryHouseNumber"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.cityCode = _data["cityCode"];
            this.deliveryPhoneNumber = _data["deliveryPhoneNumber"];
        }
    }

    static fromJS(data: any): MerchandiseDeliveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseDeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryLocationAddress"] = this.deliveryLocationAddress;
        data["deliveryHouseNumber"] = this.deliveryHouseNumber;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["cityCode"] = this.cityCode;
        data["deliveryPhoneNumber"] = this.deliveryPhoneNumber;
        return data; 
    }

    clone(): MerchandiseDeliveryDto {
        const json = this.toJSON();
        let result = new MerchandiseDeliveryDto();
        result.init(json);
        return result;
    }
}

/** Información del local de entrega de las mercaderías. SIFEN: E940 - gCamEnt */
export interface IMerchandiseDeliveryDto {
    /** Dirección del local de la entrega de
las mercaderías.
SIFEN: E941 - dDirLocEnt */
    deliveryLocationAddress: string;
    /** Número de casa del local de la
entrega de las mercaderías.
SIFEN: E942 - dNumCasEnt */
    deliveryHouseNumber: number;
    /** Complemento 1 de dirección del local de
entrega de las mercaderías.
SIFEN: E943 - dComp1Ent */
    addressComplement1: string | undefined;
    /** Complemento 2 de dirección del local de
entrega de las mercaderías.
SIFEN: E944 - dComp2Ent */
    addressComplement2: string | undefined;
    /** Código de la ciudad del local de entrega
de las mercaderías.
SIFEN: E949 - cCiuEnt */
    cityCode: number;
    /** Teléfono de contacto del local de entrega
de las mercaderías.
SIFEN: E951 - dTelEnt */
    deliveryPhoneNumber: string | undefined;
}

/** <p>Members:</p><ul><li><i>1</i> = Número de identificación del vehículo</li><li><i>2</i> = Matrícula del vehículo</li></ul> */
export enum VehicleIdentificationType {
    _1 = 1,
    _2 = 2,
}

/** Información del vehículo de traslado de las mercaderías. SIFEN: E960 - gVehTras */
export class MerchandiseTransportVehicleDto implements IMerchandiseTransportVehicleDto {
    /** Tipo del vehículo de traslado de las
mercaderías (acorde a los especificado como
modo de transporte -transportMode-).
SIFEN: E961 - dTiVehTras */
    vehicleType: string;
    /** Marca del vehículo de traslado de las
mercaderías.
SIFEN: E962 - dMarVeh */
    brand: string;
    vehicleIdentificationType: VehicleIdentificationType;
    /** Número de identificación del vehículo de
traslado de las mercaderías.
Obligatorio cuando vehicleIdentificationType = 1
SIFEN: E963 - dNroIDVeh */
    vehicleIdentificationNumber: string | undefined;
    /** Datos adicionales del vehículo de traslado
de las mercaderías.
SIFEN: E964 - dAdicVeh */
    vehicleAditionalInformation: string | undefined;
    /** Número de matrícula del vehículo de
traslado de las mercaderías.
Obligatorio cuando vehicleIdentificationType = 2
SIFEN: E965 - dNroMatVeh */
    vehicleRegistrationPlate: string | undefined;
    /** Número del vuelo en el que se transportan
las mercaderías.
Obligatorio cuando el modo de transporte es
aéreo (transportMode = 3). No informar en otro
caso.
SIFEN: E966 - dNroVuelo */
    flightNumber: string | undefined;

    constructor(data?: IMerchandiseTransportVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleType = _data["vehicleType"];
            this.brand = _data["brand"];
            this.vehicleIdentificationType = _data["vehicleIdentificationType"];
            this.vehicleIdentificationNumber = _data["vehicleIdentificationNumber"];
            this.vehicleAditionalInformation = _data["vehicleAditionalInformation"];
            this.vehicleRegistrationPlate = _data["vehicleRegistrationPlate"];
            this.flightNumber = _data["flightNumber"];
        }
    }

    static fromJS(data: any): MerchandiseTransportVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseTransportVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleType"] = this.vehicleType;
        data["brand"] = this.brand;
        data["vehicleIdentificationType"] = this.vehicleIdentificationType;
        data["vehicleIdentificationNumber"] = this.vehicleIdentificationNumber;
        data["vehicleAditionalInformation"] = this.vehicleAditionalInformation;
        data["vehicleRegistrationPlate"] = this.vehicleRegistrationPlate;
        data["flightNumber"] = this.flightNumber;
        return data; 
    }

    clone(): MerchandiseTransportVehicleDto {
        const json = this.toJSON();
        let result = new MerchandiseTransportVehicleDto();
        result.init(json);
        return result;
    }
}

/** Información del vehículo de traslado de las mercaderías. SIFEN: E960 - gVehTras */
export interface IMerchandiseTransportVehicleDto {
    /** Tipo del vehículo de traslado de las
mercaderías (acorde a los especificado como
modo de transporte -transportMode-).
SIFEN: E961 - dTiVehTras */
    vehicleType: string;
    /** Marca del vehículo de traslado de las
mercaderías.
SIFEN: E962 - dMarVeh */
    brand: string;
    vehicleIdentificationType: VehicleIdentificationType;
    /** Número de identificación del vehículo de
traslado de las mercaderías.
Obligatorio cuando vehicleIdentificationType = 1
SIFEN: E963 - dNroIDVeh */
    vehicleIdentificationNumber: string | undefined;
    /** Datos adicionales del vehículo de traslado
de las mercaderías.
SIFEN: E964 - dAdicVeh */
    vehicleAditionalInformation: string | undefined;
    /** Número de matrícula del vehículo de
traslado de las mercaderías.
Obligatorio cuando vehicleIdentificationType = 2
SIFEN: E965 - dNroMatVeh */
    vehicleRegistrationPlate: string | undefined;
    /** Número del vuelo en el que se transportan
las mercaderías.
Obligatorio cuando el modo de transporte es
aéreo (transportMode = 3). No informar en otro
caso.
SIFEN: E966 - dNroVuelo */
    flightNumber: string | undefined;
}

/** Información sobre el transportista de las mercaderías. SIFEN: E980 - gCamTrans */
export class MerchandiseCarrierDto implements IMerchandiseCarrierDto {
    carrierNatureType: NatureType;
    /** Nombre o razón social del transportista de
las mercaderías.
SIFEN: E982 - dNomTrans */
    carrierName: string;
    /** RUC del transportista de las mercaderías.
Debe ser informado si la naturaleza del mismo
es 'Contribuyente' (carrierNatureType = 1).
SIFEN: E983 - dRucTrans */
    carrierRUC: string | undefined;
    /** Tipo de documento de identidad del transportista
de las mercaderías.
Debe ser informado si la naturaleza del mismo
es 'No Contribuyente' (carrierNatureType = 1).
1= Cédula paraguaya
2= Pasaporte
3= Cédula extranjera
4= Carnet de residencia
SIFEN: E985 - iTipIDTrans */
    carrierIdentityDocumentTypeCode: number | undefined;
    /** Código del país de nacionalidad del transportista
de las mercaderías.
SIFEN: E988 - cNacTrans */
    carrierNationalityCountryCode: string | undefined;
    /** Domicilio fiscal del transportista de las
mercaderías.
SIFEN: E992 - dDomFisc */
    carrierAddress: string | undefined;
    /** Número de documento de identidad del chofer
designado al transporte de las mercaderías.
Obligatorio.
SIFEN: E990 - dNumIDChof */
    driverDocumentNumber: string;
    /** Nombre completo (nombre y apellido) del chofer
designado al transporte de las mercaderías.
Obligatorio.
SIFEN: E991 - dNomChof */
    driverNameAndLastName: string;
    /** Dirección (domicilio fiscal) del transportista
de las mercaderías.
Opcional.
SIFEN: E992 - dDomFisc */
    driverAddress: string | undefined;
    /** Nombre o razón social del agente involucrado
en el transporte de las mercaderías (casos
particulares según RG Nro 41/14).
Opcional.
SIFEN: E994 - dNombAg */
    agentName: string | undefined;
    /** RUC del agente involucrado
en el transporte de las mercaderías (casos
particulares según RG Nro 41/14).
Opcional.
SIFEN: E995 - dRucAg */
    agentRUC: string | undefined;
    /** Dirección del agente involucrado
en el transporte de las mercaderías (casos
particulares según RG Nro 41/14).
Opcional.
SIFEN: E997 - dDirAge */
    agentAddress: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMerchandiseCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierNatureType = _data["carrierNatureType"];
            this.carrierName = _data["carrierName"];
            this.carrierRUC = _data["carrierRUC"];
            this.carrierIdentityDocumentTypeCode = _data["carrierIdentityDocumentTypeCode"];
            this.carrierNationalityCountryCode = _data["carrierNationalityCountryCode"];
            this.carrierAddress = _data["carrierAddress"];
            this.driverDocumentNumber = _data["driverDocumentNumber"];
            this.driverNameAndLastName = _data["driverNameAndLastName"];
            this.driverAddress = _data["driverAddress"];
            this.agentName = _data["agentName"];
            this.agentRUC = _data["agentRUC"];
            this.agentAddress = _data["agentAddress"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierNatureType"] = this.carrierNatureType;
        data["carrierName"] = this.carrierName;
        data["carrierRUC"] = this.carrierRUC;
        data["carrierIdentityDocumentTypeCode"] = this.carrierIdentityDocumentTypeCode;
        data["carrierNationalityCountryCode"] = this.carrierNationalityCountryCode;
        data["carrierAddress"] = this.carrierAddress;
        data["driverDocumentNumber"] = this.driverDocumentNumber;
        data["driverNameAndLastName"] = this.driverNameAndLastName;
        data["driverAddress"] = this.driverAddress;
        data["agentName"] = this.agentName;
        data["agentRUC"] = this.agentRUC;
        data["agentAddress"] = this.agentAddress;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseCarrierDto {
        const json = this.toJSON();
        let result = new MerchandiseCarrierDto();
        result.init(json);
        return result;
    }
}

/** Información sobre el transportista de las mercaderías. SIFEN: E980 - gCamTrans */
export interface IMerchandiseCarrierDto {
    carrierNatureType: NatureType;
    /** Nombre o razón social del transportista de
las mercaderías.
SIFEN: E982 - dNomTrans */
    carrierName: string;
    /** RUC del transportista de las mercaderías.
Debe ser informado si la naturaleza del mismo
es 'Contribuyente' (carrierNatureType = 1).
SIFEN: E983 - dRucTrans */
    carrierRUC: string | undefined;
    /** Tipo de documento de identidad del transportista
de las mercaderías.
Debe ser informado si la naturaleza del mismo
es 'No Contribuyente' (carrierNatureType = 1).
1= Cédula paraguaya
2= Pasaporte
3= Cédula extranjera
4= Carnet de residencia
SIFEN: E985 - iTipIDTrans */
    carrierIdentityDocumentTypeCode: number | undefined;
    /** Código del país de nacionalidad del transportista
de las mercaderías.
SIFEN: E988 - cNacTrans */
    carrierNationalityCountryCode: string | undefined;
    /** Domicilio fiscal del transportista de las
mercaderías.
SIFEN: E992 - dDomFisc */
    carrierAddress: string | undefined;
    /** Número de documento de identidad del chofer
designado al transporte de las mercaderías.
Obligatorio.
SIFEN: E990 - dNumIDChof */
    driverDocumentNumber: string;
    /** Nombre completo (nombre y apellido) del chofer
designado al transporte de las mercaderías.
Obligatorio.
SIFEN: E991 - dNomChof */
    driverNameAndLastName: string;
    /** Dirección (domicilio fiscal) del transportista
de las mercaderías.
Opcional.
SIFEN: E992 - dDomFisc */
    driverAddress: string | undefined;
    /** Nombre o razón social del agente involucrado
en el transporte de las mercaderías (casos
particulares según RG Nro 41/14).
Opcional.
SIFEN: E994 - dNombAg */
    agentName: string | undefined;
    /** RUC del agente involucrado
en el transporte de las mercaderías (casos
particulares según RG Nro 41/14).
Opcional.
SIFEN: E995 - dRucAg */
    agentRUC: string | undefined;
    /** Dirección del agente involucrado
en el transporte de las mercaderías (casos
particulares según RG Nro 41/14).
Opcional.
SIFEN: E997 - dDirAge */
    agentAddress: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** Información del transporte de mercaderías. Obligatorio para Notas de remisión electrónicas. SIFEN: E900 - gTransp */
export class MerchandiseTransportDto implements IMerchandiseTransportDto {
    transportType: TransportType;
    transportMode: TransportMode;
    freightCostResponsible: FreightCostResponsibleEnum;
    /** Condición de la negociación (Incoterms).
SIFEN: E906 - cCondNeg
Opcional. */
    merchandiseNegotiationConditionCode: string | undefined;
    /** Número de manifiesto o conocimiento de carga/declaración de tránsito
aduanero / Carta de porte internacional.
SIFEN: E907 - dNuManif
Opcional. */
    manifestNumber: string | undefined;
    /** Número de despacho de importación.
SIFEN: E908 - dNuDespImp */
    importClearanceNumber: string | undefined;
    /** Fecha estimada de inicio de traslado.
SIFEN: E909 - dIniTras */
    estimatedTransferStartDate: moment.Moment | undefined;
    /** Fecha estimada de fin de traslado.
SIFEN: E910 - dFinTras */
    estimatedTransferEndDate: moment.Moment | undefined;
    /** Código del país de destino.
SIFEN: E911 - cPaisDest */
    countryCode: string | undefined;
    merchandiseDeparture: MerchandiseDepartureDto;
    /** Locales de entrega de las mercaderías.
SIFEN: E940 - gCamEnt */
    merchandiseDeliveries: MerchandiseDeliveryDto[] | undefined;
    /** Vehículos de traslado de las mercaderías.
SIFEN: E960 - gVehTras */
    merchandiseTransportVehicles: MerchandiseTransportVehicleDto[] | undefined;
    merchandiseCarrier: MerchandiseCarrierDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMerchandiseTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transportType = _data["transportType"];
            this.transportMode = _data["transportMode"];
            this.freightCostResponsible = _data["freightCostResponsible"];
            this.merchandiseNegotiationConditionCode = _data["merchandiseNegotiationConditionCode"];
            this.manifestNumber = _data["manifestNumber"];
            this.importClearanceNumber = _data["importClearanceNumber"];
            this.estimatedTransferStartDate = _data["estimatedTransferStartDate"] ? moment(_data["estimatedTransferStartDate"].toString()) : <any>undefined;
            this.estimatedTransferEndDate = _data["estimatedTransferEndDate"] ? moment(_data["estimatedTransferEndDate"].toString()) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.merchandiseDeparture = _data["merchandiseDeparture"] ? MerchandiseDepartureDto.fromJS(_data["merchandiseDeparture"]) : <any>undefined;
            if (Array.isArray(_data["merchandiseDeliveries"])) {
                this.merchandiseDeliveries = [] as any;
                for (let item of _data["merchandiseDeliveries"])
                    this.merchandiseDeliveries.push(MerchandiseDeliveryDto.fromJS(item));
            }
            if (Array.isArray(_data["merchandiseTransportVehicles"])) {
                this.merchandiseTransportVehicles = [] as any;
                for (let item of _data["merchandiseTransportVehicles"])
                    this.merchandiseTransportVehicles.push(MerchandiseTransportVehicleDto.fromJS(item));
            }
            this.merchandiseCarrier = _data["merchandiseCarrier"] ? MerchandiseCarrierDto.fromJS(_data["merchandiseCarrier"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportType"] = this.transportType;
        data["transportMode"] = this.transportMode;
        data["freightCostResponsible"] = this.freightCostResponsible;
        data["merchandiseNegotiationConditionCode"] = this.merchandiseNegotiationConditionCode;
        data["manifestNumber"] = this.manifestNumber;
        data["importClearanceNumber"] = this.importClearanceNumber;
        data["estimatedTransferStartDate"] = this.estimatedTransferStartDate ? this.estimatedTransferStartDate.toISOString() : <any>undefined;
        data["estimatedTransferEndDate"] = this.estimatedTransferEndDate ? this.estimatedTransferEndDate.toISOString() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["merchandiseDeparture"] = this.merchandiseDeparture ? this.merchandiseDeparture.toJSON() : <any>undefined;
        if (Array.isArray(this.merchandiseDeliveries)) {
            data["merchandiseDeliveries"] = [];
            for (let item of this.merchandiseDeliveries)
                data["merchandiseDeliveries"].push(item.toJSON());
        }
        if (Array.isArray(this.merchandiseTransportVehicles)) {
            data["merchandiseTransportVehicles"] = [];
            for (let item of this.merchandiseTransportVehicles)
                data["merchandiseTransportVehicles"].push(item.toJSON());
        }
        data["merchandiseCarrier"] = this.merchandiseCarrier ? this.merchandiseCarrier.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseTransportDto {
        const json = this.toJSON();
        let result = new MerchandiseTransportDto();
        result.init(json);
        return result;
    }
}

/** Información del transporte de mercaderías. Obligatorio para Notas de remisión electrónicas. SIFEN: E900 - gTransp */
export interface IMerchandiseTransportDto {
    transportType: TransportType;
    transportMode: TransportMode;
    freightCostResponsible: FreightCostResponsibleEnum;
    /** Condición de la negociación (Incoterms).
SIFEN: E906 - cCondNeg
Opcional. */
    merchandiseNegotiationConditionCode: string | undefined;
    /** Número de manifiesto o conocimiento de carga/declaración de tránsito
aduanero / Carta de porte internacional.
SIFEN: E907 - dNuManif
Opcional. */
    manifestNumber: string | undefined;
    /** Número de despacho de importación.
SIFEN: E908 - dNuDespImp */
    importClearanceNumber: string | undefined;
    /** Fecha estimada de inicio de traslado.
SIFEN: E909 - dIniTras */
    estimatedTransferStartDate: moment.Moment | undefined;
    /** Fecha estimada de fin de traslado.
SIFEN: E910 - dFinTras */
    estimatedTransferEndDate: moment.Moment | undefined;
    /** Código del país de destino.
SIFEN: E911 - cPaisDest */
    countryCode: string | undefined;
    merchandiseDeparture: MerchandiseDepartureDto;
    /** Locales de entrega de las mercaderías.
SIFEN: E940 - gCamEnt */
    merchandiseDeliveries: MerchandiseDeliveryDto[] | undefined;
    /** Vehículos de traslado de las mercaderías.
SIFEN: E960 - gVehTras */
    merchandiseTransportVehicles: MerchandiseTransportVehicleDto[] | undefined;
    merchandiseCarrier: MerchandiseCarrierDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class InsurancePolicyDto implements IInsurancePolicyDto {
    policyCode: string;
    policyValidityTimeUnit: string;
    policyValidity: number;
    policyNumber: string;
    validityStartDate: moment.Moment | undefined;
    validityEndDate: moment.Moment | undefined;
    itemInternalCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IInsurancePolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyCode = _data["policyCode"];
            this.policyValidityTimeUnit = _data["policyValidityTimeUnit"];
            this.policyValidity = _data["policyValidity"];
            this.policyNumber = _data["policyNumber"];
            this.validityStartDate = _data["validityStartDate"] ? moment(_data["validityStartDate"].toString()) : <any>undefined;
            this.validityEndDate = _data["validityEndDate"] ? moment(_data["validityEndDate"].toString()) : <any>undefined;
            this.itemInternalCode = _data["itemInternalCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsurancePolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyCode"] = this.policyCode;
        data["policyValidityTimeUnit"] = this.policyValidityTimeUnit;
        data["policyValidity"] = this.policyValidity;
        data["policyNumber"] = this.policyNumber;
        data["validityStartDate"] = this.validityStartDate ? this.validityStartDate.toISOString() : <any>undefined;
        data["validityEndDate"] = this.validityEndDate ? this.validityEndDate.toISOString() : <any>undefined;
        data["itemInternalCode"] = this.itemInternalCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsurancePolicyDto {
        const json = this.toJSON();
        let result = new InsurancePolicyDto();
        result.init(json);
        return result;
    }
}

export interface IInsurancePolicyDto {
    policyCode: string;
    policyValidityTimeUnit: string;
    policyValidity: number;
    policyNumber: string;
    validityStartDate: moment.Moment | undefined;
    validityEndDate: moment.Moment | undefined;
    itemInternalCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class InsuranceDto implements IInsuranceDto {
    insuranceSuperintendenceCompanyCode: string | undefined;
    insurancePolicies: InsurancePolicyDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceSuperintendenceCompanyCode = _data["insuranceSuperintendenceCompanyCode"];
            if (Array.isArray(_data["insurancePolicies"])) {
                this.insurancePolicies = [] as any;
                for (let item of _data["insurancePolicies"])
                    this.insurancePolicies.push(InsurancePolicyDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceSuperintendenceCompanyCode"] = this.insuranceSuperintendenceCompanyCode;
        if (Array.isArray(this.insurancePolicies)) {
            data["insurancePolicies"] = [];
            for (let item of this.insurancePolicies)
                data["insurancePolicies"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsuranceDto {
        const json = this.toJSON();
        let result = new InsuranceDto();
        result.init(json);
        return result;
    }
}

export interface IInsuranceDto {
    insuranceSuperintendenceCompanyCode: string | undefined;
    insurancePolicies: InsurancePolicyDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Electrónico</li><li><i>2</i> = Impreso</li><li><i>3</i> = Constancia Electrónica</li></ul> */
export enum AssociatedDocumentType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** <p>Members:</p><ul><li><i>1</i> = Factura</li><li><i>2</i> = Nota de crédito</li><li><i>3</i> = Nota de débito</li><li><i>4</i> = Nota de remisión</li><li><i>5</i> = Comprobante de retención</li></ul> */
export enum PrintedDocumentType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** <p>Members:</p><ul><li><i>1</i> = Constancia de no ser contribuyente</li><li><i>2</i> = Constancia de microproductores</li></ul> */
export enum RecordType {
    _1 = 1,
    _2 = 2,
}

export class AssociatedDocumentDto implements IAssociatedDocumentDto {
    associatedDocumentType: AssociatedDocumentType;
    cdc: string | undefined;
    stampNumber: number | undefined;
    stablishment: string | undefined;
    expeditionPoint: string | undefined;
    documentNumber: string | undefined;
    printedDocumentType: PrintedDocumentType;
    issuingDate: moment.Moment | undefined;
    withholdingVoucherNumber: string | undefined;
    taxCreditResolutionNumber: string | undefined;
    recordType: RecordType;
    recordNumber: number | undefined;
    recordControlNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssociatedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.associatedDocumentType = _data["associatedDocumentType"];
            this.cdc = _data["cdc"];
            this.stampNumber = _data["stampNumber"];
            this.stablishment = _data["stablishment"];
            this.expeditionPoint = _data["expeditionPoint"];
            this.documentNumber = _data["documentNumber"];
            this.printedDocumentType = _data["printedDocumentType"];
            this.issuingDate = _data["issuingDate"] ? moment(_data["issuingDate"].toString()) : <any>undefined;
            this.withholdingVoucherNumber = _data["withholdingVoucherNumber"];
            this.taxCreditResolutionNumber = _data["taxCreditResolutionNumber"];
            this.recordType = _data["recordType"];
            this.recordNumber = _data["recordNumber"];
            this.recordControlNumber = _data["recordControlNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssociatedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associatedDocumentType"] = this.associatedDocumentType;
        data["cdc"] = this.cdc;
        data["stampNumber"] = this.stampNumber;
        data["stablishment"] = this.stablishment;
        data["expeditionPoint"] = this.expeditionPoint;
        data["documentNumber"] = this.documentNumber;
        data["printedDocumentType"] = this.printedDocumentType;
        data["issuingDate"] = this.issuingDate ? this.issuingDate.toISOString() : <any>undefined;
        data["withholdingVoucherNumber"] = this.withholdingVoucherNumber;
        data["taxCreditResolutionNumber"] = this.taxCreditResolutionNumber;
        data["recordType"] = this.recordType;
        data["recordNumber"] = this.recordNumber;
        data["recordControlNumber"] = this.recordControlNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AssociatedDocumentDto {
        const json = this.toJSON();
        let result = new AssociatedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IAssociatedDocumentDto {
    associatedDocumentType: AssociatedDocumentType;
    cdc: string | undefined;
    stampNumber: number | undefined;
    stablishment: string | undefined;
    expeditionPoint: string | undefined;
    documentNumber: string | undefined;
    printedDocumentType: PrintedDocumentType;
    issuingDate: moment.Moment | undefined;
    withholdingVoucherNumber: string | undefined;
    taxCreditResolutionNumber: string | undefined;
    recordType: RecordType;
    recordNumber: number | undefined;
    recordControlNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = CIF</li><li><i>2</i> = FOB</li><li><i>3</i> = Otros</li></ul> */
export enum NegotiationConditionEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PhysicalInfoDto implements IPhysicalInfoDto {
    /** Tipo de operación, para las facturas de exportación siempre: "Exportación" */
    operationType: string | undefined;
    negotiationCondition: NegotiationConditionEnum;
    /** País de destino. */
    destinationCountryCode: string | undefined;
    /** Empresa Fletera o Exportador Nacional. */
    freightCompany: string | undefined;
    /** Agente de Transporte. */
    transportAgent: string | undefined;
    /** Instrucciones de Pago para el
cliente (Beneficiario, Banco, N° de cuenta, 
Código SWIFT, Cartas de Crédito, otro). */
    paymentInstructions: string | undefined;
    /** Número/s de Conocimiento/s de Embarque. */
    numbersOfKnowledgeShipment: number;
    /** Número/s de Manifiesto/s Internacional/es de Carga. */
    numberOfManifestInternationalCargo: number;
    /** Número de barcaza o remolcador, descripción y cantidad del bien transportado
(en los casos de Flete Internacional). */
    internationalFreightData: string | undefined;
    /** Las demás informaciones que sean fijadas por la
Administración Tributaria, ennormas de carácter general. */
    extraInformation: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPhysicalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationType = _data["operationType"];
            this.negotiationCondition = _data["negotiationCondition"];
            this.destinationCountryCode = _data["destinationCountryCode"];
            this.freightCompany = _data["freightCompany"];
            this.transportAgent = _data["transportAgent"];
            this.paymentInstructions = _data["paymentInstructions"];
            this.numbersOfKnowledgeShipment = _data["numbersOfKnowledgeShipment"];
            this.numberOfManifestInternationalCargo = _data["numberOfManifestInternationalCargo"];
            this.internationalFreightData = _data["internationalFreightData"];
            this.extraInformation = _data["extraInformation"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PhysicalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType;
        data["negotiationCondition"] = this.negotiationCondition;
        data["destinationCountryCode"] = this.destinationCountryCode;
        data["freightCompany"] = this.freightCompany;
        data["transportAgent"] = this.transportAgent;
        data["paymentInstructions"] = this.paymentInstructions;
        data["numbersOfKnowledgeShipment"] = this.numbersOfKnowledgeShipment;
        data["numberOfManifestInternationalCargo"] = this.numberOfManifestInternationalCargo;
        data["internationalFreightData"] = this.internationalFreightData;
        data["extraInformation"] = this.extraInformation;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PhysicalInfoDto {
        const json = this.toJSON();
        let result = new PhysicalInfoDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalInfoDto {
    /** Tipo de operación, para las facturas de exportación siempre: "Exportación" */
    operationType: string | undefined;
    negotiationCondition: NegotiationConditionEnum;
    /** País de destino. */
    destinationCountryCode: string | undefined;
    /** Empresa Fletera o Exportador Nacional. */
    freightCompany: string | undefined;
    /** Agente de Transporte. */
    transportAgent: string | undefined;
    /** Instrucciones de Pago para el
cliente (Beneficiario, Banco, N° de cuenta, 
Código SWIFT, Cartas de Crédito, otro). */
    paymentInstructions: string | undefined;
    /** Número/s de Conocimiento/s de Embarque. */
    numbersOfKnowledgeShipment: number;
    /** Número/s de Manifiesto/s Internacional/es de Carga. */
    numberOfManifestInternationalCargo: number;
    /** Número de barcaza o remolcador, descripción y cantidad del bien transportado
(en los casos de Flete Internacional). */
    internationalFreightData: string | undefined;
    /** Las demás informaciones que sean fijadas por la
Administración Tributaria, ennormas de carácter general. */
    extraInformation: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** Documento Electrónico (DE). */
export class ElectronicDocumentDto implements IElectronicDocumentDto {
    issuingType: IssuingType;
    /** Código de seguridad generado aleatoriamente,
para asegurar la confidencialidad de la consulta pública
del DE.
SIFEN: B004 - dCodSeg */
    securityCode: string | undefined;
    /** Información de interés del emisor,
respecto al DE.
Opcional.
SIFEN: B005 - dInfoEmi */
    aditionalInformation: string | undefined;
    /** Información de interés del Fisco,
respecto al DE.
Opcional.
SIFEN: B006 - dInfoFisc */
    aditionalTreasuryInformation: string | undefined;
    /** Código del tipo de documento a emitir.
SIFEN: C002 - iTiDE */
    documentTypeCode: number;
    documentType: DocumentTypeDto;
    /** Número identificatorio del documento que
se está emitiendo.
SIFEN: C007 - dNumDoc */
    number: number;
    /** Serie del número de timbrado (asociado
al campo number).
SIFEN: C010 - dSerieNum */
    series: string | undefined;
    /** Fecha de emisión del DE al SIFEN
(por defecto, la actual).
SIFEN: D002 - dFeEmiDE */
    issuedDate: moment.Moment;
    /** Identificador del tipo de transacción
en SIFEN.
SIFEN: D011 - iTipTra */
    transactionTypeCode: number | undefined;
    transactionType: TransactionTypeDto;
    /** Identificador del tipo de impuesto afectado
en SIFEN.
SIFEN: D013 - iTImp */
    taxTypeCode: number | undefined;
    taxType: TaxTypeDto;
    /** Identificador de la moneda de la operación (ISO 4217)
en SIFEN.
SIFEN: D015 - cMoneOpe */
    currencyTypeCode: string | undefined;
    currencyType: CurrencyTypeDto;
    exchangeRateCondition: ExchangeRateConditionEnum;
    /** Tipo de cambio de la operación cuando
la moneda no es PYG.
SIFEN: D018 - dTiCam */
    exchangeRate: number | undefined;
    advanceCondition: AdvanceConditionEnum;
    /** Identificador interno en Paranet del
cliente (receptor electrónico) del DE.
SIFEN: D200 - gDatRec */
    clientId: number;
    client: ReceiverDto;
    /** Identificador interno en Paranet de la sucursal del
cliente (receptor electrónico) del DE. */
    receiverBranchId: number | undefined;
    receiverBranch: ReceiverBranchDto;
    /** Fecha de vencimiento */
    expirationDate: moment.Moment | undefined;
    /** Cantidad pagada */
    paidAmount: number;
    /** Código de Control */
    cdc: string | undefined;
    statusId: DocumentStatus;
    /** Fecha de aprobación en SIFEN. */
    approvedDate: moment.Moment | undefined;
    /** Mensaje de resultado, asociado al estado del
Documento Electrónico. */
    statusMessage: string | undefined;
    sellerNatureTypeId: SellerNatureType;
    /** Código de ciudad dónde ocurre la transacción. */
    transactionCityCode: number | undefined;
    /** Nombre de la ciudad dónde ocurre la transacción. */
    transactionCityName: string | undefined;
    /** ID de distrito dónde ocurre la transacción. */
    transactionDistrictId: number | undefined;
    /** Nombre del distrito dónde ocurre la transacción. */
    transactionDistrictName: string | undefined;
    /** ID de departamento dónde ocurre la transacción. */
    transactionDepartmentId: number | undefined;
    /** Departamento dónde ocurre al transacción. */
    transactionDepartmentName: string | undefined;
    /** Lugar de la transacción (dirección dónde se provee el servicio/producto) */
    transactionPlace: string | undefined;
    /** Motivo de emisión de la nota de crédito/débito.
SIFEN: E401 - iMotEmi */
    creditNoteReasonCode: number | undefined;
    /** Motivo de emisión de la nota de remisión
electrónica.
Obligatorio cuando DocumentTypeCode = 7
SIFEN: E501 - iMotEmiNR */
    remissionNoteReasonCode: number | undefined;
    /** Descripción del motivo de emisión
de las notas de remisión electrónica.
Obligatorio cuando RemissionNoteReasonCode = 99
SIFEN: E502 - dDesMotEmiNR */
    customRemissionReason: string | undefined;
    estimatedKilometersOfTravel: number | undefined;
    futureDateOfInvoiceIssue: moment.Moment | undefined;
    remissionNoteResponsible: RemissionNoteResponsible;
    operationCondition: OperationCondition;
    /** Número de orden de compra */
    purchaseOrderNumber: string | undefined;
    subTotal: number;
    total: number;
    operationTotal: number | undefined;
    itemsDiscount: number | undefined;
    globalDiscount: number | undefined;
    itemsAdvance: number | undefined;
    globalAdvance: number | undefined;
    totalDiscount: number | undefined;
    totalAdvance: number | undefined;
    round: number | undefined;
    comission: number | undefined;
    generalTotal: number | undefined;
    subTotalTax10: number | undefined;
    subTotalTax5: number | undefined;
    tax10: number | undefined;
    tax5: number | undefined;
    taxBase10: number | undefined;
    taxBase5: number | undefined;
    totalTax: number | undefined;
    totalBaseTax: number | undefined;
    subTotalExcent: number | undefined;
    subTotalExo: number | undefined;
    comissionTax: number | undefined;
    totalTax5Liquidation: number | undefined;
    totalTax10Liquidation: number | undefined;
    branchId: number | undefined;
    tenantId: number | undefined;
    /** Indicador de presencia.
SIFEN: E011 - iIndPres */
    presenceIndicatorCode: number | undefined;
    /** Descripción del indicador de presencia (solo en caso de otro).
SIFEN: E012 - dDesIndPres */
    otherPresenceIndicator: string | undefined;
    /** Fecha futura del traslado de mercadería.
SIFEN: E013 - dFecEmNR */
    dateOfShipment: moment.Moment | undefined;
    modality: string | undefined;
    entity: number | undefined;
    year: number | undefined;
    sequence: number | undefined;
    contractingDate: moment.Moment | undefined;
    electronicDocumentBulkId: number | undefined;
    qrCode: string | undefined;
    totalGuaraniesSpecified: boolean;
    electronicDocumentItems: ElectronicDocumentItemDto[] | undefined;
    branch: BranchDto;
    presenceIndicator: PresenceIndicatorDto;
    /** Información de pagos de la operación al contado
o crédito con monto de entrega inicial.
SIFEN: E605 - gPaConEIni */
    payments: PaymentDto[] | undefined;
    tenant: TenantDto;
    credit: CreditDto;
    electricEnergy: ElectricEnergyDto;
    supermarket: SupermarketDto;
    commercialData: CommercialDataDto;
    merchandiseTransport: MerchandiseTransportDto;
    insurance: InsuranceDto;
    associatedDocuments: AssociatedDocumentDto[] | undefined;
    physicalInfo: PhysicalInfoDto;
    /** Indica si el documento tiene recibos asociados. */
    hasReceipts: boolean;
    /** Fecha del último recibo creado para este documento. */
    lastReceiptDate: moment.Moment | undefined;
    /** Cantidad de recibos asociados a este documento. */
    receiptsCount: number;
    /** Indica si la factura electrónica es de exportación. */
    isExportation: boolean;
    id: number;

    constructor(data?: IElectronicDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuingType = _data["issuingType"];
            this.securityCode = _data["securityCode"];
            this.aditionalInformation = _data["aditionalInformation"];
            this.aditionalTreasuryInformation = _data["aditionalTreasuryInformation"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.number = _data["number"];
            this.series = _data["series"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : <any>undefined;
            this.transactionTypeCode = _data["transactionTypeCode"];
            this.transactionType = _data["transactionType"] ? TransactionTypeDto.fromJS(_data["transactionType"]) : <any>undefined;
            this.taxTypeCode = _data["taxTypeCode"];
            this.taxType = _data["taxType"] ? TaxTypeDto.fromJS(_data["taxType"]) : <any>undefined;
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.currencyType = _data["currencyType"] ? CurrencyTypeDto.fromJS(_data["currencyType"]) : <any>undefined;
            this.exchangeRateCondition = _data["exchangeRateCondition"];
            this.exchangeRate = _data["exchangeRate"];
            this.advanceCondition = _data["advanceCondition"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ReceiverDto.fromJS(_data["client"]) : <any>undefined;
            this.receiverBranchId = _data["receiverBranchId"];
            this.receiverBranch = _data["receiverBranch"] ? ReceiverBranchDto.fromJS(_data["receiverBranch"]) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.paidAmount = _data["paidAmount"];
            this.cdc = _data["cdc"];
            this.statusId = _data["statusId"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.statusMessage = _data["statusMessage"];
            this.sellerNatureTypeId = _data["sellerNatureTypeId"];
            this.transactionCityCode = _data["transactionCityCode"];
            this.transactionCityName = _data["transactionCityName"];
            this.transactionDistrictId = _data["transactionDistrictId"];
            this.transactionDistrictName = _data["transactionDistrictName"];
            this.transactionDepartmentId = _data["transactionDepartmentId"];
            this.transactionDepartmentName = _data["transactionDepartmentName"];
            this.transactionPlace = _data["transactionPlace"];
            this.creditNoteReasonCode = _data["creditNoteReasonCode"];
            this.remissionNoteReasonCode = _data["remissionNoteReasonCode"];
            this.customRemissionReason = _data["customRemissionReason"];
            this.estimatedKilometersOfTravel = _data["estimatedKilometersOfTravel"];
            this.futureDateOfInvoiceIssue = _data["futureDateOfInvoiceIssue"] ? moment(_data["futureDateOfInvoiceIssue"].toString()) : <any>undefined;
            this.remissionNoteResponsible = _data["remissionNoteResponsible"];
            this.operationCondition = _data["operationCondition"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.operationTotal = _data["operationTotal"];
            this.itemsDiscount = _data["itemsDiscount"];
            this.globalDiscount = _data["globalDiscount"];
            this.itemsAdvance = _data["itemsAdvance"];
            this.globalAdvance = _data["globalAdvance"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalAdvance = _data["totalAdvance"];
            this.round = _data["round"];
            this.comission = _data["comission"];
            this.generalTotal = _data["generalTotal"];
            this.subTotalTax10 = _data["subTotalTax10"];
            this.subTotalTax5 = _data["subTotalTax5"];
            this.tax10 = _data["tax10"];
            this.tax5 = _data["tax5"];
            this.taxBase10 = _data["taxBase10"];
            this.taxBase5 = _data["taxBase5"];
            this.totalTax = _data["totalTax"];
            this.totalBaseTax = _data["totalBaseTax"];
            this.subTotalExcent = _data["subTotalExcent"];
            this.subTotalExo = _data["subTotalExo"];
            this.comissionTax = _data["comissionTax"];
            this.totalTax5Liquidation = _data["totalTax5Liquidation"];
            this.totalTax10Liquidation = _data["totalTax10Liquidation"];
            this.branchId = _data["branchId"];
            this.tenantId = _data["tenantId"];
            this.presenceIndicatorCode = _data["presenceIndicatorCode"];
            this.otherPresenceIndicator = _data["otherPresenceIndicator"];
            this.dateOfShipment = _data["dateOfShipment"] ? moment(_data["dateOfShipment"].toString()) : <any>undefined;
            this.modality = _data["modality"];
            this.entity = _data["entity"];
            this.year = _data["year"];
            this.sequence = _data["sequence"];
            this.contractingDate = _data["contractingDate"] ? moment(_data["contractingDate"].toString()) : <any>undefined;
            this.electronicDocumentBulkId = _data["electronicDocumentBulkId"];
            this.qrCode = _data["qrCode"];
            this.totalGuaraniesSpecified = _data["totalGuaraniesSpecified"];
            if (Array.isArray(_data["electronicDocumentItems"])) {
                this.electronicDocumentItems = [] as any;
                for (let item of _data["electronicDocumentItems"])
                    this.electronicDocumentItems.push(ElectronicDocumentItemDto.fromJS(item));
            }
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.presenceIndicator = _data["presenceIndicator"] ? PresenceIndicatorDto.fromJS(_data["presenceIndicator"]) : <any>undefined;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.credit = _data["credit"] ? CreditDto.fromJS(_data["credit"]) : <any>undefined;
            this.electricEnergy = _data["electricEnergy"] ? ElectricEnergyDto.fromJS(_data["electricEnergy"]) : <any>undefined;
            this.supermarket = _data["supermarket"] ? SupermarketDto.fromJS(_data["supermarket"]) : <any>undefined;
            this.commercialData = _data["commercialData"] ? CommercialDataDto.fromJS(_data["commercialData"]) : <any>undefined;
            this.merchandiseTransport = _data["merchandiseTransport"] ? MerchandiseTransportDto.fromJS(_data["merchandiseTransport"]) : <any>undefined;
            this.insurance = _data["insurance"] ? InsuranceDto.fromJS(_data["insurance"]) : <any>undefined;
            if (Array.isArray(_data["associatedDocuments"])) {
                this.associatedDocuments = [] as any;
                for (let item of _data["associatedDocuments"])
                    this.associatedDocuments.push(AssociatedDocumentDto.fromJS(item));
            }
            this.physicalInfo = _data["physicalInfo"] ? PhysicalInfoDto.fromJS(_data["physicalInfo"]) : <any>undefined;
            this.hasReceipts = _data["hasReceipts"];
            this.lastReceiptDate = _data["lastReceiptDate"] ? moment(_data["lastReceiptDate"].toString()) : <any>undefined;
            this.receiptsCount = _data["receiptsCount"];
            this.isExportation = _data["isExportation"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuingType"] = this.issuingType;
        data["securityCode"] = this.securityCode;
        data["aditionalInformation"] = this.aditionalInformation;
        data["aditionalTreasuryInformation"] = this.aditionalTreasuryInformation;
        data["documentTypeCode"] = this.documentTypeCode;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["number"] = this.number;
        data["series"] = this.series;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : <any>undefined;
        data["transactionTypeCode"] = this.transactionTypeCode;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["taxTypeCode"] = this.taxTypeCode;
        data["taxType"] = this.taxType ? this.taxType.toJSON() : <any>undefined;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["currencyType"] = this.currencyType ? this.currencyType.toJSON() : <any>undefined;
        data["exchangeRateCondition"] = this.exchangeRateCondition;
        data["exchangeRate"] = this.exchangeRate;
        data["advanceCondition"] = this.advanceCondition;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["receiverBranchId"] = this.receiverBranchId;
        data["receiverBranch"] = this.receiverBranch ? this.receiverBranch.toJSON() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["paidAmount"] = this.paidAmount;
        data["cdc"] = this.cdc;
        data["statusId"] = this.statusId;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["statusMessage"] = this.statusMessage;
        data["sellerNatureTypeId"] = this.sellerNatureTypeId;
        data["transactionCityCode"] = this.transactionCityCode;
        data["transactionCityName"] = this.transactionCityName;
        data["transactionDistrictId"] = this.transactionDistrictId;
        data["transactionDistrictName"] = this.transactionDistrictName;
        data["transactionDepartmentId"] = this.transactionDepartmentId;
        data["transactionDepartmentName"] = this.transactionDepartmentName;
        data["transactionPlace"] = this.transactionPlace;
        data["creditNoteReasonCode"] = this.creditNoteReasonCode;
        data["remissionNoteReasonCode"] = this.remissionNoteReasonCode;
        data["customRemissionReason"] = this.customRemissionReason;
        data["estimatedKilometersOfTravel"] = this.estimatedKilometersOfTravel;
        data["futureDateOfInvoiceIssue"] = this.futureDateOfInvoiceIssue ? this.futureDateOfInvoiceIssue.toISOString() : <any>undefined;
        data["remissionNoteResponsible"] = this.remissionNoteResponsible;
        data["operationCondition"] = this.operationCondition;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["operationTotal"] = this.operationTotal;
        data["itemsDiscount"] = this.itemsDiscount;
        data["globalDiscount"] = this.globalDiscount;
        data["itemsAdvance"] = this.itemsAdvance;
        data["globalAdvance"] = this.globalAdvance;
        data["totalDiscount"] = this.totalDiscount;
        data["totalAdvance"] = this.totalAdvance;
        data["round"] = this.round;
        data["comission"] = this.comission;
        data["generalTotal"] = this.generalTotal;
        data["subTotalTax10"] = this.subTotalTax10;
        data["subTotalTax5"] = this.subTotalTax5;
        data["tax10"] = this.tax10;
        data["tax5"] = this.tax5;
        data["taxBase10"] = this.taxBase10;
        data["taxBase5"] = this.taxBase5;
        data["totalTax"] = this.totalTax;
        data["totalBaseTax"] = this.totalBaseTax;
        data["subTotalExcent"] = this.subTotalExcent;
        data["subTotalExo"] = this.subTotalExo;
        data["comissionTax"] = this.comissionTax;
        data["totalTax5Liquidation"] = this.totalTax5Liquidation;
        data["totalTax10Liquidation"] = this.totalTax10Liquidation;
        data["branchId"] = this.branchId;
        data["tenantId"] = this.tenantId;
        data["presenceIndicatorCode"] = this.presenceIndicatorCode;
        data["otherPresenceIndicator"] = this.otherPresenceIndicator;
        data["dateOfShipment"] = this.dateOfShipment ? this.dateOfShipment.toISOString() : <any>undefined;
        data["modality"] = this.modality;
        data["entity"] = this.entity;
        data["year"] = this.year;
        data["sequence"] = this.sequence;
        data["contractingDate"] = this.contractingDate ? this.contractingDate.toISOString() : <any>undefined;
        data["electronicDocumentBulkId"] = this.electronicDocumentBulkId;
        data["qrCode"] = this.qrCode;
        data["totalGuaraniesSpecified"] = this.totalGuaraniesSpecified;
        if (Array.isArray(this.electronicDocumentItems)) {
            data["electronicDocumentItems"] = [];
            for (let item of this.electronicDocumentItems)
                data["electronicDocumentItems"].push(item.toJSON());
        }
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["presenceIndicator"] = this.presenceIndicator ? this.presenceIndicator.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["credit"] = this.credit ? this.credit.toJSON() : <any>undefined;
        data["electricEnergy"] = this.electricEnergy ? this.electricEnergy.toJSON() : <any>undefined;
        data["supermarket"] = this.supermarket ? this.supermarket.toJSON() : <any>undefined;
        data["commercialData"] = this.commercialData ? this.commercialData.toJSON() : <any>undefined;
        data["merchandiseTransport"] = this.merchandiseTransport ? this.merchandiseTransport.toJSON() : <any>undefined;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        if (Array.isArray(this.associatedDocuments)) {
            data["associatedDocuments"] = [];
            for (let item of this.associatedDocuments)
                data["associatedDocuments"].push(item.toJSON());
        }
        data["physicalInfo"] = this.physicalInfo ? this.physicalInfo.toJSON() : <any>undefined;
        data["hasReceipts"] = this.hasReceipts;
        data["lastReceiptDate"] = this.lastReceiptDate ? this.lastReceiptDate.toISOString() : <any>undefined;
        data["receiptsCount"] = this.receiptsCount;
        data["isExportation"] = this.isExportation;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectronicDocumentDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentDto();
        result.init(json);
        return result;
    }
}

/** Documento Electrónico (DE). */
export interface IElectronicDocumentDto {
    issuingType: IssuingType;
    /** Código de seguridad generado aleatoriamente,
para asegurar la confidencialidad de la consulta pública
del DE.
SIFEN: B004 - dCodSeg */
    securityCode: string | undefined;
    /** Información de interés del emisor,
respecto al DE.
Opcional.
SIFEN: B005 - dInfoEmi */
    aditionalInformation: string | undefined;
    /** Información de interés del Fisco,
respecto al DE.
Opcional.
SIFEN: B006 - dInfoFisc */
    aditionalTreasuryInformation: string | undefined;
    /** Código del tipo de documento a emitir.
SIFEN: C002 - iTiDE */
    documentTypeCode: number;
    documentType: DocumentTypeDto;
    /** Número identificatorio del documento que
se está emitiendo.
SIFEN: C007 - dNumDoc */
    number: number;
    /** Serie del número de timbrado (asociado
al campo number).
SIFEN: C010 - dSerieNum */
    series: string | undefined;
    /** Fecha de emisión del DE al SIFEN
(por defecto, la actual).
SIFEN: D002 - dFeEmiDE */
    issuedDate: moment.Moment;
    /** Identificador del tipo de transacción
en SIFEN.
SIFEN: D011 - iTipTra */
    transactionTypeCode: number | undefined;
    transactionType: TransactionTypeDto;
    /** Identificador del tipo de impuesto afectado
en SIFEN.
SIFEN: D013 - iTImp */
    taxTypeCode: number | undefined;
    taxType: TaxTypeDto;
    /** Identificador de la moneda de la operación (ISO 4217)
en SIFEN.
SIFEN: D015 - cMoneOpe */
    currencyTypeCode: string | undefined;
    currencyType: CurrencyTypeDto;
    exchangeRateCondition: ExchangeRateConditionEnum;
    /** Tipo de cambio de la operación cuando
la moneda no es PYG.
SIFEN: D018 - dTiCam */
    exchangeRate: number | undefined;
    advanceCondition: AdvanceConditionEnum;
    /** Identificador interno en Paranet del
cliente (receptor electrónico) del DE.
SIFEN: D200 - gDatRec */
    clientId: number;
    client: ReceiverDto;
    /** Identificador interno en Paranet de la sucursal del
cliente (receptor electrónico) del DE. */
    receiverBranchId: number | undefined;
    receiverBranch: ReceiverBranchDto;
    /** Fecha de vencimiento */
    expirationDate: moment.Moment | undefined;
    /** Cantidad pagada */
    paidAmount: number;
    /** Código de Control */
    cdc: string | undefined;
    statusId: DocumentStatus;
    /** Fecha de aprobación en SIFEN. */
    approvedDate: moment.Moment | undefined;
    /** Mensaje de resultado, asociado al estado del
Documento Electrónico. */
    statusMessage: string | undefined;
    sellerNatureTypeId: SellerNatureType;
    /** Código de ciudad dónde ocurre la transacción. */
    transactionCityCode: number | undefined;
    /** Nombre de la ciudad dónde ocurre la transacción. */
    transactionCityName: string | undefined;
    /** ID de distrito dónde ocurre la transacción. */
    transactionDistrictId: number | undefined;
    /** Nombre del distrito dónde ocurre la transacción. */
    transactionDistrictName: string | undefined;
    /** ID de departamento dónde ocurre la transacción. */
    transactionDepartmentId: number | undefined;
    /** Departamento dónde ocurre al transacción. */
    transactionDepartmentName: string | undefined;
    /** Lugar de la transacción (dirección dónde se provee el servicio/producto) */
    transactionPlace: string | undefined;
    /** Motivo de emisión de la nota de crédito/débito.
SIFEN: E401 - iMotEmi */
    creditNoteReasonCode: number | undefined;
    /** Motivo de emisión de la nota de remisión
electrónica.
Obligatorio cuando DocumentTypeCode = 7
SIFEN: E501 - iMotEmiNR */
    remissionNoteReasonCode: number | undefined;
    /** Descripción del motivo de emisión
de las notas de remisión electrónica.
Obligatorio cuando RemissionNoteReasonCode = 99
SIFEN: E502 - dDesMotEmiNR */
    customRemissionReason: string | undefined;
    estimatedKilometersOfTravel: number | undefined;
    futureDateOfInvoiceIssue: moment.Moment | undefined;
    remissionNoteResponsible: RemissionNoteResponsible;
    operationCondition: OperationCondition;
    /** Número de orden de compra */
    purchaseOrderNumber: string | undefined;
    subTotal: number;
    total: number;
    operationTotal: number | undefined;
    itemsDiscount: number | undefined;
    globalDiscount: number | undefined;
    itemsAdvance: number | undefined;
    globalAdvance: number | undefined;
    totalDiscount: number | undefined;
    totalAdvance: number | undefined;
    round: number | undefined;
    comission: number | undefined;
    generalTotal: number | undefined;
    subTotalTax10: number | undefined;
    subTotalTax5: number | undefined;
    tax10: number | undefined;
    tax5: number | undefined;
    taxBase10: number | undefined;
    taxBase5: number | undefined;
    totalTax: number | undefined;
    totalBaseTax: number | undefined;
    subTotalExcent: number | undefined;
    subTotalExo: number | undefined;
    comissionTax: number | undefined;
    totalTax5Liquidation: number | undefined;
    totalTax10Liquidation: number | undefined;
    branchId: number | undefined;
    tenantId: number | undefined;
    /** Indicador de presencia.
SIFEN: E011 - iIndPres */
    presenceIndicatorCode: number | undefined;
    /** Descripción del indicador de presencia (solo en caso de otro).
SIFEN: E012 - dDesIndPres */
    otherPresenceIndicator: string | undefined;
    /** Fecha futura del traslado de mercadería.
SIFEN: E013 - dFecEmNR */
    dateOfShipment: moment.Moment | undefined;
    modality: string | undefined;
    entity: number | undefined;
    year: number | undefined;
    sequence: number | undefined;
    contractingDate: moment.Moment | undefined;
    electronicDocumentBulkId: number | undefined;
    qrCode: string | undefined;
    totalGuaraniesSpecified: boolean;
    electronicDocumentItems: ElectronicDocumentItemDto[] | undefined;
    branch: BranchDto;
    presenceIndicator: PresenceIndicatorDto;
    /** Información de pagos de la operación al contado
o crédito con monto de entrega inicial.
SIFEN: E605 - gPaConEIni */
    payments: PaymentDto[] | undefined;
    tenant: TenantDto;
    credit: CreditDto;
    electricEnergy: ElectricEnergyDto;
    supermarket: SupermarketDto;
    commercialData: CommercialDataDto;
    merchandiseTransport: MerchandiseTransportDto;
    insurance: InsuranceDto;
    associatedDocuments: AssociatedDocumentDto[] | undefined;
    physicalInfo: PhysicalInfoDto;
    /** Indica si el documento tiene recibos asociados. */
    hasReceipts: boolean;
    /** Fecha del último recibo creado para este documento. */
    lastReceiptDate: moment.Moment | undefined;
    /** Cantidad de recibos asociados a este documento. */
    receiptsCount: number;
    /** Indica si la factura electrónica es de exportación. */
    isExportation: boolean;
    id: number;
}

export class ElectronicDocumentDtoPagedResultDto implements IElectronicDocumentDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentDto[] | undefined;

    constructor(data?: IElectronicDocumentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ElectronicDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectronicDocumentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ElectronicDocumentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentDto[] | undefined;
}

/** Entidad de recibo. */
export class ReceiptDto implements IReceiptDto {
    /** Cantidad de pago (emitida en el tipo de cambio del documento electrónico). */
    payment: number;
    /** Balance pagado para el recibo. */
    balance: number;
    /** Tipo de cambio de la operación cuando
la moneda no es PYG. */
    exchangeRate: number | undefined;
    /** Identificador del cliente. */
    receiverId: number | undefined;
    /** Identificador de la moneda de la operación
en Paranet. */
    currencyTypeCode: string | undefined;
    /** Fecha de alta para la factura */
    creationTime: moment.Moment;
    currencyType: CurrencyTypeDto;
    /** Referencia de tipo de pago */
    reference: string | undefined;
    /** Número de recibo */
    number: number;
    id: number;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment = _data["payment"];
            this.balance = _data["balance"];
            this.exchangeRate = _data["exchangeRate"];
            this.receiverId = _data["receiverId"];
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.currencyType = _data["currencyType"] ? CurrencyTypeDto.fromJS(_data["currencyType"]) : <any>undefined;
            this.reference = _data["reference"];
            this.number = _data["number"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment;
        data["balance"] = this.balance;
        data["exchangeRate"] = this.exchangeRate;
        data["receiverId"] = this.receiverId;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["currencyType"] = this.currencyType ? this.currencyType.toJSON() : <any>undefined;
        data["reference"] = this.reference;
        data["number"] = this.number;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReceiptDto {
        const json = this.toJSON();
        let result = new ReceiptDto();
        result.init(json);
        return result;
    }
}

/** Entidad de recibo. */
export interface IReceiptDto {
    /** Cantidad de pago (emitida en el tipo de cambio del documento electrónico). */
    payment: number;
    /** Balance pagado para el recibo. */
    balance: number;
    /** Tipo de cambio de la operación cuando
la moneda no es PYG. */
    exchangeRate: number | undefined;
    /** Identificador del cliente. */
    receiverId: number | undefined;
    /** Identificador de la moneda de la operación
en Paranet. */
    currencyTypeCode: string | undefined;
    /** Fecha de alta para la factura */
    creationTime: moment.Moment;
    currencyType: CurrencyTypeDto;
    /** Referencia de tipo de pago */
    reference: string | undefined;
    /** Número de recibo */
    number: number;
    id: number;
}

export class ElectronicDocumentReceiptDto implements IElectronicDocumentReceiptDto {
    id: number;
    receiptTotal: number | undefined;
    payment: number | undefined;
    electronicDocumentId: number;
    electronicDocument: ElectronicDocumentDto;
    receiptId: number;
    receipt: ReceiptDto;
    creationTime: moment.Moment;
    reference: string | undefined;
    isMultiple: boolean;

    constructor(data?: IElectronicDocumentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receiptTotal = _data["receiptTotal"];
            this.payment = _data["payment"];
            this.electronicDocumentId = _data["electronicDocumentId"];
            this.electronicDocument = _data["electronicDocument"] ? ElectronicDocumentDto.fromJS(_data["electronicDocument"]) : <any>undefined;
            this.receiptId = _data["receiptId"];
            this.receipt = _data["receipt"] ? ReceiptDto.fromJS(_data["receipt"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.reference = _data["reference"];
            this.isMultiple = _data["isMultiple"];
        }
    }

    static fromJS(data: any): ElectronicDocumentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiptTotal"] = this.receiptTotal;
        data["payment"] = this.payment;
        data["electronicDocumentId"] = this.electronicDocumentId;
        data["electronicDocument"] = this.electronicDocument ? this.electronicDocument.toJSON() : <any>undefined;
        data["receiptId"] = this.receiptId;
        data["receipt"] = this.receipt ? this.receipt.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["reference"] = this.reference;
        data["isMultiple"] = this.isMultiple;
        return data; 
    }

    clone(): ElectronicDocumentReceiptDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentReceiptDto {
    id: number;
    receiptTotal: number | undefined;
    payment: number | undefined;
    electronicDocumentId: number;
    electronicDocument: ElectronicDocumentDto;
    receiptId: number;
    receipt: ReceiptDto;
    creationTime: moment.Moment;
    reference: string | undefined;
    isMultiple: boolean;
}

export class ElectronicDocumentReceiptDtoPagedResultDto implements IElectronicDocumentReceiptDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentReceiptDto[] | undefined;

    constructor(data?: IElectronicDocumentReceiptDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ElectronicDocumentReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectronicDocumentReceiptDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentReceiptDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ElectronicDocumentReceiptDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentReceiptDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentReceiptDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentReceiptDto[] | undefined;
}

export class AccountBalanceReportItemDto implements IAccountBalanceReportItemDto {
    date: moment.Moment;
    number: number;
    expirationDate: moment.Moment;
    total: number;
    paid: number;
    currentAmount: number;
    state: string | undefined;
    currencyTypeCode: string | undefined;
    id: number;

    constructor(data?: IAccountBalanceReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.paid = _data["paid"];
            this.currentAmount = _data["currentAmount"];
            this.state = _data["state"];
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AccountBalanceReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBalanceReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["paid"] = this.paid;
        data["currentAmount"] = this.currentAmount;
        data["state"] = this.state;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): AccountBalanceReportItemDto {
        const json = this.toJSON();
        let result = new AccountBalanceReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IAccountBalanceReportItemDto {
    date: moment.Moment;
    number: number;
    expirationDate: moment.Moment;
    total: number;
    paid: number;
    currentAmount: number;
    state: string | undefined;
    currencyTypeCode: string | undefined;
    id: number;
}

export class AccountBalanceReportDto implements IAccountBalanceReportDto {
    items: AccountBalanceReportItemDto[] | undefined;
    totalDebt: number;
    toExpire: number;
    expired: number;
    totalDebtUSD: number;
    toExpireUSD: number;
    expiredUSD: number;
    id: number;

    constructor(data?: IAccountBalanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AccountBalanceReportItemDto.fromJS(item));
            }
            this.totalDebt = _data["totalDebt"];
            this.toExpire = _data["toExpire"];
            this.expired = _data["expired"];
            this.totalDebtUSD = _data["totalDebtUSD"];
            this.toExpireUSD = _data["toExpireUSD"];
            this.expiredUSD = _data["expiredUSD"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AccountBalanceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBalanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalDebt"] = this.totalDebt;
        data["toExpire"] = this.toExpire;
        data["expired"] = this.expired;
        data["totalDebtUSD"] = this.totalDebtUSD;
        data["toExpireUSD"] = this.toExpireUSD;
        data["expiredUSD"] = this.expiredUSD;
        data["id"] = this.id;
        return data; 
    }

    clone(): AccountBalanceReportDto {
        const json = this.toJSON();
        let result = new AccountBalanceReportDto();
        result.init(json);
        return result;
    }
}

export interface IAccountBalanceReportDto {
    items: AccountBalanceReportItemDto[] | undefined;
    totalDebt: number;
    toExpire: number;
    expired: number;
    totalDebtUSD: number;
    toExpireUSD: number;
    expiredUSD: number;
    id: number;
}

export class ElectronicDocumentBulkDto implements IElectronicDocumentBulkDto {
    /** Descripción para identificación del lote. */
    description: string | undefined;
    statusId: DocumentStatus;
    tenantId: number | undefined;
    /** Identificador del lote en SIFEN. */
    sifenBulkId: string | undefined;
    /** Identificador de tipo de documento. */
    documentTypeId: number;
    documentType: DocumentTypeDto;
    /** Documentos electrónicos del lote. */
    electronicDocuments: ElectronicDocumentDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IElectronicDocumentBulkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.tenantId = _data["tenantId"];
            this.sifenBulkId = _data["sifenBulkId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            if (Array.isArray(_data["electronicDocuments"])) {
                this.electronicDocuments = [] as any;
                for (let item of _data["electronicDocuments"])
                    this.electronicDocuments.push(ElectronicDocumentDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicDocumentBulkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentBulkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["tenantId"] = this.tenantId;
        data["sifenBulkId"] = this.sifenBulkId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        if (Array.isArray(this.electronicDocuments)) {
            data["electronicDocuments"] = [];
            for (let item of this.electronicDocuments)
                data["electronicDocuments"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectronicDocumentBulkDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentBulkDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentBulkDto {
    /** Descripción para identificación del lote. */
    description: string | undefined;
    statusId: DocumentStatus;
    tenantId: number | undefined;
    /** Identificador del lote en SIFEN. */
    sifenBulkId: string | undefined;
    /** Identificador de tipo de documento. */
    documentTypeId: number;
    documentType: DocumentTypeDto;
    /** Documentos electrónicos del lote. */
    electronicDocuments: ElectronicDocumentDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ElectronicDocumentBulkDtoPagedResultDto implements IElectronicDocumentBulkDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentBulkDto[] | undefined;

    constructor(data?: IElectronicDocumentBulkDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ElectronicDocumentBulkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectronicDocumentBulkDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentBulkDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ElectronicDocumentBulkDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentBulkDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentBulkDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentBulkDto[] | undefined;
}

/** <p>Members:</p><ul><li><i>1</i> = Recibido</li><li><i>2</i> = Acuerdo total</li><li><i>3</i> = Acuerdo parcial</li><li><i>4</i> = Desacuerdo</li><li><i>5</i> = Documento desconocido</li></ul> */
export enum DocumentReceptionStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** Motivo de emisión para las Notas de Remisión Electrónicas. */
export class RemissionNoteReasonDto implements IRemissionNoteReasonDto {
    /** Nombre/Descripción de motivo de emisión. */
    name: string;
    /** Identificador del motivo de emisión en
el SIFEN. */
    identifier: number;
    id: number;

    constructor(data?: IRemissionNoteReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemissionNoteReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemissionNoteReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): RemissionNoteReasonDto {
        const json = this.toJSON();
        let result = new RemissionNoteReasonDto();
        result.init(json);
        return result;
    }
}

/** Motivo de emisión para las Notas de Remisión Electrónicas. */
export interface IRemissionNoteReasonDto {
    /** Nombre/Descripción de motivo de emisión. */
    name: string;
    /** Identificador del motivo de emisión en
el SIFEN. */
    identifier: number;
    id: number;
}

export class ElectronicDocumentReceptionItemDto implements IElectronicDocumentReceptionItemDto {
    internalCode: string;
    tariffHeading: number | undefined;
    mercosurNomenclature: number | undefined;
    generalDNCPCode: string | undefined;
    specificDNCPCode: string | undefined;
    productGTIN: number | undefined;
    packageGTIN: number | undefined;
    description: string;
    measurementUnitCode: number;
    quantity: number;
    productCountryCode: string | undefined;
    informationOfInterest: string | undefined;
    relevanceDataCode: RelevanceDataCodeEnum;
    brokeShrinkQuantity: number | undefined;
    brokeShrinkPercentage: number | undefined;
    advanceCDC: string | undefined;
    unitPriceWithTax: number | undefined;
    itemExchangeRate: number | undefined;
    itemUnitPriceDiscountWithTax: number | undefined;
    itemDiscountPercentage: number | undefined;
    itemUnitPriceGlobalDiscountWithTax: number | undefined;
    itemUnitPriceAdvanceWithTax: number | undefined;
    itemUnitPriceGlobalAdvanceWithTax: number | undefined;
    taxImpact: TaxImpact;
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    lotNumber: string | undefined;
    merchandiseExpiringDate: moment.Moment | undefined;
    serialNumber: string | undefined;
    orderNumber: string | undefined;
    trackingNumber: string | undefined;
    importerName: string | undefined;
    importerAddress: string | undefined;
    importerSignatureNumber: string | undefined;
    senaveProductRegistrationNumber: string | undefined;
    senaveBusinessRegistrationNumber: string | undefined;
    typeOfVehicleSale: VehicleSale;
    vehicleChassis: string | undefined;
    vechicleColor: string | undefined;
    enginePower: number | undefined;
    engineCapacity: number | undefined;
    netWeightInTons: number | undefined;
    grossWeightInTons: number | undefined;
    fuelTypeCode: number | undefined;
    engineNumber: string | undefined;
    tractionCapacityInTons: number | undefined;
    fabricationYear: number | undefined;
    vehicleType: string | undefined;
    seatedPassengersCapacity: number | undefined;
    engineDisplacement: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IElectronicDocumentReceptionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalCode = _data["internalCode"];
            this.tariffHeading = _data["tariffHeading"];
            this.mercosurNomenclature = _data["mercosurNomenclature"];
            this.generalDNCPCode = _data["generalDNCPCode"];
            this.specificDNCPCode = _data["specificDNCPCode"];
            this.productGTIN = _data["productGTIN"];
            this.packageGTIN = _data["packageGTIN"];
            this.description = _data["description"];
            this.measurementUnitCode = _data["measurementUnitCode"];
            this.quantity = _data["quantity"];
            this.productCountryCode = _data["productCountryCode"];
            this.informationOfInterest = _data["informationOfInterest"];
            this.relevanceDataCode = _data["relevanceDataCode"];
            this.brokeShrinkQuantity = _data["brokeShrinkQuantity"];
            this.brokeShrinkPercentage = _data["brokeShrinkPercentage"];
            this.advanceCDC = _data["advanceCDC"];
            this.unitPriceWithTax = _data["unitPriceWithTax"];
            this.itemExchangeRate = _data["itemExchangeRate"];
            this.itemUnitPriceDiscountWithTax = _data["itemUnitPriceDiscountWithTax"];
            this.itemDiscountPercentage = _data["itemDiscountPercentage"];
            this.itemUnitPriceGlobalDiscountWithTax = _data["itemUnitPriceGlobalDiscountWithTax"];
            this.itemUnitPriceAdvanceWithTax = _data["itemUnitPriceAdvanceWithTax"];
            this.itemUnitPriceGlobalAdvanceWithTax = _data["itemUnitPriceGlobalAdvanceWithTax"];
            this.taxImpact = _data["taxImpact"];
            this.taxedProportion = _data["taxedProportion"];
            this.taxRate = _data["taxRate"];
            this.lotNumber = _data["lotNumber"];
            this.merchandiseExpiringDate = _data["merchandiseExpiringDate"] ? moment(_data["merchandiseExpiringDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.orderNumber = _data["orderNumber"];
            this.trackingNumber = _data["trackingNumber"];
            this.importerName = _data["importerName"];
            this.importerAddress = _data["importerAddress"];
            this.importerSignatureNumber = _data["importerSignatureNumber"];
            this.senaveProductRegistrationNumber = _data["senaveProductRegistrationNumber"];
            this.senaveBusinessRegistrationNumber = _data["senaveBusinessRegistrationNumber"];
            this.typeOfVehicleSale = _data["typeOfVehicleSale"];
            this.vehicleChassis = _data["vehicleChassis"];
            this.vechicleColor = _data["vechicleColor"];
            this.enginePower = _data["enginePower"];
            this.engineCapacity = _data["engineCapacity"];
            this.netWeightInTons = _data["netWeightInTons"];
            this.grossWeightInTons = _data["grossWeightInTons"];
            this.fuelTypeCode = _data["fuelTypeCode"];
            this.engineNumber = _data["engineNumber"];
            this.tractionCapacityInTons = _data["tractionCapacityInTons"];
            this.fabricationYear = _data["fabricationYear"];
            this.vehicleType = _data["vehicleType"];
            this.seatedPassengersCapacity = _data["seatedPassengersCapacity"];
            this.engineDisplacement = _data["engineDisplacement"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicDocumentReceptionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentReceptionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalCode"] = this.internalCode;
        data["tariffHeading"] = this.tariffHeading;
        data["mercosurNomenclature"] = this.mercosurNomenclature;
        data["generalDNCPCode"] = this.generalDNCPCode;
        data["specificDNCPCode"] = this.specificDNCPCode;
        data["productGTIN"] = this.productGTIN;
        data["packageGTIN"] = this.packageGTIN;
        data["description"] = this.description;
        data["measurementUnitCode"] = this.measurementUnitCode;
        data["quantity"] = this.quantity;
        data["productCountryCode"] = this.productCountryCode;
        data["informationOfInterest"] = this.informationOfInterest;
        data["relevanceDataCode"] = this.relevanceDataCode;
        data["brokeShrinkQuantity"] = this.brokeShrinkQuantity;
        data["brokeShrinkPercentage"] = this.brokeShrinkPercentage;
        data["advanceCDC"] = this.advanceCDC;
        data["unitPriceWithTax"] = this.unitPriceWithTax;
        data["itemExchangeRate"] = this.itemExchangeRate;
        data["itemUnitPriceDiscountWithTax"] = this.itemUnitPriceDiscountWithTax;
        data["itemDiscountPercentage"] = this.itemDiscountPercentage;
        data["itemUnitPriceGlobalDiscountWithTax"] = this.itemUnitPriceGlobalDiscountWithTax;
        data["itemUnitPriceAdvanceWithTax"] = this.itemUnitPriceAdvanceWithTax;
        data["itemUnitPriceGlobalAdvanceWithTax"] = this.itemUnitPriceGlobalAdvanceWithTax;
        data["taxImpact"] = this.taxImpact;
        data["taxedProportion"] = this.taxedProportion;
        data["taxRate"] = this.taxRate;
        data["lotNumber"] = this.lotNumber;
        data["merchandiseExpiringDate"] = this.merchandiseExpiringDate ? this.merchandiseExpiringDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["orderNumber"] = this.orderNumber;
        data["trackingNumber"] = this.trackingNumber;
        data["importerName"] = this.importerName;
        data["importerAddress"] = this.importerAddress;
        data["importerSignatureNumber"] = this.importerSignatureNumber;
        data["senaveProductRegistrationNumber"] = this.senaveProductRegistrationNumber;
        data["senaveBusinessRegistrationNumber"] = this.senaveBusinessRegistrationNumber;
        data["typeOfVehicleSale"] = this.typeOfVehicleSale;
        data["vehicleChassis"] = this.vehicleChassis;
        data["vechicleColor"] = this.vechicleColor;
        data["enginePower"] = this.enginePower;
        data["engineCapacity"] = this.engineCapacity;
        data["netWeightInTons"] = this.netWeightInTons;
        data["grossWeightInTons"] = this.grossWeightInTons;
        data["fuelTypeCode"] = this.fuelTypeCode;
        data["engineNumber"] = this.engineNumber;
        data["tractionCapacityInTons"] = this.tractionCapacityInTons;
        data["fabricationYear"] = this.fabricationYear;
        data["vehicleType"] = this.vehicleType;
        data["seatedPassengersCapacity"] = this.seatedPassengersCapacity;
        data["engineDisplacement"] = this.engineDisplacement;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectronicDocumentReceptionItemDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentReceptionItemDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentReceptionItemDto {
    internalCode: string;
    tariffHeading: number | undefined;
    mercosurNomenclature: number | undefined;
    generalDNCPCode: string | undefined;
    specificDNCPCode: string | undefined;
    productGTIN: number | undefined;
    packageGTIN: number | undefined;
    description: string;
    measurementUnitCode: number;
    quantity: number;
    productCountryCode: string | undefined;
    informationOfInterest: string | undefined;
    relevanceDataCode: RelevanceDataCodeEnum;
    brokeShrinkQuantity: number | undefined;
    brokeShrinkPercentage: number | undefined;
    advanceCDC: string | undefined;
    unitPriceWithTax: number | undefined;
    itemExchangeRate: number | undefined;
    itemUnitPriceDiscountWithTax: number | undefined;
    itemDiscountPercentage: number | undefined;
    itemUnitPriceGlobalDiscountWithTax: number | undefined;
    itemUnitPriceAdvanceWithTax: number | undefined;
    itemUnitPriceGlobalAdvanceWithTax: number | undefined;
    taxImpact: TaxImpact;
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    lotNumber: string | undefined;
    merchandiseExpiringDate: moment.Moment | undefined;
    serialNumber: string | undefined;
    orderNumber: string | undefined;
    trackingNumber: string | undefined;
    importerName: string | undefined;
    importerAddress: string | undefined;
    importerSignatureNumber: string | undefined;
    senaveProductRegistrationNumber: string | undefined;
    senaveBusinessRegistrationNumber: string | undefined;
    typeOfVehicleSale: VehicleSale;
    vehicleChassis: string | undefined;
    vechicleColor: string | undefined;
    enginePower: number | undefined;
    engineCapacity: number | undefined;
    netWeightInTons: number | undefined;
    grossWeightInTons: number | undefined;
    fuelTypeCode: number | undefined;
    engineNumber: string | undefined;
    tractionCapacityInTons: number | undefined;
    fabricationYear: number | undefined;
    vehicleType: string | undefined;
    seatedPassengersCapacity: number | undefined;
    engineDisplacement: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** Método de pago. */
export class PaymentMethodDto implements IPaymentMethodDto {
    /** Nombre del método de pago. */
    name: string;
    /** Identificador en SIFEN del método de pago. */
    identifier: number;
    id: number;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaymentMethodDto {
        const json = this.toJSON();
        let result = new PaymentMethodDto();
        result.init(json);
        return result;
    }
}

/** Método de pago. */
export interface IPaymentMethodDto {
    /** Nombre del método de pago. */
    name: string;
    /** Identificador en SIFEN del método de pago. */
    identifier: number;
    id: number;
}

export class PaymentReceptionDto implements IPaymentReceptionDto {
    paymentMethodCode: number;
    paymentMethod: PaymentMethodDto;
    customPaymentMethod: string | undefined;
    currencyCode: string;
    exchangeRate: number | undefined;
    ammount: number;
    cardTypeCode: number | undefined;
    customCardType: string | undefined;
    cardType: CardTypeDto;
    cardProcessorName: string | undefined;
    cardProcessorRUC: string | undefined;
    paymentProcessorOption: PaymentProcessorOptions;
    operationAuthorizationCode: number | undefined;
    cardHolderName: string | undefined;
    cardLastFourNumbers: string | undefined;
    checkNumber: string | undefined;
    issuingBank: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPaymentReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodCode = _data["paymentMethodCode"];
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodDto.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.customPaymentMethod = _data["customPaymentMethod"];
            this.currencyCode = _data["currencyCode"];
            this.exchangeRate = _data["exchangeRate"];
            this.ammount = _data["ammount"];
            this.cardTypeCode = _data["cardTypeCode"];
            this.customCardType = _data["customCardType"];
            this.cardType = _data["cardType"] ? CardTypeDto.fromJS(_data["cardType"]) : <any>undefined;
            this.cardProcessorName = _data["cardProcessorName"];
            this.cardProcessorRUC = _data["cardProcessorRUC"];
            this.paymentProcessorOption = _data["paymentProcessorOption"];
            this.operationAuthorizationCode = _data["operationAuthorizationCode"];
            this.cardHolderName = _data["cardHolderName"];
            this.cardLastFourNumbers = _data["cardLastFourNumbers"];
            this.checkNumber = _data["checkNumber"];
            this.issuingBank = _data["issuingBank"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PaymentReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodCode"] = this.paymentMethodCode;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["customPaymentMethod"] = this.customPaymentMethod;
        data["currencyCode"] = this.currencyCode;
        data["exchangeRate"] = this.exchangeRate;
        data["ammount"] = this.ammount;
        data["cardTypeCode"] = this.cardTypeCode;
        data["customCardType"] = this.customCardType;
        data["cardType"] = this.cardType ? this.cardType.toJSON() : <any>undefined;
        data["cardProcessorName"] = this.cardProcessorName;
        data["cardProcessorRUC"] = this.cardProcessorRUC;
        data["paymentProcessorOption"] = this.paymentProcessorOption;
        data["operationAuthorizationCode"] = this.operationAuthorizationCode;
        data["cardHolderName"] = this.cardHolderName;
        data["cardLastFourNumbers"] = this.cardLastFourNumbers;
        data["checkNumber"] = this.checkNumber;
        data["issuingBank"] = this.issuingBank;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaymentReceptionDto {
        const json = this.toJSON();
        let result = new PaymentReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentReceptionDto {
    paymentMethodCode: number;
    paymentMethod: PaymentMethodDto;
    customPaymentMethod: string | undefined;
    currencyCode: string;
    exchangeRate: number | undefined;
    ammount: number;
    cardTypeCode: number | undefined;
    customCardType: string | undefined;
    cardType: CardTypeDto;
    cardProcessorName: string | undefined;
    cardProcessorRUC: string | undefined;
    paymentProcessorOption: PaymentProcessorOptions;
    operationAuthorizationCode: number | undefined;
    cardHolderName: string | undefined;
    cardLastFourNumbers: string | undefined;
    checkNumber: string | undefined;
    issuingBank: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class FeeReceptionDto implements IFeeReceptionDto {
    feeAmmount: number;
    feeDueDate: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFeeReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeAmmount = _data["feeAmmount"];
            this.feeDueDate = _data["feeDueDate"] ? moment(_data["feeDueDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FeeReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeAmmount"] = this.feeAmmount;
        data["feeDueDate"] = this.feeDueDate ? this.feeDueDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): FeeReceptionDto {
        const json = this.toJSON();
        let result = new FeeReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IFeeReceptionDto {
    feeAmmount: number;
    feeDueDate: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreditReceptionDto implements ICreditReceptionDto {
    creditOperationCondition: CreditOperationCondition;
    creditDeadline: string | undefined;
    feeNumbers: number | undefined;
    initialDeliveryAmmount: number | undefined;
    fees: FeeReceptionDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICreditReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditOperationCondition = _data["creditOperationCondition"];
            this.creditDeadline = _data["creditDeadline"];
            this.feeNumbers = _data["feeNumbers"];
            this.initialDeliveryAmmount = _data["initialDeliveryAmmount"];
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees.push(FeeReceptionDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreditReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditOperationCondition"] = this.creditOperationCondition;
        data["creditDeadline"] = this.creditDeadline;
        data["feeNumbers"] = this.feeNumbers;
        data["initialDeliveryAmmount"] = this.initialDeliveryAmmount;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreditReceptionDto {
        const json = this.toJSON();
        let result = new CreditReceptionDto();
        result.init(json);
        return result;
    }
}

export interface ICreditReceptionDto {
    creditOperationCondition: CreditOperationCondition;
    creditDeadline: string | undefined;
    feeNumbers: number | undefined;
    initialDeliveryAmmount: number | undefined;
    fees: FeeReceptionDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ElectricEnergyReceptionDto implements IElectricEnergyReceptionDto {
    meterNumber: string | undefined;
    activityCode: number | undefined;
    categoryCode: string | undefined;
    previousReading: number | undefined;
    actualReading: number | undefined;
    consumption: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IElectricEnergyReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.activityCode = _data["activityCode"];
            this.categoryCode = _data["categoryCode"];
            this.previousReading = _data["previousReading"];
            this.actualReading = _data["actualReading"];
            this.consumption = _data["consumption"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectricEnergyReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricEnergyReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["activityCode"] = this.activityCode;
        data["categoryCode"] = this.categoryCode;
        data["previousReading"] = this.previousReading;
        data["actualReading"] = this.actualReading;
        data["consumption"] = this.consumption;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectricEnergyReceptionDto {
        const json = this.toJSON();
        let result = new ElectricEnergyReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IElectricEnergyReceptionDto {
    meterNumber: string | undefined;
    activityCode: number | undefined;
    categoryCode: string | undefined;
    previousReading: number | undefined;
    actualReading: number | undefined;
    consumption: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SupermarketReceptionDto implements ISupermarketReceptionDto {
    cashierName: string | undefined;
    cash: number | undefined;
    change: number | undefined;
    donationAmmount: number | undefined;
    donationDescription: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISupermarketReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashierName = _data["cashierName"];
            this.cash = _data["cash"];
            this.change = _data["change"];
            this.donationAmmount = _data["donationAmmount"];
            this.donationDescription = _data["donationDescription"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupermarketReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupermarketReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierName"] = this.cashierName;
        data["cash"] = this.cash;
        data["change"] = this.change;
        data["donationAmmount"] = this.donationAmmount;
        data["donationDescription"] = this.donationDescription;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SupermarketReceptionDto {
        const json = this.toJSON();
        let result = new SupermarketReceptionDto();
        result.init(json);
        return result;
    }
}

export interface ISupermarketReceptionDto {
    cashierName: string | undefined;
    cash: number | undefined;
    change: number | undefined;
    donationAmmount: number | undefined;
    donationDescription: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommercialDataReceptionDto implements ICommercialDataReceptionDto {
    cycle: string | undefined;
    cycleStartDate: moment.Moment | undefined;
    cycleEndDate: moment.Moment | undefined;
    paymentDueDate: moment.Moment | undefined;
    contractNumber: string | undefined;
    previousBalance: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommercialDataReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycle = _data["cycle"];
            this.cycleStartDate = _data["cycleStartDate"] ? moment(_data["cycleStartDate"].toString()) : <any>undefined;
            this.cycleEndDate = _data["cycleEndDate"] ? moment(_data["cycleEndDate"].toString()) : <any>undefined;
            this.paymentDueDate = _data["paymentDueDate"] ? moment(_data["paymentDueDate"].toString()) : <any>undefined;
            this.contractNumber = _data["contractNumber"];
            this.previousBalance = _data["previousBalance"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommercialDataReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialDataReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycle"] = this.cycle;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : <any>undefined;
        data["cycleEndDate"] = this.cycleEndDate ? this.cycleEndDate.toISOString() : <any>undefined;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : <any>undefined;
        data["contractNumber"] = this.contractNumber;
        data["previousBalance"] = this.previousBalance;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CommercialDataReceptionDto {
        const json = this.toJSON();
        let result = new CommercialDataReceptionDto();
        result.init(json);
        return result;
    }
}

export interface ICommercialDataReceptionDto {
    cycle: string | undefined;
    cycleStartDate: moment.Moment | undefined;
    cycleEndDate: moment.Moment | undefined;
    paymentDueDate: moment.Moment | undefined;
    contractNumber: string | undefined;
    previousBalance: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MerchandiseDepartureReceptionDto implements IMerchandiseDepartureReceptionDto {
    departureLocationAddress: string;
    departureHouseNumber: number;
    addressComplement1: string | undefined;
    addressComplement2: string | undefined;
    cityCode: number;
    departurePhoneNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMerchandiseDepartureReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureLocationAddress = _data["departureLocationAddress"];
            this.departureHouseNumber = _data["departureHouseNumber"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.cityCode = _data["cityCode"];
            this.departurePhoneNumber = _data["departurePhoneNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseDepartureReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseDepartureReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureLocationAddress"] = this.departureLocationAddress;
        data["departureHouseNumber"] = this.departureHouseNumber;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["cityCode"] = this.cityCode;
        data["departurePhoneNumber"] = this.departurePhoneNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseDepartureReceptionDto {
        const json = this.toJSON();
        let result = new MerchandiseDepartureReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IMerchandiseDepartureReceptionDto {
    departureLocationAddress: string;
    departureHouseNumber: number;
    addressComplement1: string | undefined;
    addressComplement2: string | undefined;
    cityCode: number;
    departurePhoneNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MerchandiseDeliveryReceptionDto implements IMerchandiseDeliveryReceptionDto {
    deliveryLocationAddress: string;
    deliveryHouseNumber: number;
    addressComplement1: string | undefined;
    addressComplement2: string | undefined;
    cityCode: number;
    deliveryPhoneNumber: string | undefined;

    constructor(data?: IMerchandiseDeliveryReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryLocationAddress = _data["deliveryLocationAddress"];
            this.deliveryHouseNumber = _data["deliveryHouseNumber"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.cityCode = _data["cityCode"];
            this.deliveryPhoneNumber = _data["deliveryPhoneNumber"];
        }
    }

    static fromJS(data: any): MerchandiseDeliveryReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseDeliveryReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryLocationAddress"] = this.deliveryLocationAddress;
        data["deliveryHouseNumber"] = this.deliveryHouseNumber;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["cityCode"] = this.cityCode;
        data["deliveryPhoneNumber"] = this.deliveryPhoneNumber;
        return data; 
    }

    clone(): MerchandiseDeliveryReceptionDto {
        const json = this.toJSON();
        let result = new MerchandiseDeliveryReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IMerchandiseDeliveryReceptionDto {
    deliveryLocationAddress: string;
    deliveryHouseNumber: number;
    addressComplement1: string | undefined;
    addressComplement2: string | undefined;
    cityCode: number;
    deliveryPhoneNumber: string | undefined;
}

export class MerchandiseTransportVehicleReceptionDto implements IMerchandiseTransportVehicleReceptionDto {
    vehicleType: string;
    brand: string;
    vehicleIdentificationType: VehicleIdentificationType;
    vehicleIdentificationNumber: string | undefined;
    vehicleAditionalInformation: string | undefined;
    vehicleRegistrationPlate: string | undefined;
    flightNumber: string | undefined;

    constructor(data?: IMerchandiseTransportVehicleReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleType = _data["vehicleType"];
            this.brand = _data["brand"];
            this.vehicleIdentificationType = _data["vehicleIdentificationType"];
            this.vehicleIdentificationNumber = _data["vehicleIdentificationNumber"];
            this.vehicleAditionalInformation = _data["vehicleAditionalInformation"];
            this.vehicleRegistrationPlate = _data["vehicleRegistrationPlate"];
            this.flightNumber = _data["flightNumber"];
        }
    }

    static fromJS(data: any): MerchandiseTransportVehicleReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseTransportVehicleReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleType"] = this.vehicleType;
        data["brand"] = this.brand;
        data["vehicleIdentificationType"] = this.vehicleIdentificationType;
        data["vehicleIdentificationNumber"] = this.vehicleIdentificationNumber;
        data["vehicleAditionalInformation"] = this.vehicleAditionalInformation;
        data["vehicleRegistrationPlate"] = this.vehicleRegistrationPlate;
        data["flightNumber"] = this.flightNumber;
        return data; 
    }

    clone(): MerchandiseTransportVehicleReceptionDto {
        const json = this.toJSON();
        let result = new MerchandiseTransportVehicleReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IMerchandiseTransportVehicleReceptionDto {
    vehicleType: string;
    brand: string;
    vehicleIdentificationType: VehicleIdentificationType;
    vehicleIdentificationNumber: string | undefined;
    vehicleAditionalInformation: string | undefined;
    vehicleRegistrationPlate: string | undefined;
    flightNumber: string | undefined;
}

export class MerchandiseCarrierReceptionDto implements IMerchandiseCarrierReceptionDto {
    carrierNatureType: NatureType;
    carrierName: string;
    carrierRUC: string | undefined;
    carrierIdentityDocumentTypeCode: number | undefined;
    carrierNationalityCountryCode: string | undefined;
    carrierAddress: string | undefined;
    driverDocumentNumber: string;
    driverNameAndLastName: string;
    driverAddress: string | undefined;
    agentName: string | undefined;
    agentRUC: string | undefined;
    agentAddress: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMerchandiseCarrierReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierNatureType = _data["carrierNatureType"];
            this.carrierName = _data["carrierName"];
            this.carrierRUC = _data["carrierRUC"];
            this.carrierIdentityDocumentTypeCode = _data["carrierIdentityDocumentTypeCode"];
            this.carrierNationalityCountryCode = _data["carrierNationalityCountryCode"];
            this.carrierAddress = _data["carrierAddress"];
            this.driverDocumentNumber = _data["driverDocumentNumber"];
            this.driverNameAndLastName = _data["driverNameAndLastName"];
            this.driverAddress = _data["driverAddress"];
            this.agentName = _data["agentName"];
            this.agentRUC = _data["agentRUC"];
            this.agentAddress = _data["agentAddress"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseCarrierReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseCarrierReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierNatureType"] = this.carrierNatureType;
        data["carrierName"] = this.carrierName;
        data["carrierRUC"] = this.carrierRUC;
        data["carrierIdentityDocumentTypeCode"] = this.carrierIdentityDocumentTypeCode;
        data["carrierNationalityCountryCode"] = this.carrierNationalityCountryCode;
        data["carrierAddress"] = this.carrierAddress;
        data["driverDocumentNumber"] = this.driverDocumentNumber;
        data["driverNameAndLastName"] = this.driverNameAndLastName;
        data["driverAddress"] = this.driverAddress;
        data["agentName"] = this.agentName;
        data["agentRUC"] = this.agentRUC;
        data["agentAddress"] = this.agentAddress;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseCarrierReceptionDto {
        const json = this.toJSON();
        let result = new MerchandiseCarrierReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IMerchandiseCarrierReceptionDto {
    carrierNatureType: NatureType;
    carrierName: string;
    carrierRUC: string | undefined;
    carrierIdentityDocumentTypeCode: number | undefined;
    carrierNationalityCountryCode: string | undefined;
    carrierAddress: string | undefined;
    driverDocumentNumber: string;
    driverNameAndLastName: string;
    driverAddress: string | undefined;
    agentName: string | undefined;
    agentRUC: string | undefined;
    agentAddress: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MerchandiseTransportReceptionDto implements IMerchandiseTransportReceptionDto {
    transportType: TransportType;
    transportMode: TransportMode;
    freightCostResponsible: FreightCostResponsibleEnum;
    merchandiseNegotiationConditionCode: string | undefined;
    manifestNumber: string | undefined;
    importClearanceNumber: string | undefined;
    estimatedTransferStartDate: moment.Moment | undefined;
    estimatedTransferEndDate: moment.Moment | undefined;
    countryCode: string | undefined;
    merchandiseDeparture: MerchandiseDepartureReceptionDto;
    merchandiseDeliveries: MerchandiseDeliveryReceptionDto[] | undefined;
    merchandiseTransportVehicles: MerchandiseTransportVehicleReceptionDto[] | undefined;
    merchandiseCarrier: MerchandiseCarrierReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMerchandiseTransportReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transportType = _data["transportType"];
            this.transportMode = _data["transportMode"];
            this.freightCostResponsible = _data["freightCostResponsible"];
            this.merchandiseNegotiationConditionCode = _data["merchandiseNegotiationConditionCode"];
            this.manifestNumber = _data["manifestNumber"];
            this.importClearanceNumber = _data["importClearanceNumber"];
            this.estimatedTransferStartDate = _data["estimatedTransferStartDate"] ? moment(_data["estimatedTransferStartDate"].toString()) : <any>undefined;
            this.estimatedTransferEndDate = _data["estimatedTransferEndDate"] ? moment(_data["estimatedTransferEndDate"].toString()) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.merchandiseDeparture = _data["merchandiseDeparture"] ? MerchandiseDepartureReceptionDto.fromJS(_data["merchandiseDeparture"]) : <any>undefined;
            if (Array.isArray(_data["merchandiseDeliveries"])) {
                this.merchandiseDeliveries = [] as any;
                for (let item of _data["merchandiseDeliveries"])
                    this.merchandiseDeliveries.push(MerchandiseDeliveryReceptionDto.fromJS(item));
            }
            if (Array.isArray(_data["merchandiseTransportVehicles"])) {
                this.merchandiseTransportVehicles = [] as any;
                for (let item of _data["merchandiseTransportVehicles"])
                    this.merchandiseTransportVehicles.push(MerchandiseTransportVehicleReceptionDto.fromJS(item));
            }
            this.merchandiseCarrier = _data["merchandiseCarrier"] ? MerchandiseCarrierReceptionDto.fromJS(_data["merchandiseCarrier"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseTransportReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseTransportReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportType"] = this.transportType;
        data["transportMode"] = this.transportMode;
        data["freightCostResponsible"] = this.freightCostResponsible;
        data["merchandiseNegotiationConditionCode"] = this.merchandiseNegotiationConditionCode;
        data["manifestNumber"] = this.manifestNumber;
        data["importClearanceNumber"] = this.importClearanceNumber;
        data["estimatedTransferStartDate"] = this.estimatedTransferStartDate ? this.estimatedTransferStartDate.toISOString() : <any>undefined;
        data["estimatedTransferEndDate"] = this.estimatedTransferEndDate ? this.estimatedTransferEndDate.toISOString() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["merchandiseDeparture"] = this.merchandiseDeparture ? this.merchandiseDeparture.toJSON() : <any>undefined;
        if (Array.isArray(this.merchandiseDeliveries)) {
            data["merchandiseDeliveries"] = [];
            for (let item of this.merchandiseDeliveries)
                data["merchandiseDeliveries"].push(item.toJSON());
        }
        if (Array.isArray(this.merchandiseTransportVehicles)) {
            data["merchandiseTransportVehicles"] = [];
            for (let item of this.merchandiseTransportVehicles)
                data["merchandiseTransportVehicles"].push(item.toJSON());
        }
        data["merchandiseCarrier"] = this.merchandiseCarrier ? this.merchandiseCarrier.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseTransportReceptionDto {
        const json = this.toJSON();
        let result = new MerchandiseTransportReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IMerchandiseTransportReceptionDto {
    transportType: TransportType;
    transportMode: TransportMode;
    freightCostResponsible: FreightCostResponsibleEnum;
    merchandiseNegotiationConditionCode: string | undefined;
    manifestNumber: string | undefined;
    importClearanceNumber: string | undefined;
    estimatedTransferStartDate: moment.Moment | undefined;
    estimatedTransferEndDate: moment.Moment | undefined;
    countryCode: string | undefined;
    merchandiseDeparture: MerchandiseDepartureReceptionDto;
    merchandiseDeliveries: MerchandiseDeliveryReceptionDto[] | undefined;
    merchandiseTransportVehicles: MerchandiseTransportVehicleReceptionDto[] | undefined;
    merchandiseCarrier: MerchandiseCarrierReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class InsuranceReceptionPolicyDto implements IInsuranceReceptionPolicyDto {
    policyCode: string;
    policyValidityTimeUnit: string;
    policyValidity: number;
    policyNumber: string;
    validityStartDate: moment.Moment | undefined;
    validityEndDate: moment.Moment | undefined;
    itemInternalCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IInsuranceReceptionPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyCode = _data["policyCode"];
            this.policyValidityTimeUnit = _data["policyValidityTimeUnit"];
            this.policyValidity = _data["policyValidity"];
            this.policyNumber = _data["policyNumber"];
            this.validityStartDate = _data["validityStartDate"] ? moment(_data["validityStartDate"].toString()) : <any>undefined;
            this.validityEndDate = _data["validityEndDate"] ? moment(_data["validityEndDate"].toString()) : <any>undefined;
            this.itemInternalCode = _data["itemInternalCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsuranceReceptionPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceReceptionPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyCode"] = this.policyCode;
        data["policyValidityTimeUnit"] = this.policyValidityTimeUnit;
        data["policyValidity"] = this.policyValidity;
        data["policyNumber"] = this.policyNumber;
        data["validityStartDate"] = this.validityStartDate ? this.validityStartDate.toISOString() : <any>undefined;
        data["validityEndDate"] = this.validityEndDate ? this.validityEndDate.toISOString() : <any>undefined;
        data["itemInternalCode"] = this.itemInternalCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsuranceReceptionPolicyDto {
        const json = this.toJSON();
        let result = new InsuranceReceptionPolicyDto();
        result.init(json);
        return result;
    }
}

export interface IInsuranceReceptionPolicyDto {
    policyCode: string;
    policyValidityTimeUnit: string;
    policyValidity: number;
    policyNumber: string;
    validityStartDate: moment.Moment | undefined;
    validityEndDate: moment.Moment | undefined;
    itemInternalCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class InsuranceReceptionDto implements IInsuranceReceptionDto {
    insuranceSuperintendenceCompanyCode: string | undefined;
    insurancePolicies: InsuranceReceptionPolicyDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IInsuranceReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceSuperintendenceCompanyCode = _data["insuranceSuperintendenceCompanyCode"];
            if (Array.isArray(_data["insurancePolicies"])) {
                this.insurancePolicies = [] as any;
                for (let item of _data["insurancePolicies"])
                    this.insurancePolicies.push(InsuranceReceptionPolicyDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsuranceReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceSuperintendenceCompanyCode"] = this.insuranceSuperintendenceCompanyCode;
        if (Array.isArray(this.insurancePolicies)) {
            data["insurancePolicies"] = [];
            for (let item of this.insurancePolicies)
                data["insurancePolicies"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsuranceReceptionDto {
        const json = this.toJSON();
        let result = new InsuranceReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IInsuranceReceptionDto {
    insuranceSuperintendenceCompanyCode: string | undefined;
    insurancePolicies: InsuranceReceptionPolicyDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssociatedDocumentReceptionDto implements IAssociatedDocumentReceptionDto {
    associatedDocumentType: AssociatedDocumentType;
    cdc: string | undefined;
    stampNumber: number | undefined;
    stablishment: string | undefined;
    expeditionPoint: string | undefined;
    documentNumber: string | undefined;
    documentTypeCode: number | undefined;
    issuingDate: moment.Moment | undefined;
    withholdingVoucherNumber: string | undefined;
    taxCreditResolutionNumber: string | undefined;
    recordType: RecordType;
    recordNumber: number | undefined;
    recordControlNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssociatedDocumentReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.associatedDocumentType = _data["associatedDocumentType"];
            this.cdc = _data["cdc"];
            this.stampNumber = _data["stampNumber"];
            this.stablishment = _data["stablishment"];
            this.expeditionPoint = _data["expeditionPoint"];
            this.documentNumber = _data["documentNumber"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.issuingDate = _data["issuingDate"] ? moment(_data["issuingDate"].toString()) : <any>undefined;
            this.withholdingVoucherNumber = _data["withholdingVoucherNumber"];
            this.taxCreditResolutionNumber = _data["taxCreditResolutionNumber"];
            this.recordType = _data["recordType"];
            this.recordNumber = _data["recordNumber"];
            this.recordControlNumber = _data["recordControlNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssociatedDocumentReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedDocumentReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associatedDocumentType"] = this.associatedDocumentType;
        data["cdc"] = this.cdc;
        data["stampNumber"] = this.stampNumber;
        data["stablishment"] = this.stablishment;
        data["expeditionPoint"] = this.expeditionPoint;
        data["documentNumber"] = this.documentNumber;
        data["documentTypeCode"] = this.documentTypeCode;
        data["issuingDate"] = this.issuingDate ? this.issuingDate.toISOString() : <any>undefined;
        data["withholdingVoucherNumber"] = this.withholdingVoucherNumber;
        data["taxCreditResolutionNumber"] = this.taxCreditResolutionNumber;
        data["recordType"] = this.recordType;
        data["recordNumber"] = this.recordNumber;
        data["recordControlNumber"] = this.recordControlNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AssociatedDocumentReceptionDto {
        const json = this.toJSON();
        let result = new AssociatedDocumentReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IAssociatedDocumentReceptionDto {
    associatedDocumentType: AssociatedDocumentType;
    cdc: string | undefined;
    stampNumber: number | undefined;
    stablishment: string | undefined;
    expeditionPoint: string | undefined;
    documentNumber: string | undefined;
    documentTypeCode: number | undefined;
    issuingDate: moment.Moment | undefined;
    withholdingVoucherNumber: string | undefined;
    taxCreditResolutionNumber: string | undefined;
    recordType: RecordType;
    recordNumber: number | undefined;
    recordControlNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ElectronicDocumentReceptionDto implements IElectronicDocumentReceptionDto {
    cdc: string | undefined;
    clientId: number;
    issuedDate: moment.Moment;
    number: number;
    securityCode: string | undefined;
    statusId: DocumentReceptionStatus;
    approvedDate: moment.Moment | undefined;
    statusMessage: string | undefined;
    documentTypeCode: number;
    transactionTypeCode: number | undefined;
    sellerNatureTypeId: number | undefined;
    transactionCityCode: number | undefined;
    transactionPlace: string | undefined;
    creditNoteReasonCode: number | undefined;
    creditNoteReason: CreditNoteReasonDto;
    remissionNoteReasonCode: number | undefined;
    remissionNoteReason: RemissionNoteReasonDto;
    customRemissionReason: string | undefined;
    estimatedKilometersOfTravel: number | undefined;
    futureDateOfInvoiceIssue: moment.Moment | undefined;
    remissionNoteResponsible: RemissionNoteResponsible;
    operationCondition: OperationCondition;
    taxTypeCode: number;
    issuingType: IssuingType;
    stampNumber: number;
    stablishment: string;
    expeditionPoint: string;
    series: string | undefined;
    stampDate: moment.Moment;
    currencyTypeCode: string;
    exchangeRateCondition: number | undefined;
    advanceCondition: AdvanceConditionEnum;
    exchangeRate: number | undefined;
    subTotal: number;
    total: number;
    tax: number;
    branchId: number | undefined;
    tenantId: number | undefined;
    presenceIndicatorCode: number | undefined;
    dateOfShipment: moment.Moment | undefined;
    modality: string | undefined;
    entity: number | undefined;
    year: number | undefined;
    sequence: number | undefined;
    aditionalInformation: string | undefined;
    aditionalTreasuryInformation: string | undefined;
    contractingDate: moment.Moment | undefined;
    electronicDocumentBulkId: number | undefined;
    qrCode: string | undefined;
    client: ReceiverDto;
    electronicDocumentItems: ElectronicDocumentReceptionItemDto[] | undefined;
    branch: BranchDto;
    currencyType: CurrencyTypeDto;
    documentType: DocumentTypeDto;
    transactionType: TransactionTypeDto;
    presenceIndicator: PresenceIndicatorDto;
    taxType: TaxTypeDto;
    payments: PaymentReceptionDto[] | undefined;
    tenant: TenantDto;
    credit: CreditReceptionDto;
    electricEnergy: ElectricEnergyReceptionDto;
    supermarket: SupermarketReceptionDto;
    commercialData: CommercialDataReceptionDto;
    merchandiseTransport: MerchandiseTransportReceptionDto;
    insurance: InsuranceReceptionDto;
    associatedDocuments: AssociatedDocumentReceptionDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IElectronicDocumentReceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cdc = _data["cdc"];
            this.clientId = _data["clientId"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.securityCode = _data["securityCode"];
            this.statusId = _data["statusId"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.statusMessage = _data["statusMessage"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.transactionTypeCode = _data["transactionTypeCode"];
            this.sellerNatureTypeId = _data["sellerNatureTypeId"];
            this.transactionCityCode = _data["transactionCityCode"];
            this.transactionPlace = _data["transactionPlace"];
            this.creditNoteReasonCode = _data["creditNoteReasonCode"];
            this.creditNoteReason = _data["creditNoteReason"] ? CreditNoteReasonDto.fromJS(_data["creditNoteReason"]) : <any>undefined;
            this.remissionNoteReasonCode = _data["remissionNoteReasonCode"];
            this.remissionNoteReason = _data["remissionNoteReason"] ? RemissionNoteReasonDto.fromJS(_data["remissionNoteReason"]) : <any>undefined;
            this.customRemissionReason = _data["customRemissionReason"];
            this.estimatedKilometersOfTravel = _data["estimatedKilometersOfTravel"];
            this.futureDateOfInvoiceIssue = _data["futureDateOfInvoiceIssue"] ? moment(_data["futureDateOfInvoiceIssue"].toString()) : <any>undefined;
            this.remissionNoteResponsible = _data["remissionNoteResponsible"];
            this.operationCondition = _data["operationCondition"];
            this.taxTypeCode = _data["taxTypeCode"];
            this.issuingType = _data["issuingType"];
            this.stampNumber = _data["stampNumber"];
            this.stablishment = _data["stablishment"];
            this.expeditionPoint = _data["expeditionPoint"];
            this.series = _data["series"];
            this.stampDate = _data["stampDate"] ? moment(_data["stampDate"].toString()) : <any>undefined;
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.exchangeRateCondition = _data["exchangeRateCondition"];
            this.advanceCondition = _data["advanceCondition"];
            this.exchangeRate = _data["exchangeRate"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.tax = _data["tax"];
            this.branchId = _data["branchId"];
            this.tenantId = _data["tenantId"];
            this.presenceIndicatorCode = _data["presenceIndicatorCode"];
            this.dateOfShipment = _data["dateOfShipment"] ? moment(_data["dateOfShipment"].toString()) : <any>undefined;
            this.modality = _data["modality"];
            this.entity = _data["entity"];
            this.year = _data["year"];
            this.sequence = _data["sequence"];
            this.aditionalInformation = _data["aditionalInformation"];
            this.aditionalTreasuryInformation = _data["aditionalTreasuryInformation"];
            this.contractingDate = _data["contractingDate"] ? moment(_data["contractingDate"].toString()) : <any>undefined;
            this.electronicDocumentBulkId = _data["electronicDocumentBulkId"];
            this.qrCode = _data["qrCode"];
            this.client = _data["client"] ? ReceiverDto.fromJS(_data["client"]) : <any>undefined;
            if (Array.isArray(_data["electronicDocumentItems"])) {
                this.electronicDocumentItems = [] as any;
                for (let item of _data["electronicDocumentItems"])
                    this.electronicDocumentItems.push(ElectronicDocumentReceptionItemDto.fromJS(item));
            }
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.currencyType = _data["currencyType"] ? CurrencyTypeDto.fromJS(_data["currencyType"]) : <any>undefined;
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.transactionType = _data["transactionType"] ? TransactionTypeDto.fromJS(_data["transactionType"]) : <any>undefined;
            this.presenceIndicator = _data["presenceIndicator"] ? PresenceIndicatorDto.fromJS(_data["presenceIndicator"]) : <any>undefined;
            this.taxType = _data["taxType"] ? TaxTypeDto.fromJS(_data["taxType"]) : <any>undefined;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(PaymentReceptionDto.fromJS(item));
            }
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.credit = _data["credit"] ? CreditReceptionDto.fromJS(_data["credit"]) : <any>undefined;
            this.electricEnergy = _data["electricEnergy"] ? ElectricEnergyReceptionDto.fromJS(_data["electricEnergy"]) : <any>undefined;
            this.supermarket = _data["supermarket"] ? SupermarketReceptionDto.fromJS(_data["supermarket"]) : <any>undefined;
            this.commercialData = _data["commercialData"] ? CommercialDataReceptionDto.fromJS(_data["commercialData"]) : <any>undefined;
            this.merchandiseTransport = _data["merchandiseTransport"] ? MerchandiseTransportReceptionDto.fromJS(_data["merchandiseTransport"]) : <any>undefined;
            this.insurance = _data["insurance"] ? InsuranceReceptionDto.fromJS(_data["insurance"]) : <any>undefined;
            if (Array.isArray(_data["associatedDocuments"])) {
                this.associatedDocuments = [] as any;
                for (let item of _data["associatedDocuments"])
                    this.associatedDocuments.push(AssociatedDocumentReceptionDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicDocumentReceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentReceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cdc"] = this.cdc;
        data["clientId"] = this.clientId;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["securityCode"] = this.securityCode;
        data["statusId"] = this.statusId;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["statusMessage"] = this.statusMessage;
        data["documentTypeCode"] = this.documentTypeCode;
        data["transactionTypeCode"] = this.transactionTypeCode;
        data["sellerNatureTypeId"] = this.sellerNatureTypeId;
        data["transactionCityCode"] = this.transactionCityCode;
        data["transactionPlace"] = this.transactionPlace;
        data["creditNoteReasonCode"] = this.creditNoteReasonCode;
        data["creditNoteReason"] = this.creditNoteReason ? this.creditNoteReason.toJSON() : <any>undefined;
        data["remissionNoteReasonCode"] = this.remissionNoteReasonCode;
        data["remissionNoteReason"] = this.remissionNoteReason ? this.remissionNoteReason.toJSON() : <any>undefined;
        data["customRemissionReason"] = this.customRemissionReason;
        data["estimatedKilometersOfTravel"] = this.estimatedKilometersOfTravel;
        data["futureDateOfInvoiceIssue"] = this.futureDateOfInvoiceIssue ? this.futureDateOfInvoiceIssue.toISOString() : <any>undefined;
        data["remissionNoteResponsible"] = this.remissionNoteResponsible;
        data["operationCondition"] = this.operationCondition;
        data["taxTypeCode"] = this.taxTypeCode;
        data["issuingType"] = this.issuingType;
        data["stampNumber"] = this.stampNumber;
        data["stablishment"] = this.stablishment;
        data["expeditionPoint"] = this.expeditionPoint;
        data["series"] = this.series;
        data["stampDate"] = this.stampDate ? this.stampDate.toISOString() : <any>undefined;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["exchangeRateCondition"] = this.exchangeRateCondition;
        data["advanceCondition"] = this.advanceCondition;
        data["exchangeRate"] = this.exchangeRate;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["tax"] = this.tax;
        data["branchId"] = this.branchId;
        data["tenantId"] = this.tenantId;
        data["presenceIndicatorCode"] = this.presenceIndicatorCode;
        data["dateOfShipment"] = this.dateOfShipment ? this.dateOfShipment.toISOString() : <any>undefined;
        data["modality"] = this.modality;
        data["entity"] = this.entity;
        data["year"] = this.year;
        data["sequence"] = this.sequence;
        data["aditionalInformation"] = this.aditionalInformation;
        data["aditionalTreasuryInformation"] = this.aditionalTreasuryInformation;
        data["contractingDate"] = this.contractingDate ? this.contractingDate.toISOString() : <any>undefined;
        data["electronicDocumentBulkId"] = this.electronicDocumentBulkId;
        data["qrCode"] = this.qrCode;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        if (Array.isArray(this.electronicDocumentItems)) {
            data["electronicDocumentItems"] = [];
            for (let item of this.electronicDocumentItems)
                data["electronicDocumentItems"].push(item.toJSON());
        }
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["currencyType"] = this.currencyType ? this.currencyType.toJSON() : <any>undefined;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["presenceIndicator"] = this.presenceIndicator ? this.presenceIndicator.toJSON() : <any>undefined;
        data["taxType"] = this.taxType ? this.taxType.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["credit"] = this.credit ? this.credit.toJSON() : <any>undefined;
        data["electricEnergy"] = this.electricEnergy ? this.electricEnergy.toJSON() : <any>undefined;
        data["supermarket"] = this.supermarket ? this.supermarket.toJSON() : <any>undefined;
        data["commercialData"] = this.commercialData ? this.commercialData.toJSON() : <any>undefined;
        data["merchandiseTransport"] = this.merchandiseTransport ? this.merchandiseTransport.toJSON() : <any>undefined;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        if (Array.isArray(this.associatedDocuments)) {
            data["associatedDocuments"] = [];
            for (let item of this.associatedDocuments)
                data["associatedDocuments"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectronicDocumentReceptionDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentReceptionDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentReceptionDto {
    cdc: string | undefined;
    clientId: number;
    issuedDate: moment.Moment;
    number: number;
    securityCode: string | undefined;
    statusId: DocumentReceptionStatus;
    approvedDate: moment.Moment | undefined;
    statusMessage: string | undefined;
    documentTypeCode: number;
    transactionTypeCode: number | undefined;
    sellerNatureTypeId: number | undefined;
    transactionCityCode: number | undefined;
    transactionPlace: string | undefined;
    creditNoteReasonCode: number | undefined;
    creditNoteReason: CreditNoteReasonDto;
    remissionNoteReasonCode: number | undefined;
    remissionNoteReason: RemissionNoteReasonDto;
    customRemissionReason: string | undefined;
    estimatedKilometersOfTravel: number | undefined;
    futureDateOfInvoiceIssue: moment.Moment | undefined;
    remissionNoteResponsible: RemissionNoteResponsible;
    operationCondition: OperationCondition;
    taxTypeCode: number;
    issuingType: IssuingType;
    stampNumber: number;
    stablishment: string;
    expeditionPoint: string;
    series: string | undefined;
    stampDate: moment.Moment;
    currencyTypeCode: string;
    exchangeRateCondition: number | undefined;
    advanceCondition: AdvanceConditionEnum;
    exchangeRate: number | undefined;
    subTotal: number;
    total: number;
    tax: number;
    branchId: number | undefined;
    tenantId: number | undefined;
    presenceIndicatorCode: number | undefined;
    dateOfShipment: moment.Moment | undefined;
    modality: string | undefined;
    entity: number | undefined;
    year: number | undefined;
    sequence: number | undefined;
    aditionalInformation: string | undefined;
    aditionalTreasuryInformation: string | undefined;
    contractingDate: moment.Moment | undefined;
    electronicDocumentBulkId: number | undefined;
    qrCode: string | undefined;
    client: ReceiverDto;
    electronicDocumentItems: ElectronicDocumentReceptionItemDto[] | undefined;
    branch: BranchDto;
    currencyType: CurrencyTypeDto;
    documentType: DocumentTypeDto;
    transactionType: TransactionTypeDto;
    presenceIndicator: PresenceIndicatorDto;
    taxType: TaxTypeDto;
    payments: PaymentReceptionDto[] | undefined;
    tenant: TenantDto;
    credit: CreditReceptionDto;
    electricEnergy: ElectricEnergyReceptionDto;
    supermarket: SupermarketReceptionDto;
    commercialData: CommercialDataReceptionDto;
    merchandiseTransport: MerchandiseTransportReceptionDto;
    insurance: InsuranceReceptionDto;
    associatedDocuments: AssociatedDocumentReceptionDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ElectronicDocumentReceptionDtoPagedResultDto implements IElectronicDocumentReceptionDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentReceptionDto[] | undefined;

    constructor(data?: IElectronicDocumentReceptionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ElectronicDocumentReceptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectronicDocumentReceptionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentReceptionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ElectronicDocumentReceptionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentReceptionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentReceptionDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentReceptionDto[] | undefined;
}

/** <p>Members:</p><ul><li><i>1</i> = PDF</li><li><i>2</i> = Ticket</li></ul> */
export enum TemplateTypeEnum {
    _1 = 1,
    _2 = 2,
}

export class ElectronicDocumentTemplateDto implements IElectronicDocumentTemplateDto {
    template: string | undefined;
    templateType: TemplateTypeEnum;
    id: number;

    constructor(data?: IElectronicDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
            this.templateType = _data["templateType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicDocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        data["templateType"] = this.templateType;
        data["id"] = this.id;
        return data; 
    }

    clone(): ElectronicDocumentTemplateDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentTemplateDto {
    template: string | undefined;
    templateType: TemplateTypeEnum;
    id: number;
}

export class ObjectPagedResultDto implements IObjectPagedResultDto {
    totalCount: number;
    items: any[] | undefined;

    constructor(data?: IObjectPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(item);
            }
        }
    }

    static fromJS(data: any): ObjectPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data; 
    }

    clone(): ObjectPagedResultDto {
        const json = this.toJSON();
        let result = new ObjectPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObjectPagedResultDto {
    totalCount: number;
    items: any[] | undefined;
}

export class EventCancellationDto implements IEventCancellationDto {
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    documentTypeId: string | undefined;
    electronicDocument: ElectronicDocumentDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEventCancellationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.motive = _data["motive"];
            this.electronicDocumentCDC = _data["electronicDocumentCDC"];
            this.discriminator = _data["discriminator"];
            this.documentTypeId = _data["documentTypeId"];
            this.electronicDocument = _data["electronicDocument"] ? ElectronicDocumentDto.fromJS(_data["electronicDocument"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventCancellationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventCancellationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motive"] = this.motive;
        data["electronicDocumentCDC"] = this.electronicDocumentCDC;
        data["discriminator"] = this.discriminator;
        data["documentTypeId"] = this.documentTypeId;
        data["electronicDocument"] = this.electronicDocument ? this.electronicDocument.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventCancellationDto {
        const json = this.toJSON();
        let result = new EventCancellationDto();
        result.init(json);
        return result;
    }
}

export interface IEventCancellationDto {
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    documentTypeId: string | undefined;
    electronicDocument: ElectronicDocumentDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventDisableDto implements IEventDisableDto {
    startNumber: string;
    endNumber: string;
    documentTypeCode: number;
    documentTypeName: string | undefined;
    series: string | undefined;
    documentType: DocumentTypeDto;
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    documentTypeId: string | undefined;
    electronicDocument: ElectronicDocumentDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEventDisableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startNumber = _data["startNumber"];
            this.endNumber = _data["endNumber"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.documentTypeName = _data["documentTypeName"];
            this.series = _data["series"];
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.motive = _data["motive"];
            this.electronicDocumentCDC = _data["electronicDocumentCDC"];
            this.discriminator = _data["discriminator"];
            this.documentTypeId = _data["documentTypeId"];
            this.electronicDocument = _data["electronicDocument"] ? ElectronicDocumentDto.fromJS(_data["electronicDocument"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventDisableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDisableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startNumber"] = this.startNumber;
        data["endNumber"] = this.endNumber;
        data["documentTypeCode"] = this.documentTypeCode;
        data["documentTypeName"] = this.documentTypeName;
        data["series"] = this.series;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["motive"] = this.motive;
        data["electronicDocumentCDC"] = this.electronicDocumentCDC;
        data["discriminator"] = this.discriminator;
        data["documentTypeId"] = this.documentTypeId;
        data["electronicDocument"] = this.electronicDocument ? this.electronicDocument.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventDisableDto {
        const json = this.toJSON();
        let result = new EventDisableDto();
        result.init(json);
        return result;
    }
}

export interface IEventDisableDto {
    startNumber: string;
    endNumber: string;
    documentTypeCode: number;
    documentTypeName: string | undefined;
    series: string | undefined;
    documentType: DocumentTypeDto;
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    documentTypeId: string | undefined;
    electronicDocument: ElectronicDocumentDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** <p>Members:</p><ul><li><i>1</i> = Acuerdo total</li><li><i>2</i> = Acuerdo parcial</li></ul> */
export enum EventAgreementType {
    _1 = 1,
    _2 = 2,
}

export class EventAgreementDto implements IEventAgreementDto {
    eventAgreeType: EventAgreementType;
    estimatedDateOfReceipt: moment.Moment | undefined;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    electronicDocumentReception: ElectronicDocumentReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEventAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventAgreeType = _data["eventAgreeType"];
            this.estimatedDateOfReceipt = _data["estimatedDateOfReceipt"] ? moment(_data["estimatedDateOfReceipt"].toString()) : <any>undefined;
            this.electronicDocumentCDC = _data["electronicDocumentCDC"];
            this.discriminator = _data["discriminator"];
            this.electronicDocumentReception = _data["electronicDocumentReception"] ? ElectronicDocumentReceptionDto.fromJS(_data["electronicDocumentReception"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventAgreeType"] = this.eventAgreeType;
        data["estimatedDateOfReceipt"] = this.estimatedDateOfReceipt ? this.estimatedDateOfReceipt.toISOString() : <any>undefined;
        data["electronicDocumentCDC"] = this.electronicDocumentCDC;
        data["discriminator"] = this.discriminator;
        data["electronicDocumentReception"] = this.electronicDocumentReception ? this.electronicDocumentReception.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventAgreementDto {
        const json = this.toJSON();
        let result = new EventAgreementDto();
        result.init(json);
        return result;
    }
}

export interface IEventAgreementDto {
    eventAgreeType: EventAgreementType;
    estimatedDateOfReceipt: moment.Moment | undefined;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    electronicDocumentReception: ElectronicDocumentReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventDisagreementDto implements IEventDisagreementDto {
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    electronicDocumentReception: ElectronicDocumentReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEventDisagreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.motive = _data["motive"];
            this.electronicDocumentCDC = _data["electronicDocumentCDC"];
            this.discriminator = _data["discriminator"];
            this.electronicDocumentReception = _data["electronicDocumentReception"] ? ElectronicDocumentReceptionDto.fromJS(_data["electronicDocumentReception"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventDisagreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDisagreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motive"] = this.motive;
        data["electronicDocumentCDC"] = this.electronicDocumentCDC;
        data["discriminator"] = this.discriminator;
        data["electronicDocumentReception"] = this.electronicDocumentReception ? this.electronicDocumentReception.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventDisagreementDto {
        const json = this.toJSON();
        let result = new EventDisagreementDto();
        result.init(json);
        return result;
    }
}

export interface IEventDisagreementDto {
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    electronicDocumentReception: ElectronicDocumentReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventUnknownDto implements IEventUnknownDto {
    issuingDate: moment.Moment;
    receivingDate: moment.Moment;
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    electronicDocumentReception: ElectronicDocumentReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEventUnknownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuingDate = _data["issuingDate"] ? moment(_data["issuingDate"].toString()) : <any>undefined;
            this.receivingDate = _data["receivingDate"] ? moment(_data["receivingDate"].toString()) : <any>undefined;
            this.motive = _data["motive"];
            this.electronicDocumentCDC = _data["electronicDocumentCDC"];
            this.discriminator = _data["discriminator"];
            this.electronicDocumentReception = _data["electronicDocumentReception"] ? ElectronicDocumentReceptionDto.fromJS(_data["electronicDocumentReception"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventUnknownDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventUnknownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuingDate"] = this.issuingDate ? this.issuingDate.toISOString() : <any>undefined;
        data["receivingDate"] = this.receivingDate ? this.receivingDate.toISOString() : <any>undefined;
        data["motive"] = this.motive;
        data["electronicDocumentCDC"] = this.electronicDocumentCDC;
        data["discriminator"] = this.discriminator;
        data["electronicDocumentReception"] = this.electronicDocumentReception ? this.electronicDocumentReception.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventUnknownDto {
        const json = this.toJSON();
        let result = new EventUnknownDto();
        result.init(json);
        return result;
    }
}

export interface IEventUnknownDto {
    issuingDate: moment.Moment;
    receivingDate: moment.Moment;
    motive: string;
    electronicDocumentCDC: string | undefined;
    discriminator: string | undefined;
    electronicDocumentReception: ElectronicDocumentReceptionDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** Tipo de combustible. Utilizado para el sector [Automotores]. */
export class FuelTypeDto implements IFuelTypeDto {
    /** Nombre del tipo de combustible. */
    name: string;
    /** Identificador utilizado por el SIFEN. */
    identifier: number;
    id: number;

    constructor(data?: IFuelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): FuelTypeDto {
        const json = this.toJSON();
        let result = new FuelTypeDto();
        result.init(json);
        return result;
    }
}

/** Tipo de combustible. Utilizado para el sector [Automotores]. */
export interface IFuelTypeDto {
    /** Nombre del tipo de combustible. */
    name: string;
    /** Identificador utilizado por el SIFEN. */
    identifier: number;
    id: number;
}

export class FuelTypeDtoPagedResultDto implements IFuelTypeDtoPagedResultDto {
    totalCount: number;
    items: FuelTypeDto[] | undefined;

    constructor(data?: IFuelTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FuelTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FuelTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FuelTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FuelTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFuelTypeDtoPagedResultDto {
    totalCount: number;
    items: FuelTypeDto[] | undefined;
}

/** Datos del tipo de documento (asociados al responsable de la generación del DE). SIFEN: D141 - iTipIDRespDE y D142 - dDTipIDRespDE */
export class IdentityDocumentTypeDto implements IIdentityDocumentTypeDto {
    /** Descripción del tipo de documento.
SIFEN: D142 - dDTipIDRespDE */
    name: string;
    /** Código SIFEN del tipo de documento de
identidad.
SIFEN: D141 - iTipIDRespDE */
    identifier: number;
    id: number;

    constructor(data?: IIdentityDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdentityDocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): IdentityDocumentTypeDto {
        const json = this.toJSON();
        let result = new IdentityDocumentTypeDto();
        result.init(json);
        return result;
    }
}

/** Datos del tipo de documento (asociados al responsable de la generación del DE). SIFEN: D141 - iTipIDRespDE y D142 - dDTipIDRespDE */
export interface IIdentityDocumentTypeDto {
    /** Descripción del tipo de documento.
SIFEN: D142 - dDTipIDRespDE */
    name: string;
    /** Código SIFEN del tipo de documento de
identidad.
SIFEN: D141 - iTipIDRespDE */
    identifier: number;
    id: number;
}

export class IdentityDocumentTypeDtoPagedResultDto implements IIdentityDocumentTypeDtoPagedResultDto {
    totalCount: number;
    items: IdentityDocumentTypeDto[] | undefined;

    constructor(data?: IIdentityDocumentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IdentityDocumentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityDocumentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityDocumentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IdentityDocumentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IdentityDocumentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityDocumentTypeDtoPagedResultDto {
    totalCount: number;
    items: IdentityDocumentTypeDto[] | undefined;
}

/** Unidad de medida. */
export class MeasurementUnitDto implements IMeasurementUnitDto {
    /** Identificador utilizado por el SIFEN. */
    identifier: number;
    /** Nombre/descripción de la unidad de medida. */
    name: string;
    /** Símbolo de la unidad de medida, utilizado
por el SIFEN. */
    symbol: string;
    id: number;

    constructor(data?: IMeasurementUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["id"] = this.id;
        return data; 
    }

    clone(): MeasurementUnitDto {
        const json = this.toJSON();
        let result = new MeasurementUnitDto();
        result.init(json);
        return result;
    }
}

/** Unidad de medida. */
export interface IMeasurementUnitDto {
    /** Identificador utilizado por el SIFEN. */
    identifier: number;
    /** Nombre/descripción de la unidad de medida. */
    name: string;
    /** Símbolo de la unidad de medida, utilizado
por el SIFEN. */
    symbol: string;
    id: number;
}

export class MeasurementUnitDtoPagedResultDto implements IMeasurementUnitDtoPagedResultDto {
    totalCount: number;
    items: MeasurementUnitDto[] | undefined;

    constructor(data?: IMeasurementUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MeasurementUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasurementUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MeasurementUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MeasurementUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMeasurementUnitDtoPagedResultDto {
    totalCount: number;
    items: MeasurementUnitDto[] | undefined;
}

/** Condiciones de negociación (INCOTERMS) utilizado para el transporte de mercaderías. */
export class MerchandiseNegotiationConditionDto implements IMerchandiseNegotiationConditionDto {
    /** Nombre de la condición de negociación. */
    name: string;
    /** Identificador utilizado por el SIFEN. */
    identifier: string;
    id: number;

    constructor(data?: IMerchandiseNegotiationConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchandiseNegotiationConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseNegotiationConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): MerchandiseNegotiationConditionDto {
        const json = this.toJSON();
        let result = new MerchandiseNegotiationConditionDto();
        result.init(json);
        return result;
    }
}

/** Condiciones de negociación (INCOTERMS) utilizado para el transporte de mercaderías. */
export interface IMerchandiseNegotiationConditionDto {
    /** Nombre de la condición de negociación. */
    name: string;
    /** Identificador utilizado por el SIFEN. */
    identifier: string;
    id: number;
}

export class MerchandiseNegotiationConditionDtoPagedResultDto implements IMerchandiseNegotiationConditionDtoPagedResultDto {
    totalCount: number;
    items: MerchandiseNegotiationConditionDto[] | undefined;

    constructor(data?: IMerchandiseNegotiationConditionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MerchandiseNegotiationConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MerchandiseNegotiationConditionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandiseNegotiationConditionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MerchandiseNegotiationConditionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchandiseNegotiationConditionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchandiseNegotiationConditionDtoPagedResultDto {
    totalCount: number;
    items: MerchandiseNegotiationConditionDto[] | undefined;
}

/** Nomenclatura (NCM). */
export class NomenclatureDto implements INomenclatureDto {
    /** Nombre/descripción (denominación comercial) de la partida
para la nomenclatura NCM. */
    name: string | undefined;
    /** Valor de la nomenclatura. */
    identifier: string | undefined;
    /** Identifidador interno del capítulo, partida o
sub partida padre (dependiendo el nivel). */
    parentId: number | undefined;
    /** Nomenclatura (ejemplo, 1010.10) del padre. */
    parentIdentifier: string | undefined;
    id: number;

    constructor(data?: INomenclatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.parentId = _data["parentId"];
            this.parentIdentifier = _data["parentIdentifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NomenclatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new NomenclatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["parentId"] = this.parentId;
        data["parentIdentifier"] = this.parentIdentifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): NomenclatureDto {
        const json = this.toJSON();
        let result = new NomenclatureDto();
        result.init(json);
        return result;
    }
}

/** Nomenclatura (NCM). */
export interface INomenclatureDto {
    /** Nombre/descripción (denominación comercial) de la partida
para la nomenclatura NCM. */
    name: string | undefined;
    /** Valor de la nomenclatura. */
    identifier: string | undefined;
    /** Identifidador interno del capítulo, partida o
sub partida padre (dependiendo el nivel). */
    parentId: number | undefined;
    /** Nomenclatura (ejemplo, 1010.10) del padre. */
    parentIdentifier: string | undefined;
    id: number;
}

export class NomenclatureDtoPagedResultDto implements INomenclatureDtoPagedResultDto {
    totalCount: number;
    items: NomenclatureDto[] | undefined;

    constructor(data?: INomenclatureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NomenclatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NomenclatureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NomenclatureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NomenclatureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NomenclatureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INomenclatureDtoPagedResultDto {
    totalCount: number;
    items: NomenclatureDto[] | undefined;
}

export class PaymentMethodDtoPagedResultDto implements IPaymentMethodDtoPagedResultDto {
    totalCount: number;
    items: PaymentMethodDto[] | undefined;

    constructor(data?: IPaymentMethodDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PaymentMethodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentMethodDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PaymentMethodDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaymentMethodDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodDtoPagedResultDto {
    totalCount: number;
    items: PaymentMethodDto[] | undefined;
}

export class PresenceIndicatorDtoPagedResultDto implements IPresenceIndicatorDtoPagedResultDto {
    totalCount: number;
    items: PresenceIndicatorDto[] | undefined;

    constructor(data?: IPresenceIndicatorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PresenceIndicatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PresenceIndicatorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceIndicatorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PresenceIndicatorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PresenceIndicatorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPresenceIndicatorDtoPagedResultDto {
    totalCount: number;
    items: PresenceIndicatorDto[] | undefined;
}

/** Producto/Servicio (utilizado en la emisión de Documentos Electrónicos). */
export class ProductDto implements IProductDto {
    /** Código interno de identificación de  la mercadería o servicio de
responsabilidad del emisor. No se pueden tener ítems distintos de
mercadería o servicio con el mismo código interno en su catastro de
productos o servicios.Este código se puede repetir en el DE siempre
que el producto o servicio sea el mismo. */
    code: string;
    /** Descripción o detalles del producto/servicio. */
    description: string;
    /** Nombre del producto/servicio. */
    name: string;
    /** Identificador interno de la unidad de medida. */
    measurementUnitId: number;
    tariffHeading: number | undefined;
    /** NCM (Nomenclatura Común del Mercosur) del producto. */
    mercosurNomenclature: number | undefined;
    /** Código emitido por la DNCP. */
    generalDNCPCode: string | undefined;
    /** Código específico emitido por la DNCP. */
    specificDNCPCode: string | undefined;
    /** Código GTIN del producto */
    productGTIN: number | undefined;
    /** País de origen del producto. */
    productCountryId: number | undefined;
    /** Identificador interno de la moneda en la que se
comerciliza el producto. */
    currencyTypeId: number;
    /** Precio del producto (acorde a la moneda seleccionada). */
    price: number;
    productService: ProductService;
    /** Cantidad/Stock del producto. */
    stock: number;
    /** Precio unitario del producto con impuestos. */
    unitPriceWithTax: number | undefined;
    /** Tipo de cambio del precio del producto. */
    itemExchangeRate: number | undefined;
    taxImpact: TaxImpact;
    /** Proporción gravada de IVA del producto/servicio.
Corresponde al porcentaje (%) gravado. */
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    /** Bandera indicando si el producto es un vehículo
o no. */
    isVehicle: boolean;
    id: number;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.measurementUnitId = _data["measurementUnitId"];
            this.tariffHeading = _data["tariffHeading"];
            this.mercosurNomenclature = _data["mercosurNomenclature"];
            this.generalDNCPCode = _data["generalDNCPCode"];
            this.specificDNCPCode = _data["specificDNCPCode"];
            this.productGTIN = _data["productGTIN"];
            this.productCountryId = _data["productCountryId"];
            this.currencyTypeId = _data["currencyTypeId"];
            this.price = _data["price"];
            this.productService = _data["productService"];
            this.stock = _data["stock"];
            this.unitPriceWithTax = _data["unitPriceWithTax"];
            this.itemExchangeRate = _data["itemExchangeRate"];
            this.taxImpact = _data["taxImpact"];
            this.taxedProportion = _data["taxedProportion"];
            this.taxRate = _data["taxRate"];
            this.isVehicle = _data["isVehicle"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["name"] = this.name;
        data["measurementUnitId"] = this.measurementUnitId;
        data["tariffHeading"] = this.tariffHeading;
        data["mercosurNomenclature"] = this.mercosurNomenclature;
        data["generalDNCPCode"] = this.generalDNCPCode;
        data["specificDNCPCode"] = this.specificDNCPCode;
        data["productGTIN"] = this.productGTIN;
        data["productCountryId"] = this.productCountryId;
        data["currencyTypeId"] = this.currencyTypeId;
        data["price"] = this.price;
        data["productService"] = this.productService;
        data["stock"] = this.stock;
        data["unitPriceWithTax"] = this.unitPriceWithTax;
        data["itemExchangeRate"] = this.itemExchangeRate;
        data["taxImpact"] = this.taxImpact;
        data["taxedProportion"] = this.taxedProportion;
        data["taxRate"] = this.taxRate;
        data["isVehicle"] = this.isVehicle;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

/** Producto/Servicio (utilizado en la emisión de Documentos Electrónicos). */
export interface IProductDto {
    /** Código interno de identificación de  la mercadería o servicio de
responsabilidad del emisor. No se pueden tener ítems distintos de
mercadería o servicio con el mismo código interno en su catastro de
productos o servicios.Este código se puede repetir en el DE siempre
que el producto o servicio sea el mismo. */
    code: string;
    /** Descripción o detalles del producto/servicio. */
    description: string;
    /** Nombre del producto/servicio. */
    name: string;
    /** Identificador interno de la unidad de medida. */
    measurementUnitId: number;
    tariffHeading: number | undefined;
    /** NCM (Nomenclatura Común del Mercosur) del producto. */
    mercosurNomenclature: number | undefined;
    /** Código emitido por la DNCP. */
    generalDNCPCode: string | undefined;
    /** Código específico emitido por la DNCP. */
    specificDNCPCode: string | undefined;
    /** Código GTIN del producto */
    productGTIN: number | undefined;
    /** País de origen del producto. */
    productCountryId: number | undefined;
    /** Identificador interno de la moneda en la que se
comerciliza el producto. */
    currencyTypeId: number;
    /** Precio del producto (acorde a la moneda seleccionada). */
    price: number;
    productService: ProductService;
    /** Cantidad/Stock del producto. */
    stock: number;
    /** Precio unitario del producto con impuestos. */
    unitPriceWithTax: number | undefined;
    /** Tipo de cambio del precio del producto. */
    itemExchangeRate: number | undefined;
    taxImpact: TaxImpact;
    /** Proporción gravada de IVA del producto/servicio.
Corresponde al porcentaje (%) gravado. */
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    /** Bandera indicando si el producto es un vehículo
o no. */
    isVehicle: boolean;
    id: number;
}

export class ProductDtoPagedResultDto implements IProductDtoPagedResultDto {
    totalCount: number;
    items: ProductDto[] | undefined;

    constructor(data?: IProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductDtoPagedResultDto {
    totalCount: number;
    items: ProductDto[] | undefined;
}

export class ElectronicDocumentItemDtoPagedResultDto implements IElectronicDocumentItemDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentItemDto[] | undefined;

    constructor(data?: IElectronicDocumentItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ElectronicDocumentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectronicDocumentItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ElectronicDocumentItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentItemDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentItemDto[] | undefined;
}

export class CurrencyTotalDto implements ICurrencyTotalDto {
    currency: string | undefined;
    total: number;
    quantity: number;

    constructor(data?: ICurrencyTotalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): CurrencyTotalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyTotalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["quantity"] = this.quantity;
        return data; 
    }

    clone(): CurrencyTotalDto {
        const json = this.toJSON();
        let result = new CurrencyTotalDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyTotalDto {
    currency: string | undefined;
    total: number;
    quantity: number;
}

export class PagedResultSaleByProductDto implements IPagedResultSaleByProductDto {
    pagedResultDto: ElectronicDocumentItemDtoPagedResultDto;
    total: number;
    quantity: number;
    currencyTotals: CurrencyTotalDto[] | undefined;

    constructor(data?: IPagedResultSaleByProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pagedResultDto = _data["pagedResultDto"] ? ElectronicDocumentItemDtoPagedResultDto.fromJS(_data["pagedResultDto"]) : <any>undefined;
            this.total = _data["total"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["currencyTotals"])) {
                this.currencyTotals = [] as any;
                for (let item of _data["currencyTotals"])
                    this.currencyTotals.push(CurrencyTotalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultSaleByProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultSaleByProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagedResultDto"] = this.pagedResultDto ? this.pagedResultDto.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.currencyTotals)) {
            data["currencyTotals"] = [];
            for (let item of this.currencyTotals)
                data["currencyTotals"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultSaleByProductDto {
        const json = this.toJSON();
        let result = new PagedResultSaleByProductDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultSaleByProductDto {
    pagedResultDto: ElectronicDocumentItemDtoPagedResultDto;
    total: number;
    quantity: number;
    currencyTotals: CurrencyTotalDto[] | undefined;
}

/** Parámetro de consulta para la generación de códigos QR. */
export class QRCodeRequestDto implements IQRCodeRequestDto {
    /** Identificador del Documento Electrónico para el cuál se quiere generar
el código QR. */
    electronicDocumentId: number;
    /** Tamaño de generación del QR. */
    size: number;

    constructor(data?: IQRCodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.electronicDocumentId = _data["electronicDocumentId"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): QRCodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["electronicDocumentId"] = this.electronicDocumentId;
        data["size"] = this.size;
        return data; 
    }

    clone(): QRCodeRequestDto {
        const json = this.toJSON();
        let result = new QRCodeRequestDto();
        result.init(json);
        return result;
    }
}

/** Parámetro de consulta para la generación de códigos QR. */
export interface IQRCodeRequestDto {
    /** Identificador del Documento Electrónico para el cuál se quiere generar
el código QR. */
    electronicDocumentId: number;
    /** Tamaño de generación del QR. */
    size: number;
}

/** Resultado con el QR generado. */
export class QRCodeDto implements IQRCodeDto {
    /** Texto que representa la imagen del QR
en Base64. */
    imageText: string | undefined;

    constructor(data?: IQRCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageText = _data["imageText"];
        }
    }

    static fromJS(data: any): QRCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageText"] = this.imageText;
        return data; 
    }

    clone(): QRCodeDto {
        const json = this.toJSON();
        let result = new QRCodeDto();
        result.init(json);
        return result;
    }
}

/** Resultado con el QR generado. */
export interface IQRCodeDto {
    /** Texto que representa la imagen del QR
en Base64. */
    imageText: string | undefined;
}

export class MonthToMonthBillingDto implements IMonthToMonthBillingDto {
    month: string | undefined;
    monthSimplified: string | undefined;
    collected: number;
    due: number;
    overdue: number;

    constructor(data?: IMonthToMonthBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.monthSimplified = _data["monthSimplified"];
            this.collected = _data["collected"];
            this.due = _data["due"];
            this.overdue = _data["overdue"];
        }
    }

    static fromJS(data: any): MonthToMonthBillingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthToMonthBillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["monthSimplified"] = this.monthSimplified;
        data["collected"] = this.collected;
        data["due"] = this.due;
        data["overdue"] = this.overdue;
        return data; 
    }

    clone(): MonthToMonthBillingDto {
        const json = this.toJSON();
        let result = new MonthToMonthBillingDto();
        result.init(json);
        return result;
    }
}

export interface IMonthToMonthBillingDto {
    month: string | undefined;
    monthSimplified: string | undefined;
    collected: number;
    due: number;
    overdue: number;
}

export class ElectronicDocumentMultipleReceiptDto implements IElectronicDocumentMultipleReceiptDto {
    number: number;
    operationCondition: OperationCondition;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
    currencyTypeCode: string | undefined;
    subTotal: number;
    paidAmount: number;
    receiptAmount: number | undefined;
    electronicDocumentId: number;
    itWasSelected: boolean;

    constructor(data?: IElectronicDocumentMultipleReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.operationCondition = _data["operationCondition"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.subTotal = _data["subTotal"];
            this.paidAmount = _data["paidAmount"];
            this.receiptAmount = _data["receiptAmount"];
            this.electronicDocumentId = _data["electronicDocumentId"];
            this.itWasSelected = _data["itWasSelected"];
        }
    }

    static fromJS(data: any): ElectronicDocumentMultipleReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentMultipleReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["operationCondition"] = this.operationCondition;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["subTotal"] = this.subTotal;
        data["paidAmount"] = this.paidAmount;
        data["receiptAmount"] = this.receiptAmount;
        data["electronicDocumentId"] = this.electronicDocumentId;
        data["itWasSelected"] = this.itWasSelected;
        return data; 
    }

    clone(): ElectronicDocumentMultipleReceiptDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentMultipleReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentMultipleReceiptDto {
    number: number;
    operationCondition: OperationCondition;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
    currencyTypeCode: string | undefined;
    subTotal: number;
    paidAmount: number;
    receiptAmount: number | undefined;
    electronicDocumentId: number;
    itWasSelected: boolean;
}

export class ElectronicDocumentMultipleReceiptDtoPagedResultDto implements IElectronicDocumentMultipleReceiptDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentMultipleReceiptDto[] | undefined;

    constructor(data?: IElectronicDocumentMultipleReceiptDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ElectronicDocumentMultipleReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectronicDocumentMultipleReceiptDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicDocumentMultipleReceiptDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ElectronicDocumentMultipleReceiptDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectronicDocumentMultipleReceiptDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectronicDocumentMultipleReceiptDtoPagedResultDto {
    totalCount: number;
    items: ElectronicDocumentMultipleReceiptDto[] | undefined;
}

export class ReceiverBranchDtoPagedResultDto implements IReceiverBranchDtoPagedResultDto {
    totalCount: number;
    items: ReceiverBranchDto[] | undefined;

    constructor(data?: IReceiverBranchDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReceiverBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiverBranchDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverBranchDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReceiverBranchDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReceiverBranchDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReceiverBranchDtoPagedResultDto {
    totalCount: number;
    items: ReceiverBranchDto[] | undefined;
}

export class ReceiverDtoPagedResultDto implements IReceiverDtoPagedResultDto {
    totalCount: number;
    items: ReceiverDto[] | undefined;

    constructor(data?: IReceiverDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReceiverDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiverDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReceiverDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReceiverDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReceiverDtoPagedResultDto {
    totalCount: number;
    items: ReceiverDto[] | undefined;
}

export class ReceiverAccountBalanceDto implements IReceiverAccountBalanceDto {
    receiver: ReceiverDto;
    balanceDue: number;
    collected: number;
    due: number;
    overdue: number;
    totalDebt: number;

    constructor(data?: IReceiverAccountBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiver = _data["receiver"] ? ReceiverDto.fromJS(_data["receiver"]) : <any>undefined;
            this.balanceDue = _data["balanceDue"];
            this.collected = _data["collected"];
            this.due = _data["due"];
            this.overdue = _data["overdue"];
            this.totalDebt = _data["totalDebt"];
        }
    }

    static fromJS(data: any): ReceiverAccountBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverAccountBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiver"] = this.receiver ? this.receiver.toJSON() : <any>undefined;
        data["balanceDue"] = this.balanceDue;
        data["collected"] = this.collected;
        data["due"] = this.due;
        data["overdue"] = this.overdue;
        data["totalDebt"] = this.totalDebt;
        return data; 
    }

    clone(): ReceiverAccountBalanceDto {
        const json = this.toJSON();
        let result = new ReceiverAccountBalanceDto();
        result.init(json);
        return result;
    }
}

export interface IReceiverAccountBalanceDto {
    receiver: ReceiverDto;
    balanceDue: number;
    collected: number;
    due: number;
    overdue: number;
    totalDebt: number;
}

export class ReceiverAccountBalanceDtoPagedResultDto implements IReceiverAccountBalanceDtoPagedResultDto {
    totalCount: number;
    items: ReceiverAccountBalanceDto[] | undefined;

    constructor(data?: IReceiverAccountBalanceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReceiverAccountBalanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiverAccountBalanceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverAccountBalanceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReceiverAccountBalanceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReceiverAccountBalanceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReceiverAccountBalanceDtoPagedResultDto {
    totalCount: number;
    items: ReceiverAccountBalanceDto[] | undefined;
}

export class ReceiverTotalAccountBalanceDto implements IReceiverTotalAccountBalanceDto {
    totalBalanceDue: number;
    totalCollected: number;
    totalDue: number;
    totalOverdue: number;
    totalDebt: number;

    constructor(data?: IReceiverTotalAccountBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalBalanceDue = _data["totalBalanceDue"];
            this.totalCollected = _data["totalCollected"];
            this.totalDue = _data["totalDue"];
            this.totalOverdue = _data["totalOverdue"];
            this.totalDebt = _data["totalDebt"];
        }
    }

    static fromJS(data: any): ReceiverTotalAccountBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverTotalAccountBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalBalanceDue"] = this.totalBalanceDue;
        data["totalCollected"] = this.totalCollected;
        data["totalDue"] = this.totalDue;
        data["totalOverdue"] = this.totalOverdue;
        data["totalDebt"] = this.totalDebt;
        return data; 
    }

    clone(): ReceiverTotalAccountBalanceDto {
        const json = this.toJSON();
        let result = new ReceiverTotalAccountBalanceDto();
        result.init(json);
        return result;
    }
}

export interface IReceiverTotalAccountBalanceDto {
    totalBalanceDue: number;
    totalCollected: number;
    totalDue: number;
    totalOverdue: number;
    totalDebt: number;
}

export class RegimeDtoPagedResultDto implements IRegimeDtoPagedResultDto {
    totalCount: number;
    items: RegimeDto[] | undefined;

    constructor(data?: IRegimeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RegimeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegimeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegimeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RegimeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RegimeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRegimeDtoPagedResultDto {
    totalCount: number;
    items: RegimeDto[] | undefined;
}

export class RemissionNoteReasonDtoPagedResultDto implements IRemissionNoteReasonDtoPagedResultDto {
    totalCount: number;
    items: RemissionNoteReasonDto[] | undefined;

    constructor(data?: IRemissionNoteReasonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RemissionNoteReasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemissionNoteReasonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemissionNoteReasonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RemissionNoteReasonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RemissionNoteReasonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRemissionNoteReasonDtoPagedResultDto {
    totalCount: number;
    items: RemissionNoteReasonDto[] | undefined;
}

/** Fila de resultado para reporte de totales. */
export class TransactionGraphResultDto implements ITransactionGraphResultDto {
    /** Identificador de la "columna" del reporte.
En este caso coincide con una fecha. */
    key: string | undefined;
    /** Resultado (cantidad) de documentos
electrónicos para la fila (key). */
    count: string | undefined;

    constructor(data?: ITransactionGraphResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TransactionGraphResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionGraphResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["count"] = this.count;
        return data; 
    }

    clone(): TransactionGraphResultDto {
        const json = this.toJSON();
        let result = new TransactionGraphResultDto();
        result.init(json);
        return result;
    }
}

/** Fila de resultado para reporte de totales. */
export interface ITransactionGraphResultDto {
    /** Identificador de la "columna" del reporte.
En este caso coincide con una fecha. */
    key: string | undefined;
    /** Resultado (cantidad) de documentos
electrónicos para la fila (key). */
    count: string | undefined;
}

/** Fila de resultado para reporte de montos totales. */
export class AmountGraphResultDto implements IAmountGraphResultDto {
    /** Identificador de la "columna" del reporte.
En este caso coincide con una fecha. */
    key: string | undefined;
    /** Cantidad/monto del resultado. */
    count: string | undefined;
    /** Determinación de la cantidad, si son
miles o millones. */
    amountType: string | undefined;

    constructor(data?: IAmountGraphResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.count = _data["count"];
            this.amountType = _data["amountType"];
        }
    }

    static fromJS(data: any): AmountGraphResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmountGraphResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["count"] = this.count;
        data["amountType"] = this.amountType;
        return data; 
    }

    clone(): AmountGraphResultDto {
        const json = this.toJSON();
        let result = new AmountGraphResultDto();
        result.init(json);
        return result;
    }
}

/** Fila de resultado para reporte de montos totales. */
export interface IAmountGraphResultDto {
    /** Identificador de la "columna" del reporte.
En este caso coincide con una fecha. */
    key: string | undefined;
    /** Cantidad/monto del resultado. */
    count: string | undefined;
    /** Determinación de la cantidad, si son
miles o millones. */
    amountType: string | undefined;
}

/** Montos totales para un mes dado. */
export class MonthlyAmountDto implements IMonthlyAmountDto {
    /** Identificador de la "columna" del reporte.
En este caso coincide con un mes. */
    month: string | undefined;
    /** Monto del resultado. */
    amount: string | undefined;

    constructor(data?: IMonthlyAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MonthlyAmountDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyAmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["amount"] = this.amount;
        return data; 
    }

    clone(): MonthlyAmountDto {
        const json = this.toJSON();
        let result = new MonthlyAmountDto();
        result.init(json);
        return result;
    }
}

/** Montos totales para un mes dado. */
export interface IMonthlyAmountDto {
    /** Identificador de la "columna" del reporte.
En este caso coincide con un mes. */
    month: string | undefined;
    /** Monto del resultado. */
    amount: string | undefined;
}

/** Rol de usuarios. */
export class RoleDto implements IRoleDto {
    /** Nombre interno de rol. */
    name: string;
    /** Nombre a mostrar del rol. */
    displayName: string;
    /** Nombre interno, normalizado. */
    normalizedName: string | undefined;
    /** Descripción del rol, indicando su
propósito y a quiénes estaría enfocado. */
    description: string | undefined;
    /** Lista de permisos que posee el rol de
usuarios. */
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

/** Rol de usuarios. */
export interface IRoleDto {
    /** Nombre interno de rol. */
    name: string;
    /** Nombre a mostrar del rol. */
    displayName: string;
    /** Nombre interno, normalizado. */
    normalizedName: string | undefined;
    /** Descripción del rol, indicando su
propósito y a quiénes estaría enfocado. */
    description: string | undefined;
    /** Lista de permisos que posee el rol de
usuarios. */
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

/** Parámetro para la creación de un rol de usuarios. */
export class CreateRoleDto implements ICreateRoleDto {
    /** Nombre interno del rol. */
    name: string;
    /** Nombre a mostrar del rol. */
    displayName: string;
    /** Nombre interno normalizado. */
    normalizedName: string | undefined;
    /** Descripción del rol, indicando su
propósito y a quiénes estaría enfocado. */
    description: string | undefined;
    /** Lista de permisos que posee el rol de
usuarios. */
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

/** Parámetro para la creación de un rol de usuarios. */
export interface ICreateRoleDto {
    /** Nombre interno del rol. */
    name: string;
    /** Nombre a mostrar del rol. */
    displayName: string;
    /** Nombre interno normalizado. */
    normalizedName: string | undefined;
    /** Descripción del rol, indicando su
propósito y a quiénes estaría enfocado. */
    description: string | undefined;
    /** Lista de permisos que posee el rol de
usuarios. */
    grantedPermissions: string[] | undefined;
}

/** Listado de roles obtenidos como resultado. */
export class RoleListDto implements IRoleListDto {
    /** Nombre interno de rol. */
    name: string | undefined;
    /** Nombre a mostrar del rol. */
    displayName: string | undefined;
    /** Bandera indicando si el rol es
estático o no. */
    isStatic: boolean;
    /** Bandera indicando si es un rol por
defecto o no. */
    isDefault: boolean;
    /** Fecha de creación del rol. */
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

/** Listado de roles obtenidos como resultado. */
export interface IRoleListDto {
    /** Nombre interno de rol. */
    name: string | undefined;
    /** Nombre a mostrar del rol. */
    displayName: string | undefined;
    /** Bandera indicando si el rol es
estático o no. */
    isStatic: boolean;
    /** Bandera indicando si es un rol por
defecto o no. */
    isDefault: boolean;
    /** Fecha de creación del rol. */
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        this.features[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    defaultBranchId: number | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.defaultBranchId = _data["defaultBranchId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["defaultBranchId"] = this.defaultBranchId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    defaultBranchId: number | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    ruc: string | undefined;
    totalMultipleOfFifTy: boolean;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.ruc = _data["ruc"];
            this.totalMultipleOfFifTy = _data["totalMultipleOfFifTy"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["ruc"] = this.ruc;
        data["totalMultipleOfFifTy"] = this.totalMultipleOfFifTy;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    ruc: string | undefined;
    totalMultipleOfFifTy: boolean;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

/** <p>Members:</p><ul><li><i>1</i> = Credit</li><li><i>2</i> = Cash</li></ul> */
export enum ShoppingPaymentEnum {
    _1 = 1,
    _2 = 2,
}

export class ShoppingItemDto implements IShoppingItemDto {
    internalCode: string;
    tariffHeading: number | undefined;
    mercosurNomenclature: number | undefined;
    generalDNCPCode: string | undefined;
    specificDNCPCode: string | undefined;
    productGTIN: number | undefined;
    packageGTIN: number | undefined;
    description: string;
    measurementUnitCode: number;
    quantity: number;
    productCountryCode: string | undefined;
    informationOfInterest: string | undefined;
    relevanceDataCode: RelevanceDataCodeEnum;
    brokeShrinkQuantity: number | undefined;
    brokeShrinkPercentage: number | undefined;
    advanceCDC: string | undefined;
    unitPriceWithTax: number | undefined;
    itemExchangeRate: number | undefined;
    itemUnitPriceDiscountWithTax: number | undefined;
    itemDiscountPercentage: number | undefined;
    itemUnitPriceGlobalDiscountWithTax: number | undefined;
    itemUnitPriceAdvanceWithTax: number | undefined;
    itemUnitPriceGlobalAdvanceWithTax: number | undefined;
    itemTotalPrice: number | undefined;
    itemIvaLiquidation: number | undefined;
    itemBaseIva: number | undefined;
    itemTotalGuaranies: number | undefined;
    taxImpact: TaxImpact;
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    lotNumber: string | undefined;
    merchandiseExpiringDate: moment.Moment | undefined;
    serialNumber: string | undefined;
    orderNumber: string | undefined;
    trackingNumber: string | undefined;
    importerName: string | undefined;
    importerAddress: string | undefined;
    importerSignatureNumber: string | undefined;
    senaveProductRegistrationNumber: string | undefined;
    senaveBusinessRegistrationNumber: string | undefined;
    typeOfVehicleSale: VehicleSale;
    vehicleChassis: string | undefined;
    vechicleColor: string | undefined;
    enginePower: number | undefined;
    engineCapacity: number | undefined;
    netWeightInTons: number | undefined;
    grossWeightInTons: number | undefined;
    fuelTypeCode: number | undefined;
    engineNumber: string | undefined;
    tractionCapacityInTons: number | undefined;
    fabricationYear: number | undefined;
    vehicleType: string | undefined;
    seatedPassengersCapacity: number | undefined;
    engineDisplacement: string | undefined;
    currency: string | undefined;
    priority: number | undefined;
    productId: number;
    shoppingId: number;
    shopping: ShoppingDto;
    id: number;

    constructor(data?: IShoppingItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalCode = _data["internalCode"];
            this.tariffHeading = _data["tariffHeading"];
            this.mercosurNomenclature = _data["mercosurNomenclature"];
            this.generalDNCPCode = _data["generalDNCPCode"];
            this.specificDNCPCode = _data["specificDNCPCode"];
            this.productGTIN = _data["productGTIN"];
            this.packageGTIN = _data["packageGTIN"];
            this.description = _data["description"];
            this.measurementUnitCode = _data["measurementUnitCode"];
            this.quantity = _data["quantity"];
            this.productCountryCode = _data["productCountryCode"];
            this.informationOfInterest = _data["informationOfInterest"];
            this.relevanceDataCode = _data["relevanceDataCode"];
            this.brokeShrinkQuantity = _data["brokeShrinkQuantity"];
            this.brokeShrinkPercentage = _data["brokeShrinkPercentage"];
            this.advanceCDC = _data["advanceCDC"];
            this.unitPriceWithTax = _data["unitPriceWithTax"];
            this.itemExchangeRate = _data["itemExchangeRate"];
            this.itemUnitPriceDiscountWithTax = _data["itemUnitPriceDiscountWithTax"];
            this.itemDiscountPercentage = _data["itemDiscountPercentage"];
            this.itemUnitPriceGlobalDiscountWithTax = _data["itemUnitPriceGlobalDiscountWithTax"];
            this.itemUnitPriceAdvanceWithTax = _data["itemUnitPriceAdvanceWithTax"];
            this.itemUnitPriceGlobalAdvanceWithTax = _data["itemUnitPriceGlobalAdvanceWithTax"];
            this.itemTotalPrice = _data["itemTotalPrice"];
            this.itemIvaLiquidation = _data["itemIvaLiquidation"];
            this.itemBaseIva = _data["itemBaseIva"];
            this.itemTotalGuaranies = _data["itemTotalGuaranies"];
            this.taxImpact = _data["taxImpact"];
            this.taxedProportion = _data["taxedProportion"];
            this.taxRate = _data["taxRate"];
            this.lotNumber = _data["lotNumber"];
            this.merchandiseExpiringDate = _data["merchandiseExpiringDate"] ? moment(_data["merchandiseExpiringDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.orderNumber = _data["orderNumber"];
            this.trackingNumber = _data["trackingNumber"];
            this.importerName = _data["importerName"];
            this.importerAddress = _data["importerAddress"];
            this.importerSignatureNumber = _data["importerSignatureNumber"];
            this.senaveProductRegistrationNumber = _data["senaveProductRegistrationNumber"];
            this.senaveBusinessRegistrationNumber = _data["senaveBusinessRegistrationNumber"];
            this.typeOfVehicleSale = _data["typeOfVehicleSale"];
            this.vehicleChassis = _data["vehicleChassis"];
            this.vechicleColor = _data["vechicleColor"];
            this.enginePower = _data["enginePower"];
            this.engineCapacity = _data["engineCapacity"];
            this.netWeightInTons = _data["netWeightInTons"];
            this.grossWeightInTons = _data["grossWeightInTons"];
            this.fuelTypeCode = _data["fuelTypeCode"];
            this.engineNumber = _data["engineNumber"];
            this.tractionCapacityInTons = _data["tractionCapacityInTons"];
            this.fabricationYear = _data["fabricationYear"];
            this.vehicleType = _data["vehicleType"];
            this.seatedPassengersCapacity = _data["seatedPassengersCapacity"];
            this.engineDisplacement = _data["engineDisplacement"];
            this.currency = _data["currency"];
            this.priority = _data["priority"];
            this.productId = _data["productId"];
            this.shoppingId = _data["shoppingId"];
            this.shopping = _data["shopping"] ? ShoppingDto.fromJS(_data["shopping"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShoppingItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalCode"] = this.internalCode;
        data["tariffHeading"] = this.tariffHeading;
        data["mercosurNomenclature"] = this.mercosurNomenclature;
        data["generalDNCPCode"] = this.generalDNCPCode;
        data["specificDNCPCode"] = this.specificDNCPCode;
        data["productGTIN"] = this.productGTIN;
        data["packageGTIN"] = this.packageGTIN;
        data["description"] = this.description;
        data["measurementUnitCode"] = this.measurementUnitCode;
        data["quantity"] = this.quantity;
        data["productCountryCode"] = this.productCountryCode;
        data["informationOfInterest"] = this.informationOfInterest;
        data["relevanceDataCode"] = this.relevanceDataCode;
        data["brokeShrinkQuantity"] = this.brokeShrinkQuantity;
        data["brokeShrinkPercentage"] = this.brokeShrinkPercentage;
        data["advanceCDC"] = this.advanceCDC;
        data["unitPriceWithTax"] = this.unitPriceWithTax;
        data["itemExchangeRate"] = this.itemExchangeRate;
        data["itemUnitPriceDiscountWithTax"] = this.itemUnitPriceDiscountWithTax;
        data["itemDiscountPercentage"] = this.itemDiscountPercentage;
        data["itemUnitPriceGlobalDiscountWithTax"] = this.itemUnitPriceGlobalDiscountWithTax;
        data["itemUnitPriceAdvanceWithTax"] = this.itemUnitPriceAdvanceWithTax;
        data["itemUnitPriceGlobalAdvanceWithTax"] = this.itemUnitPriceGlobalAdvanceWithTax;
        data["itemTotalPrice"] = this.itemTotalPrice;
        data["itemIvaLiquidation"] = this.itemIvaLiquidation;
        data["itemBaseIva"] = this.itemBaseIva;
        data["itemTotalGuaranies"] = this.itemTotalGuaranies;
        data["taxImpact"] = this.taxImpact;
        data["taxedProportion"] = this.taxedProportion;
        data["taxRate"] = this.taxRate;
        data["lotNumber"] = this.lotNumber;
        data["merchandiseExpiringDate"] = this.merchandiseExpiringDate ? this.merchandiseExpiringDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["orderNumber"] = this.orderNumber;
        data["trackingNumber"] = this.trackingNumber;
        data["importerName"] = this.importerName;
        data["importerAddress"] = this.importerAddress;
        data["importerSignatureNumber"] = this.importerSignatureNumber;
        data["senaveProductRegistrationNumber"] = this.senaveProductRegistrationNumber;
        data["senaveBusinessRegistrationNumber"] = this.senaveBusinessRegistrationNumber;
        data["typeOfVehicleSale"] = this.typeOfVehicleSale;
        data["vehicleChassis"] = this.vehicleChassis;
        data["vechicleColor"] = this.vechicleColor;
        data["enginePower"] = this.enginePower;
        data["engineCapacity"] = this.engineCapacity;
        data["netWeightInTons"] = this.netWeightInTons;
        data["grossWeightInTons"] = this.grossWeightInTons;
        data["fuelTypeCode"] = this.fuelTypeCode;
        data["engineNumber"] = this.engineNumber;
        data["tractionCapacityInTons"] = this.tractionCapacityInTons;
        data["fabricationYear"] = this.fabricationYear;
        data["vehicleType"] = this.vehicleType;
        data["seatedPassengersCapacity"] = this.seatedPassengersCapacity;
        data["engineDisplacement"] = this.engineDisplacement;
        data["currency"] = this.currency;
        data["priority"] = this.priority;
        data["productId"] = this.productId;
        data["shoppingId"] = this.shoppingId;
        data["shopping"] = this.shopping ? this.shopping.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShoppingItemDto {
        const json = this.toJSON();
        let result = new ShoppingItemDto();
        result.init(json);
        return result;
    }
}

export interface IShoppingItemDto {
    internalCode: string;
    tariffHeading: number | undefined;
    mercosurNomenclature: number | undefined;
    generalDNCPCode: string | undefined;
    specificDNCPCode: string | undefined;
    productGTIN: number | undefined;
    packageGTIN: number | undefined;
    description: string;
    measurementUnitCode: number;
    quantity: number;
    productCountryCode: string | undefined;
    informationOfInterest: string | undefined;
    relevanceDataCode: RelevanceDataCodeEnum;
    brokeShrinkQuantity: number | undefined;
    brokeShrinkPercentage: number | undefined;
    advanceCDC: string | undefined;
    unitPriceWithTax: number | undefined;
    itemExchangeRate: number | undefined;
    itemUnitPriceDiscountWithTax: number | undefined;
    itemDiscountPercentage: number | undefined;
    itemUnitPriceGlobalDiscountWithTax: number | undefined;
    itemUnitPriceAdvanceWithTax: number | undefined;
    itemUnitPriceGlobalAdvanceWithTax: number | undefined;
    itemTotalPrice: number | undefined;
    itemIvaLiquidation: number | undefined;
    itemBaseIva: number | undefined;
    itemTotalGuaranies: number | undefined;
    taxImpact: TaxImpact;
    taxedProportion: number | undefined;
    taxRate: TaxEnum;
    lotNumber: string | undefined;
    merchandiseExpiringDate: moment.Moment | undefined;
    serialNumber: string | undefined;
    orderNumber: string | undefined;
    trackingNumber: string | undefined;
    importerName: string | undefined;
    importerAddress: string | undefined;
    importerSignatureNumber: string | undefined;
    senaveProductRegistrationNumber: string | undefined;
    senaveBusinessRegistrationNumber: string | undefined;
    typeOfVehicleSale: VehicleSale;
    vehicleChassis: string | undefined;
    vechicleColor: string | undefined;
    enginePower: number | undefined;
    engineCapacity: number | undefined;
    netWeightInTons: number | undefined;
    grossWeightInTons: number | undefined;
    fuelTypeCode: number | undefined;
    engineNumber: string | undefined;
    tractionCapacityInTons: number | undefined;
    fabricationYear: number | undefined;
    vehicleType: string | undefined;
    seatedPassengersCapacity: number | undefined;
    engineDisplacement: string | undefined;
    currency: string | undefined;
    priority: number | undefined;
    productId: number;
    shoppingId: number;
    shopping: ShoppingDto;
    id: number;
}

export class ShoppingPaymentDto implements IShoppingPaymentDto {
    shoppingId: number;
    payment: number;
    /** Identificador de la moneda de la operación
en Paranet. */
    currencyTypeId: number | undefined;
    creationTime: moment.Moment;
    reference: string | undefined;
    currencyType: CurrencyTypeDto;
    id: number;

    constructor(data?: IShoppingPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingId = _data["shoppingId"];
            this.payment = _data["payment"];
            this.currencyTypeId = _data["currencyTypeId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.reference = _data["reference"];
            this.currencyType = _data["currencyType"] ? CurrencyTypeDto.fromJS(_data["currencyType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShoppingPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingId"] = this.shoppingId;
        data["payment"] = this.payment;
        data["currencyTypeId"] = this.currencyTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["reference"] = this.reference;
        data["currencyType"] = this.currencyType ? this.currencyType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShoppingPaymentDto {
        const json = this.toJSON();
        let result = new ShoppingPaymentDto();
        result.init(json);
        return result;
    }
}

export interface IShoppingPaymentDto {
    shoppingId: number;
    payment: number;
    /** Identificador de la moneda de la operación
en Paranet. */
    currencyTypeId: number | undefined;
    creationTime: moment.Moment;
    reference: string | undefined;
    currencyType: CurrencyTypeDto;
    id: number;
}

export class ShoppingDto implements IShoppingDto {
    shoppingPayment: ShoppingPaymentEnum;
    /** Identificador interno en Paranet,
del emisor de la compra. */
    tenantId: number;
    tenant: TenantDto;
    /** Identificador interno en Paranet del
cliente (receptor electrónico) de la compra. */
    clientId: number;
    client: ReceiverDto;
    /** Fecha de emisión de la compra.
(por defecto, la actual). */
    issuedDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
    shoppingItems: ShoppingItemDto[] | undefined;
    subTotal: number;
    total: number;
    /** Identificador de la moneda de la operación. */
    currencyTypeCode: string | undefined;
    status: string | undefined;
    currencyType: CurrencyTypeDto;
    invoiceNumber: string | undefined;
    shoppingPayments: ShoppingPaymentDto[] | undefined;
    id: number;

    constructor(data?: IShoppingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingPayment = _data["shoppingPayment"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ReceiverDto.fromJS(_data["client"]) : <any>undefined;
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["shoppingItems"])) {
                this.shoppingItems = [] as any;
                for (let item of _data["shoppingItems"])
                    this.shoppingItems.push(ShoppingItemDto.fromJS(item));
            }
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.status = _data["status"];
            this.currencyType = _data["currencyType"] ? CurrencyTypeDto.fromJS(_data["currencyType"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            if (Array.isArray(_data["shoppingPayments"])) {
                this.shoppingPayments = [] as any;
                for (let item of _data["shoppingPayments"])
                    this.shoppingPayments.push(ShoppingPaymentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShoppingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingPayment"] = this.shoppingPayment;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.shoppingItems)) {
            data["shoppingItems"] = [];
            for (let item of this.shoppingItems)
                data["shoppingItems"].push(item.toJSON());
        }
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["status"] = this.status;
        data["currencyType"] = this.currencyType ? this.currencyType.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        if (Array.isArray(this.shoppingPayments)) {
            data["shoppingPayments"] = [];
            for (let item of this.shoppingPayments)
                data["shoppingPayments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ShoppingDto {
        const json = this.toJSON();
        let result = new ShoppingDto();
        result.init(json);
        return result;
    }
}

export interface IShoppingDto {
    shoppingPayment: ShoppingPaymentEnum;
    /** Identificador interno en Paranet,
del emisor de la compra. */
    tenantId: number;
    tenant: TenantDto;
    /** Identificador interno en Paranet del
cliente (receptor electrónico) de la compra. */
    clientId: number;
    client: ReceiverDto;
    /** Fecha de emisión de la compra.
(por defecto, la actual). */
    issuedDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
    shoppingItems: ShoppingItemDto[] | undefined;
    subTotal: number;
    total: number;
    /** Identificador de la moneda de la operación. */
    currencyTypeCode: string | undefined;
    status: string | undefined;
    currencyType: CurrencyTypeDto;
    invoiceNumber: string | undefined;
    shoppingPayments: ShoppingPaymentDto[] | undefined;
    id: number;
}

export class ShoppingDtoPagedResultDto implements IShoppingDtoPagedResultDto {
    totalCount: number;
    items: ShoppingDto[] | undefined;

    constructor(data?: IShoppingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShoppingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShoppingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShoppingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShoppingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShoppingDtoPagedResultDto {
    totalCount: number;
    items: ShoppingDto[] | undefined;
}

export class ShoppingPaymentDtoPagedResultDto implements IShoppingPaymentDtoPagedResultDto {
    totalCount: number;
    items: ShoppingPaymentDto[] | undefined;

    constructor(data?: IShoppingPaymentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShoppingPaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShoppingPaymentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingPaymentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShoppingPaymentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShoppingPaymentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShoppingPaymentDtoPagedResultDto {
    totalCount: number;
    items: ShoppingPaymentDto[] | undefined;
}

/** Datos para la creación de un certificado de firma. */
export class CreateSignatureDto implements ICreateSignatureDto {
    /** Nombre del archivo de firma (certificado). */
    filename: string | undefined;
    /** Representación binaria en Base64 del
archivo de firma (certificado). */
    fileBase64: string | undefined;
    /** Contraseña asociada al archivo de firma
(contraseña del PFX). */
    password: string | undefined;
    id: number;

    constructor(data?: ICreateSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.fileBase64 = _data["fileBase64"];
            this.password = _data["password"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["fileBase64"] = this.fileBase64;
        data["password"] = this.password;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateSignatureDto {
        const json = this.toJSON();
        let result = new CreateSignatureDto();
        result.init(json);
        return result;
    }
}

/** Datos para la creación de un certificado de firma. */
export interface ICreateSignatureDto {
    /** Nombre del archivo de firma (certificado). */
    filename: string | undefined;
    /** Representación binaria en Base64 del
archivo de firma (certificado). */
    fileBase64: string | undefined;
    /** Contraseña asociada al archivo de firma
(contraseña del PFX). */
    password: string | undefined;
    id: number;
}

/** Entidad representando un certificado de firma. */
export class SignatureDto implements ISignatureDto {
    /** Nombre/ruta del archivo de firma. */
    filename: string | undefined;
    /** Fecha de creación/carga en la plataforma
de la firma. */
    creationDate: moment.Moment;
    /** Fecha de vencimiento de la firma. */
    expirationDate: moment.Moment;
    id: number;

    constructor(data?: ISignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): SignatureDto {
        const json = this.toJSON();
        let result = new SignatureDto();
        result.init(json);
        return result;
    }
}

/** Entidad representando un certificado de firma. */
export interface ISignatureDto {
    /** Nombre/ruta del archivo de firma. */
    filename: string | undefined;
    /** Fecha de creación/carga en la plataforma
de la firma. */
    creationDate: moment.Moment;
    /** Fecha de vencimiento de la firma. */
    expirationDate: moment.Moment;
    id: number;
}

export class SignatureDtoPagedResultDto implements ISignatureDtoPagedResultDto {
    totalCount: number;
    items: SignatureDto[] | undefined;

    constructor(data?: ISignatureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SignatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignatureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SignatureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SignatureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISignatureDtoPagedResultDto {
    totalCount: number;
    items: SignatureDto[] | undefined;
}

/** <p>Members:</p><ul><li><i>0</i> = None</li><li><i>1</i> = SSL</li><li><i>2</i> = STARTTSL</li></ul> */
export enum SSLEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CCMailDto implements ICCMailDto {
    name: string;
    email: string;
    id: number;

    constructor(data?: ICCMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CCMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CCMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["id"] = this.id;
        return data; 
    }

    clone(): CCMailDto {
        const json = this.toJSON();
        let result = new CCMailDto();
        result.init(json);
        return result;
    }
}

export interface ICCMailDto {
    name: string;
    email: string;
    id: number;
}

export class SMTPServerDto implements ISMTPServerDto {
    /** Host correspondiente al servidor SMTP. */
    host: string | undefined;
    /** Puerto correspondiente al servidor SMTP. */
    port: number;
    /** Nombre de usuario correspondiente al servidor SMTP. */
    username: string | undefined;
    /** Contraseña correspondiente al servidor SMTP, la misma será posteriormente encriptada en la base de datos. */
    password: string | undefined;
    ssl: SSLEnum;
    /** Valor indicador del mail destino del servidor SMTP. */
    to: string | undefined;
    /** Lista de valores para el CC. */
    ccMails: CCMailDto[] | undefined;
    id: number;

    constructor(data?: ISMTPServerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.host = _data["host"];
            this.port = _data["port"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.ssl = _data["ssl"];
            this.to = _data["to"];
            if (Array.isArray(_data["ccMails"])) {
                this.ccMails = [] as any;
                for (let item of _data["ccMails"])
                    this.ccMails.push(CCMailDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SMTPServerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPServerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["host"] = this.host;
        data["port"] = this.port;
        data["username"] = this.username;
        data["password"] = this.password;
        data["ssl"] = this.ssl;
        data["to"] = this.to;
        if (Array.isArray(this.ccMails)) {
            data["ccMails"] = [];
            for (let item of this.ccMails)
                data["ccMails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): SMTPServerDto {
        const json = this.toJSON();
        let result = new SMTPServerDto();
        result.init(json);
        return result;
    }
}

export interface ISMTPServerDto {
    /** Host correspondiente al servidor SMTP. */
    host: string | undefined;
    /** Puerto correspondiente al servidor SMTP. */
    port: number;
    /** Nombre de usuario correspondiente al servidor SMTP. */
    username: string | undefined;
    /** Contraseña correspondiente al servidor SMTP, la misma será posteriormente encriptada en la base de datos. */
    password: string | undefined;
    ssl: SSLEnum;
    /** Valor indicador del mail destino del servidor SMTP. */
    to: string | undefined;
    /** Lista de valores para el CC. */
    ccMails: CCMailDto[] | undefined;
    id: number;
}

export class StockDocumentDto implements IStockDocumentDto {
    quantity: number;
    description: string | undefined;
    productId: number;
    product: ProductDto;
    creationTime: moment.Moment;
    tenantId: number;
    number: string | undefined;
    series: string | undefined;
    branchName: string | undefined;
    clientName: string | undefined;
    clientId: number | undefined;

    constructor(data?: IStockDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.number = _data["number"];
            this.series = _data["series"];
            this.branchName = _data["branchName"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): StockDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["number"] = this.number;
        data["series"] = this.series;
        data["branchName"] = this.branchName;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): StockDocumentDto {
        const json = this.toJSON();
        let result = new StockDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IStockDocumentDto {
    quantity: number;
    description: string | undefined;
    productId: number;
    product: ProductDto;
    creationTime: moment.Moment;
    tenantId: number;
    number: string | undefined;
    series: string | undefined;
    branchName: string | undefined;
    clientName: string | undefined;
    clientId: number | undefined;
}

export class StockDocumentDtoPagedResultDto implements IStockDocumentDtoPagedResultDto {
    totalCount: number;
    items: StockDocumentDto[] | undefined;

    constructor(data?: IStockDocumentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockDocumentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDocumentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StockDocumentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockDocumentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockDocumentDtoPagedResultDto {
    totalCount: number;
    items: StockDocumentDto[] | undefined;
}

export class StockDto implements IStockDto {
    quantity: number;
    description: string | undefined;
    productId: number;
    product: ProductDto;
    creationTime: moment.Moment;
    tenantId: number;
    id: number;

    constructor(data?: IStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): StockDto {
        const json = this.toJSON();
        let result = new StockDto();
        result.init(json);
        return result;
    }
}

export interface IStockDto {
    quantity: number;
    description: string | undefined;
    productId: number;
    product: ProductDto;
    creationTime: moment.Moment;
    tenantId: number;
    id: number;
}

export class StockDtoPagedResultDto implements IStockDtoPagedResultDto {
    totalCount: number;
    items: StockDto[] | undefined;

    constructor(data?: IStockDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StockDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockDtoPagedResultDto {
    totalCount: number;
    items: StockDto[] | undefined;
}

/** Resumen de datos de la empresa. */
export class SummaryDto implements ISummaryDto {
    /** Cantidad de usuarios registrados. */
    usersQuantity: number;
    /** Cantidad de documentos electrónicos enviados el último año. */
    edSentLastYearQuantity: number;
    /** Cantidad de documentos electrónicos enviados el último mes. */
    edSentLastMonthQuantity: number;
    /** Cantidad de documentos electrónicos enviados la última semana. */
    edSentLastWeekQuantity: number;
    /** Total facturado el último año. */
    totalInvoicedLastYear: number;
    /** Total facturado el último mes. */
    totalInvoicedLastMonth: number;
    /** Total facturado la último semana. */
    totalInvoicedLastWeek: number;
    /** Total cobrado. */
    totalCollected: number;
    /** Total por vencer. */
    totalDue: number;
    /** Total vencido. */
    totalOverdue: number;
    /** Cantidad de documentos electrónicos recibidos. */
    edReceivedQuantity: number;
    /** Cantidad de lotes de documentos electrónicos enviados. */
    edSentBulkQuantity: number;
    /** Cantidad de eventos enviados. */
    issuedEventsQuantity: number;
    /** Cantidad de eventos recibidos. */
    receivedEventsQuantity: number;
    /** Cantidad de clientes registrados. */
    customersQuantity: number;
    /** Cantidad de productos registrados. */
    productsQuantity: number;

    constructor(data?: ISummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersQuantity = _data["usersQuantity"];
            this.edSentLastYearQuantity = _data["edSentLastYearQuantity"];
            this.edSentLastMonthQuantity = _data["edSentLastMonthQuantity"];
            this.edSentLastWeekQuantity = _data["edSentLastWeekQuantity"];
            this.totalInvoicedLastYear = _data["totalInvoicedLastYear"];
            this.totalInvoicedLastMonth = _data["totalInvoicedLastMonth"];
            this.totalInvoicedLastWeek = _data["totalInvoicedLastWeek"];
            this.totalCollected = _data["totalCollected"];
            this.totalDue = _data["totalDue"];
            this.totalOverdue = _data["totalOverdue"];
            this.edReceivedQuantity = _data["edReceivedQuantity"];
            this.edSentBulkQuantity = _data["edSentBulkQuantity"];
            this.issuedEventsQuantity = _data["issuedEventsQuantity"];
            this.receivedEventsQuantity = _data["receivedEventsQuantity"];
            this.customersQuantity = _data["customersQuantity"];
            this.productsQuantity = _data["productsQuantity"];
        }
    }

    static fromJS(data: any): SummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersQuantity"] = this.usersQuantity;
        data["edSentLastYearQuantity"] = this.edSentLastYearQuantity;
        data["edSentLastMonthQuantity"] = this.edSentLastMonthQuantity;
        data["edSentLastWeekQuantity"] = this.edSentLastWeekQuantity;
        data["totalInvoicedLastYear"] = this.totalInvoicedLastYear;
        data["totalInvoicedLastMonth"] = this.totalInvoicedLastMonth;
        data["totalInvoicedLastWeek"] = this.totalInvoicedLastWeek;
        data["totalCollected"] = this.totalCollected;
        data["totalDue"] = this.totalDue;
        data["totalOverdue"] = this.totalOverdue;
        data["edReceivedQuantity"] = this.edReceivedQuantity;
        data["edSentBulkQuantity"] = this.edSentBulkQuantity;
        data["issuedEventsQuantity"] = this.issuedEventsQuantity;
        data["receivedEventsQuantity"] = this.receivedEventsQuantity;
        data["customersQuantity"] = this.customersQuantity;
        data["productsQuantity"] = this.productsQuantity;
        return data; 
    }

    clone(): SummaryDto {
        const json = this.toJSON();
        let result = new SummaryDto();
        result.init(json);
        return result;
    }
}

/** Resumen de datos de la empresa. */
export interface ISummaryDto {
    /** Cantidad de usuarios registrados. */
    usersQuantity: number;
    /** Cantidad de documentos electrónicos enviados el último año. */
    edSentLastYearQuantity: number;
    /** Cantidad de documentos electrónicos enviados el último mes. */
    edSentLastMonthQuantity: number;
    /** Cantidad de documentos electrónicos enviados la última semana. */
    edSentLastWeekQuantity: number;
    /** Total facturado el último año. */
    totalInvoicedLastYear: number;
    /** Total facturado el último mes. */
    totalInvoicedLastMonth: number;
    /** Total facturado la último semana. */
    totalInvoicedLastWeek: number;
    /** Total cobrado. */
    totalCollected: number;
    /** Total por vencer. */
    totalDue: number;
    /** Total vencido. */
    totalOverdue: number;
    /** Cantidad de documentos electrónicos recibidos. */
    edReceivedQuantity: number;
    /** Cantidad de lotes de documentos electrónicos enviados. */
    edSentBulkQuantity: number;
    /** Cantidad de eventos enviados. */
    issuedEventsQuantity: number;
    /** Cantidad de eventos recibidos. */
    receivedEventsQuantity: number;
    /** Cantidad de clientes registrados. */
    customersQuantity: number;
    /** Cantidad de productos registrados. */
    productsQuantity: number;
}

export class TaxTypeDtoPagedResultDto implements ITaxTypeDtoPagedResultDto {
    totalCount: number;
    items: TaxTypeDto[] | undefined;

    constructor(data?: ITaxTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TaxTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TaxTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TaxTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITaxTypeDtoPagedResultDto {
    totalCount: number;
    items: TaxTypeDto[] | undefined;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

/** Parámetro para la creación de una empresa "inquilina". */
export class CreateTenantDto implements ICreateTenantDto {
    /** Nombre interno de la empresa. */
    tenancyName: string;
    /** Nombre de la empresa. */
    name: string | undefined;
    /** Bandera indicando si se encuentra o no
activa. */
    isActive: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a la energía eléctrica. */
    deElectricPower: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los segudos. */
    deInsurance: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los supermercados. */
    deSupermarket: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a más información. */
    deInformation: boolean;
    /** RUC de la empresa. */
    ruc: string;
    /** Identificador interno del tipo de
contribuyente. */
    taxpayerType: number;
    /** Identificador interno del tipo
de régimen tributario. */
    regimeId: number | undefined;
    /** Dirección de la empresa. */
    address: string;
    /** Información complementaria de la
dirección de la empresa. */
    addressComplement1: string | undefined;
    /** Segunda información complementaria de la
dirección de la empresa. */
    addressComplement2: string | undefined;
    /** Número de casa de la empresa. */
    houseNumber: number;
    /** Código SIFEN identificador de la ciudad. */
    cityCode: number | undefined;
    /** Teléfono de la empresa. */
    phone: string | undefined;
    /** Correo electrónico de la empresa. */
    email: string;
    /** Número de timbrado (brindado por SIFEN). */
    stampNumber: string;
    /** Fecha de timbrado (brindado por SIFEN). */
    stampDate: moment.Moment;
    /** Establecimiento (brindado por SIFEN). */
    stablishment: string;
    /** Punto de expedición (brindado por SIFEN). */
    expeditionPoint: string;
    /** Actividades económicas que posee la
empresa. */
    activities: TenantActivityDto[] | undefined;
    /** Identificador correspondiente al CSC del Tenant. */
    idCSC: string;
    /** CSC del Tenant. */
    csc: string;
    /** Bandera indicando si se envían correos de las facturas emitadas a los clientes */
    sendInvoicesCustomersViaEmail: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.deElectricPower = _data["deElectricPower"];
            this.deInsurance = _data["deInsurance"];
            this.deSupermarket = _data["deSupermarket"];
            this.deInformation = _data["deInformation"];
            this.ruc = _data["ruc"];
            this.taxpayerType = _data["taxpayerType"];
            this.regimeId = _data["regimeId"];
            this.address = _data["address"];
            this.addressComplement1 = _data["addressComplement1"];
            this.addressComplement2 = _data["addressComplement2"];
            this.houseNumber = _data["houseNumber"];
            this.cityCode = _data["cityCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.stampNumber = _data["stampNumber"];
            this.stampDate = _data["stampDate"] ? moment(_data["stampDate"].toString()) : <any>undefined;
            this.stablishment = _data["stablishment"];
            this.expeditionPoint = _data["expeditionPoint"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(TenantActivityDto.fromJS(item));
            }
            this.idCSC = _data["idCSC"];
            this.csc = _data["csc"];
            this.sendInvoicesCustomersViaEmail = _data["sendInvoicesCustomersViaEmail"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["deElectricPower"] = this.deElectricPower;
        data["deInsurance"] = this.deInsurance;
        data["deSupermarket"] = this.deSupermarket;
        data["deInformation"] = this.deInformation;
        data["ruc"] = this.ruc;
        data["taxpayerType"] = this.taxpayerType;
        data["regimeId"] = this.regimeId;
        data["address"] = this.address;
        data["addressComplement1"] = this.addressComplement1;
        data["addressComplement2"] = this.addressComplement2;
        data["houseNumber"] = this.houseNumber;
        data["cityCode"] = this.cityCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["stampNumber"] = this.stampNumber;
        data["stampDate"] = this.stampDate ? this.stampDate.toISOString() : <any>undefined;
        data["stablishment"] = this.stablishment;
        data["expeditionPoint"] = this.expeditionPoint;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["idCSC"] = this.idCSC;
        data["csc"] = this.csc;
        data["sendInvoicesCustomersViaEmail"] = this.sendInvoicesCustomersViaEmail;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

/** Parámetro para la creación de una empresa "inquilina". */
export interface ICreateTenantDto {
    /** Nombre interno de la empresa. */
    tenancyName: string;
    /** Nombre de la empresa. */
    name: string | undefined;
    /** Bandera indicando si se encuentra o no
activa. */
    isActive: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a la energía eléctrica. */
    deElectricPower: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los segudos. */
    deInsurance: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a los supermercados. */
    deSupermarket: boolean;
    /** Bandera indicando si tiene activada
la sección en la emisión de documentos
electrónicos, correspondiente a más información. */
    deInformation: boolean;
    /** RUC de la empresa. */
    ruc: string;
    /** Identificador interno del tipo de
contribuyente. */
    taxpayerType: number;
    /** Identificador interno del tipo
de régimen tributario. */
    regimeId: number | undefined;
    /** Dirección de la empresa. */
    address: string;
    /** Información complementaria de la
dirección de la empresa. */
    addressComplement1: string | undefined;
    /** Segunda información complementaria de la
dirección de la empresa. */
    addressComplement2: string | undefined;
    /** Número de casa de la empresa. */
    houseNumber: number;
    /** Código SIFEN identificador de la ciudad. */
    cityCode: number | undefined;
    /** Teléfono de la empresa. */
    phone: string | undefined;
    /** Correo electrónico de la empresa. */
    email: string;
    /** Número de timbrado (brindado por SIFEN). */
    stampNumber: string;
    /** Fecha de timbrado (brindado por SIFEN). */
    stampDate: moment.Moment;
    /** Establecimiento (brindado por SIFEN). */
    stablishment: string;
    /** Punto de expedición (brindado por SIFEN). */
    expeditionPoint: string;
    /** Actividades económicas que posee la
empresa. */
    activities: TenantActivityDto[] | undefined;
    /** Identificador correspondiente al CSC del Tenant. */
    idCSC: string;
    /** CSC del Tenant. */
    csc: string;
    /** Bandera indicando si se envían correos de las facturas emitadas a los clientes */
    sendInvoicesCustomersViaEmail: boolean;
}

export class Int32EntityDto implements IInt32EntityDto {
    id: number;

    constructor(data?: IInt32EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int32EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): Int32EntityDto {
        const json = this.toJSON();
        let result = new Int32EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt32EntityDto {
    id: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    ruc: string | undefined;
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruc = _data["ruc"];
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruc"] = this.ruc;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    ruc: string | undefined;
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class RecoverPasswordModel implements IRecoverPasswordModel {
    ruc: string | undefined;
    userNameOrEmailAddress: string;

    constructor(data?: IRecoverPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruc = _data["ruc"];
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
        }
    }

    static fromJS(data: any): RecoverPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecoverPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruc"] = this.ruc;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        return data; 
    }

    clone(): RecoverPasswordModel {
        const json = this.toJSON();
        let result = new RecoverPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IRecoverPasswordModel {
    ruc: string | undefined;
    userNameOrEmailAddress: string;
}

export class RecoverPasswordResultModel implements IRecoverPasswordResultModel {
    statusResult: boolean;
    message: string | undefined;

    constructor(data?: IRecoverPasswordResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusResult = _data["statusResult"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RecoverPasswordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecoverPasswordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusResult"] = this.statusResult;
        data["message"] = this.message;
        return data; 
    }

    clone(): RecoverPasswordResultModel {
        const json = this.toJSON();
        let result = new RecoverPasswordResultModel();
        result.init(json);
        return result;
    }
}

export interface IRecoverPasswordResultModel {
    statusResult: boolean;
    message: string | undefined;
}

export class TransactionTypeDtoPagedResultDto implements ITransactionTypeDtoPagedResultDto {
    totalCount: number;
    items: TransactionTypeDto[] | undefined;

    constructor(data?: ITransactionTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TransactionTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionTypeDtoPagedResultDto {
    totalCount: number;
    items: TransactionTypeDto[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    identityDocumentTypeCode: number | undefined;
    identityDocumentNumber: string | undefined;
    position: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.identityDocumentTypeCode = _data["identityDocumentTypeCode"];
            this.identityDocumentNumber = _data["identityDocumentNumber"];
            this.position = _data["position"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["identityDocumentTypeCode"] = this.identityDocumentTypeCode;
        data["identityDocumentNumber"] = this.identityDocumentNumber;
        data["position"] = this.position;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    identityDocumentTypeCode: number | undefined;
    identityDocumentNumber: string | undefined;
    position: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string | undefined;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export class UserBranchDto implements IUserBranchDto {
    /** Id del usuario. */
    userId: number;
    /** Id de la sucursal a la que tiene acceso el empleado. */
    branchId: number;
    /** Empresa del usuario. */
    tenantId: number;
    user: UserDto;
    branch: BranchDto;
    tenant: TenantDto;
    id: number;

    constructor(data?: IUserBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.branchId = _data["branchId"];
            this.tenantId = _data["tenantId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["branchId"] = this.branchId;
        data["tenantId"] = this.tenantId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserBranchDto {
        const json = this.toJSON();
        let result = new UserBranchDto();
        result.init(json);
        return result;
    }
}

export interface IUserBranchDto {
    /** Id del usuario. */
    userId: number;
    /** Id de la sucursal a la que tiene acceso el empleado. */
    branchId: number;
    /** Empresa del usuario. */
    tenantId: number;
    user: UserDto;
    branch: BranchDto;
    tenant: TenantDto;
    id: number;
}

export class CreateUserBranchDto implements ICreateUserBranchDto {
    tenantId: number;
    userId: number;
    selectedBranches: BranchDto[] | undefined;

    constructor(data?: ICreateUserBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["selectedBranches"])) {
                this.selectedBranches = [] as any;
                for (let item of _data["selectedBranches"])
                    this.selectedBranches.push(BranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUserBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        if (Array.isArray(this.selectedBranches)) {
            data["selectedBranches"] = [];
            for (let item of this.selectedBranches)
                data["selectedBranches"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateUserBranchDto {
        const json = this.toJSON();
        let result = new CreateUserBranchDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserBranchDto {
    tenantId: number;
    userId: number;
    selectedBranches: BranchDto[] | undefined;
}

/** <p>Members:</p><ul><li><i>1</i> = Documento electrónico</li></ul> */
export enum SubscriptionType {
    _1 = 1,
}

export class WebhookSubscriptionDto implements IWebhookSubscriptionDto {
    uri: string | undefined;
    subscriptionType: SubscriptionType;
    id: string;

    constructor(data?: IWebhookSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.subscriptionType = _data["subscriptionType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["subscriptionType"] = this.subscriptionType;
        data["id"] = this.id;
        return data; 
    }

    clone(): WebhookSubscriptionDto {
        const json = this.toJSON();
        let result = new WebhookSubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface IWebhookSubscriptionDto {
    uri: string | undefined;
    subscriptionType: SubscriptionType;
    id: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}